<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t(isTaxScope ? 'taxChatLogTitle' : '_ChatLogs') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-title class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3" size="28">mdi-chart-line</v-icon>
            <h3 class="text-h5 font-weight-bold text-primary">Log Management</h3>
          </div>
        </v-card-title>

        <v-card-text class="pa-4">
          <!-- Date Range Section -->
          <v-row class="mb-3">
            <v-col cols="12">
              <v-card variant="outlined" class="filter-card">
                <v-card-text class="pa-3">
                  <h4 class="section-title mb-2">
                    <v-icon class="mr-2" color="primary" size="20">mdi-calendar-range</v-icon>
                    {{ $t('dateRange') }}
                  </h4>
                  <v-row class="mt-1">
                    <v-col cols="12" md="6">
                      <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            v-model="startDate"
                            label="Start Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="date-field"
                            clearable
                          >
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>Select start date for filtering</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startDate"
                          
                          :max="startDateMax"
                          @update:model-value="
                            (val) => {
                              startDate = formatDate(val);
                              startDateFlag = false;
                            }
                          "
                          color="primary"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            v-model="endDate"
                            label="End Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                            class="date-field"
                            clearable
                          >
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>Select end date for filtering</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          :min="endDateMin"
                          :max="endDateMax"
                          @update:model-value="
                            (val) => {
                              endDate = formatDate(val);
                              endDateFlag = false;
                            }
                          "
                          color="primary"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- Advanced Filters Panel -->
          <v-expansion-panels variant="accordion" class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-title @click="filterClick" class="filter-panel-title">
                <div class="d-flex align-center">
                  <v-icon class="mr-2" color="primary">mdi-filter-cog</v-icon>
                  <span class="font-weight-medium">{{ $t('AdvancedFilters') }}</span>
                  <v-chip v-if="activeFilterCount > 0" size="x-small" color="primary" class="ml-2" variant="flat">{{ activeFilterCount }}</v-chip>
                </div>
                <template #actions="{ expanded }">
                  <v-icon :icon="expanded ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-icon>
                </template>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="advanced-filters-wrapper">
                  <!-- Row 1: Identity & Type Filters -->
                  <div class="filter-section">
                    <div class="filter-section-label">
                      <v-icon size="14" color="grey-darken-1" class="mr-1">mdi-key-variant</v-icon>
                      <span>Identity</span>
                    </div>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          :label="isTaxScope ? 'CIF No' : 'User Channel'"
                          :placeholder="isTaxScope ? 'CIF เต็มค่า หรือค่าเข้ารหัสที่แสดงในตาราง (ค้นบางส่วนไม่ได้)' : undefined"
                          v-model="userChannel"
                          clearable
                          variant="outlined"
                          density="compact"
                          prepend-inner-icon="mdi-account"
                          color="primary"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field label="Session ID" v-model="sessionID" clearable variant="outlined" density="compact" prepend-inner-icon="mdi-identifier" color="primary" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field label="Log ID" v-model="logID" clearable variant="outlined" density="compact" prepend-inner-icon="mdi-clipboard-text-outline" color="primary" hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-select
                          v-model="responseType"
                          :items="responseTypeOptions"
                          item-title="title"
                          item-value="value"
                          label="Response Type"
                          clearable
                          variant="outlined"
                          density="compact"
                          prepend-inner-icon="mdi-swap-horizontal"
                          color="primary"
                          hide-details
                        >
                          <template #item="{ item, props }">
                            <v-list-item v-bind="props">
                              <template #prepend>
                                <v-icon :color="item.raw.color" size="20">{{ item.raw.icon }}</v-icon>
                              </template>
                            </v-list-item>
                          </template>
                          <template #selection="{ item }">
                            <div class="d-flex align-center">
                              <v-icon :color="item.raw.color" size="16" class="mr-1">{{ item.raw.icon }}</v-icon>
                              <span>{{ item.raw.title }}</span>
                            </div>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Row 2: Message Filters -->
                  <div class="filter-section">
                    <div class="filter-section-label">
                      <v-icon size="14" color="grey-darken-1" class="mr-1">mdi-message-text-outline</v-icon>
                      <span>Messages</span>
                    </div>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field label="Input Message" v-model="inputMessage" clearable variant="outlined" density="compact" prepend-inner-icon="mdi-message-arrow-right-outline" color="primary" hide-details placeholder="Search in input..."></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field label="Output Message" v-model="outputMessage" clearable variant="outlined" density="compact" prepend-inner-icon="mdi-message-arrow-left-outline" color="primary" hide-details placeholder="Search in output..."></v-text-field>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Row 3: Range Filters -->
                  <div class="filter-section">
                    <div class="filter-section-label">
                      <v-icon size="14" color="grey-darken-1" class="mr-1">mdi-tune-vertical</v-icon>
                      <span>Ranges</span>
                    </div>
                    <v-row dense>
                      <!-- Response Time Range -->
                      <v-col cols="12" md="6">
                        <v-sheet rounded="lg" class="range-filter-group pa-3">
                          <div class="range-filter-label mb-2">
                            <v-icon size="16" color="#ef6c00" class="mr-1">mdi-timer-sand</v-icon>
                            <span>Response Time (sec)</span>
                          </div>
                          <div class="d-flex align-center ga-2">
                            <v-text-field v-model.number="responseTimeMin" type="number" variant="outlined" density="compact" placeholder="Min" hide-details min="0" step="0.1" class="range-input"></v-text-field>
                            <span class="range-divider">—</span>
                            <v-text-field v-model.number="responseTimeMax" type="number" variant="outlined" density="compact" placeholder="Max" hide-details min="0" step="0.1" class="range-input"></v-text-field>
                          </div>
                        </v-sheet>
                      </v-col>
                      <!-- Token Range -->
                      <v-col cols="12" md="6">
                        <v-sheet rounded="lg" class="range-filter-group pa-3">
                          <div class="range-filter-label mb-2">
                            <v-icon size="16" color="#7b1fa2" class="mr-1">mdi-circle-multiple-outline</v-icon>
                            <span>Tokens</span>
                          </div>
                          <div class="d-flex align-center ga-2">
                            <v-text-field v-model.number="tokenMin" type="number" variant="outlined" density="compact" placeholder="Min" hide-details min="0" step="1" class="range-input"></v-text-field>
                            <span class="range-divider">—</span>
                            <v-text-field v-model.number="tokenMax" type="number" variant="outlined" density="compact" placeholder="Max" hide-details min="0" step="1" class="range-input"></v-text-field>
                          </div>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Clear All -->
                  <div class="d-flex justify-end mt-2">
                    <v-btn color="warning" variant="text" size="small" prepend-icon="mdi-filter-remove-outline" @click="clearAllFilters">
                      {{ $t('ClearFilters') }}
                    </v-btn>
                  </div>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Action Buttons Row -->
          <v-row class="mb-4">
            <v-col cols="12">
              <v-card variant="outlined" class="action-card">
                <v-card-text class="pa-4">
                  <div class="d-flex justify-space-between align-center flex-wrap ga-3">
                    <!-- Left Side - Search Button -->
                    <div class="action-group">
                      <v-btn color="primary" variant="elevated" size="large" @click="Search" class="search-btn" prepend-icon="mdi-magnify">
                        {{ $t('search') }}
                      </v-btn>
                    </div>


                    <!-- Right Side - Download and Toggle -->
                    <div class="action-group d-flex align-center ga-3">
                      <!-- Download Menu -->
                      <v-menu location="bottom">
                        <template #activator="{ props }">
                          <v-btn color="success" variant="elevated" v-bind="props" prepend-icon="mdi-download" class="download-btn">
                            {{ $t('Download') }}
                          </v-btn>
                        </template>
                        <v-list class="download-menu">
                          <v-list-item @click="GetExportLog()" prepend-icon="mdi-file-excel">
                            <v-list-item-title>Export Log Message</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="GetExportLog(true)" prepend-icon="mdi-file-excel-outline">
                            <v-list-item-title>Export Log Message (extra)</v-list-item-title>
                          </v-list-item>
                          <!-- <v-list-item @click="GetExportLogMonitoring()" prepend-icon="mdi-monitor">
                            <v-list-item-title>Export Log Monitoring</v-list-item-title>
                          </v-list-item> -->
                          <v-list-item
                            @click="
                              dialogExportQS = true;
                              GetDDValidationPositive();
                            "
                            prepend-icon="mdi-help-circle"
                          >
                            <v-list-item-title>Export to Question Set</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>

                      <!-- Show All Text Toggle -->
                      <v-card variant="outlined" class="toggle-card">
                        <v-card-text class="pa-3">
                          <v-switch
                            v-model="CheckboxShowAllText"
                            :label="`${$t('_ShowAllText')}: ${CheckboxShowAllText ? $t('_ShowAllTextOn') : $t('_ShowAllTextOff')}`"
                            color="primary"
                            hide-details
                            density="compact"
                            inset
                          ></v-switch>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Data Table with Modern Styling -->
          <v-card class="data-table-card">
            <div class="table-container">
              <v-data-table-server
                v-model:options="options"
                v-model:page="options.page"
                :items-per-page="options.itemsPerPage"
                :items-length="searchTotalTable"
                :items="dataTable"
                :headers="headers"
                :items-per-page-options="[10, 25, 50, 100]"
                :loading="tableLoading"
                class="modern-table"
                density="comfortable"
                hover
              >
                <template #top>
                  <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
                    <v-toolbar-title class="text-h6 font-weight-medium">
                      <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                      Log Data ({{ searchTotalTable }} records)
                    </v-toolbar-title>
                  </v-toolbar>
                </template>

                <template #item="{ item }">
                  <tr class="table-row">
                    <td>
                      <div class="d-flex align-center justify-center">
                        <!-- Response Type Icon -->
                        <v-tooltip location="top">
                          <template #activator="{ props }">
                            <v-icon
                              v-if="item.isVoiceStreaming === null"
                              v-bind="props"
                              size="18"
                              color="#2196F3"
                              class="mr-2"
                            >
                              mdi-message-text
                            </v-icon>
                            <v-icon
                              v-else-if="item.isVoiceStreaming === false"
                              v-bind="props"
                              size="18"
                              color="#4CAF50"
                              class="mr-2"
                            >
                              mdi-account-voice
                            </v-icon>
                            <v-icon
                              v-else-if="item.isVoiceStreaming === true"
                              v-bind="props"
                              size="18"
                              color="#FF9800"
                              class="mr-2"
                            >
                              mdi-broadcast
                            </v-icon>
                          </template>
                          <span v-if="item.isVoiceStreaming === null">Text Response</span>
                          <span v-else-if="item.isVoiceStreaming === false">Voice Response</span>
                          <span v-else-if="item.isVoiceStreaming === true">Voice Streaming</span>
                        </v-tooltip>
                        
                        <!-- Contact Agent Icon -->
                        <v-tooltip location="top" v-if="item.intentCategory === '1-ContactAgent'">
                          <template #activator="{ props }">
                            <v-icon
                              v-bind="props"
                              size="18"
                              color="#E91E63"
                              class="mr-2"
                            >
                              mdi-headset
                            </v-icon>
                          </template>
                          <span>Contact Agent Request</span>
                        </v-tooltip>

                        {{ substringLong(item.id) }}
                      </div>
                    </td>
                    <td class="text-container-new">{{ item.createDate ?? '-' }}</td>
                    <td>
                      <div class="text-container">
                        <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="substringLong(item.text)"></span>
                      </div>
                    </td>
                    <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="substringLong(item.replymsg)"></span>
                          <v-btn @click="item.show = !item.show" size="small" variant="text" :icon="item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-btn>
                        </div>
                      </td>
                    <td class="text-center">
                      <v-btn size="x-small" variant="text" color="primary" icon="mdi-chart-timeline-variant" @click="openFlowDialog(item)" :disabled="item.chatWorkFlow == null" class="flow-btn">
                        <v-icon size="18">mdi-chart-timeline-variant</v-icon>
                        <v-tooltip activator="parent" location="top">View Flow</v-tooltip>
                      </v-btn>
                    </td>
                    <td style="white-space: pre-wrap;">{{ item.intent || '-' }}</td>
                    <!-- <td>
                      <v-chip size="small" :color="item.userChannel ? 'primary' : 'grey'" variant="outlined">
                        {{ item.userChannel ?? '-' }}
                      </v-chip>
                    </td> -->
                    <td >
                      <!-- {{ item.createBy ?? '-' }} -->
                      <!-- tax scope: createBy มาเป็น ciphertext จาก API จึงต้องคัดลอกทั้งค่า ไม่ตัดสั้นแบบ chip
                           (หน้านี้ไม่ถอด CIF — ถอดได้ที่หน้า Tax CIF Encrypt / Decrypt) -->
                      <CopyId v-if="isTaxScope" :value="item.createBy === '-' ? '' : item.createBy" label="CIF" truncate />
                      <!-- [#889] Chat Logs: API ถอด CIF ของแถวแอป LHB ให้แล้ว (Export Excel ด้วย) · LINE/portal แสดงตามเดิม -->
                      <v-chip v-else size="small" variant="outlined">{{ substringLong(item.createBy) }}</v-chip>
                    </td>
                    <td class="text-center">
                      <v-chip size="small" color="success" variant="outlined">{{ formatResponseTimeString(item.responseTimeStr) }}</v-chip>
                    </td>
                    <td>
                      <div class="text-container">
                        <v-chip size="small" variant="outlined">{{ substringLong(item.sessionID) }}</v-chip>
                      </div>
                    </td>
                    <td class=" align-center">
                      <v-chip size="small" variant="outlined">{{ substringLong(item.total_tokens) }}</v-chip>
                    </td>
                    <!-- 
                      <td class="text-center">
                        {{ item.number }}
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="substringLong(item.prompt)"></span>
                          <v-btn @click="item.show = !item.show" size="small" variant="text" :icon="item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'" color="primary"></v-btn>
                        </div>
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="substringLong(item.vectorContext)"></span>
                        </div>
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="substringLong(item.modelDisplay)"></span>
                        </div>
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']" v-html="substringLong(item.modelName)"></span>
                        </div>
                      </td> -->
                  </tr>
                </template>
              </v-data-table-server>
            </div>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Flow Dialog - Horizontal Layout -->
    <v-dialog v-model="dialogFlow" max-width="1400" scrollable transition="dialog-bottom-transition" :scrim="true" @close="expandedStep = null">
      <v-card class="flow-dialog-card">
        <v-card-title class="flow-dialog-header pa-0">
          <div class="flow-header-content">
            <div class="d-flex align-center">
              <div class="flow-icon-wrapper">
                <v-icon class="flow-icon">mdi-chart-timeline-variant-shimmer</v-icon>
              </div>
              <div>
                <div class="flow-title">Flow Visualization</div>
                <div class="flow-subtitle">Step-by-step execution tracking</div>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              icon
              variant="text"
              class="close-btn"
              @click="
                dialogFlow = false;
                expandedStep = null;
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="flow-dialog-content pa-0">
          <div v-if="flowSteps && flowSteps.length > 0" class="horizontal-flow-container">
            <!-- Flow Steps in Horizontal Layout -->
            <div class="horizontal-flow-steps" :class="{ 'has-overflow': flowHasOverflow }" style="overflow-x: auto; overflow-y: hidden; padding-bottom: 20px">
              <div v-for="(group, groupIndex) in groupedFlowSteps" :key="group.stepId" class="horizontal-step-wrapper">
                <!-- Container for parallel steps (vertical layout if multiple) -->
                <div class="step-group-container" :class="{ 'parallel-steps': group.isParallel }">
                  <div v-for="(step, stepIndex) in group.steps" :key="`${step.stepId}-${step.node}-${stepIndex}`" class="step-item" :class="{ 'parallel-item': group.isParallel }">
                    <!-- Checkpoint Style for Input/Output -->
                    <div
                      v-if="step.node === 'messageInput' || step.node === 'response'"
                      class="checkpoint-node"
                      :class="[getStepStatusClass(step.status), { active: isStepSelected(step) }]"
                      :data-node-type="step.node"
                      @click="toggleStepDetails(step)"
                    >
                      <!-- Selection Indicator -->
                      <div v-if="isStepSelected(step)" class="selection-indicator">
                        <v-icon size="12" color="white">mdi-check-circle</v-icon>
                      </div>

                      <!-- Checkpoint Icon -->
                      <div class="checkpoint-icon" :style="{ backgroundColor: getNodeTypeColor(step.node) }">
                        <v-icon color="white" size="16">{{ getNodeIcon(step.node) }}</v-icon>
                      </div>

                      <!-- Checkpoint Label -->
                      <div class="checkpoint-label">
                        {{ getStepDisplayName(step) }}
                      </div>

                      <!-- Checkpoint Time Info -->
                      <div class="checkpoint-time-info">
                        <div class="checkpoint-time">
                          {{ formatTime(step.node === 'messageInput' ? step.startTime : step.endTime) }}
                        </div>
                        <!-- Time To First Byte for response node (time from first module start to first char) -->
                        <div
                          v-if="step.node === 'response' && getTimeToFirstByte(step) && hasAnyFirstResponseTime()"
                          class="checkpoint-duration"
                          :style="{
                            backgroundColor: '#2196F3',
                            color: 'white',
                            fontWeight: '700',
                            marginTop: '4px',
                          }"
                        >
                          {{ formatResponseTime(getTimeToFirstByte(step)) }}
                        </div>
                        <div
                          v-if="calculateResponseTime(step)"
                          class="checkpoint-duration"
                          :style="{
                            backgroundColor: getResponseTimeColor(calculateResponseTime(step)),
                            color: 'white',
                            fontWeight: '700',
                          }"
                        >
                        {{ formatResponseTime(calculateResponseTime(step)) }}
                        </div>
                      </div>
                    </div>

                    <!-- Card Style for Intent/Model/InterestOptimizer and new nodes -->
                    <div
                      v-else-if="
                        step.node === 'intent' ||
                        step.node === 'model' ||
                        step.node === 'cache' ||
                        step.node === 'interestOptimizer' ||
                        step.node === 'apiknowledge' ||
                        step.node === 'databaseIntegration' ||
                        step.node === 'reformatForTTS' ||
                        step.node === 'formatForTTSEngine' ||
                        step.node === 'apiTrigger' ||
                        step.node === 'contactAgent' ||
                        step.node === 'contactAgentV2' ||
                        step.node === 'loanInterest' ||
                        step.node === 'interestOptimizerV2' ||
                        step.node === 'loanInterestV2' ||
                        step.node === 'documents' ||
                        step.node === 'community' ||
                        step.node === 'community+documents' ||
                        step.node === 'embedding' ||
                        step.node === 'summaryMemory' ||
                        step.node === 'smartIntent' ||
                        step.node === 'router' ||
                        step.node === 'advancedRouter' ||
                        step.node === 'dynamicRouter' ||
                        step.node === 'queryRewriter' ||
                        step.node === 'orchestrator' ||
                        step.node === 'guardrail' ||
                        step.node === 'agent-tool' ||
                        step.node === 'agent' ||
                        step.node === 'agent-aimodel' ||
                        step.node === 'serviceFallback' ||
                        step.node === 'jsonCondition' ||
                        step.node === 'apiRequest' ||
                        step.node === 'favoriteMatcher' ||
                        step.node === 'serviceMatcher' ||
                        step.node === 'serviceMatcher-api' ||
                        step.node === 'serviceMatcher-favorite' ||
                        step.node === 'llmEnrich' ||
                        step.node === 'buttonStyle' ||
                        step.node === 'mutualFund' ||
                        step.node === 'taxPlanning' ||
                        step.node === 'taxPlanningV2' ||
                        step.node === 'taxPlanningAgent' ||
                        step.node === 'taxStateRead'
                      "
                      class="flow-card-node"
                      :class="[getStepStatusClass(step.status), { active: isStepSelected(step) }]"
                      :data-node-type="step.node"
                      @click="toggleStepDetails(step)"
                    >
                      <!-- Action Type Badge -->
                      <div v-if="group.isParallel" class="action-type-badge" :class="{ 'main-action': step.next && step.next.length > 0, 'parallel-action': !step.next || step.next.length === 0 }">
                        <v-icon v-if="step.next && step.next.length > 0" size="8">mdi-arrow-right-bold</v-icon>
                        <v-icon v-else size="8">mdi-arrow-split-vertical</v-icon>
                        <span>{{ step.next && step.next.length > 0 ? 'Main' : 'Parallel' }}</span>
                      </div>

                      <!-- Sync Process Badge -->
                      <div v-if="step.output && step.output.inSyncProcess === true" class="sync-process-badge">
                        <v-icon size="8" color="white">mdi-sync</v-icon>
                        <span>Sync</span>
                      </div>

                      <!-- Selection Indicator -->
                      <div v-if="isStepSelected(step)" class="card-selection-indicator">
                        <v-icon size="16" color="white">mdi-check-circle</v-icon>
                        <span class="selection-text">Selected</span>
                      </div>

                      <!-- Card Header -->
                      <div class="card-header-section">
                        <div class="card-header">
                          <div class="card-icon" :style="{ background: getNodeIconGradient(step.node) }">
                            <v-icon color="white" size="20">{{ getNodeIcon(step.node) }}</v-icon>
                          </div>
                          <div class="card-info">
                            <div class="card-title">{{ getStepDisplayName(step) }}</div>
                            <div v-if="step.node === 'intent' || step.node === 'smartIntent'" class="card-subtitle">"{{ step.output.message }}"</div>
                          </div>
                        </div>
                      </div>

                      <!-- Card Time Info -->
                      <div class="card-time-info">
                        <div class="card-time">
                          <v-icon size="10" class="mr-1">mdi-clock-outline</v-icon>
                          {{ formatTime(step.startTime) }}
                        </div>
                        <v-tooltip location="bottom" :disabled="!step.output?.processBreakdown">
                          <template v-slot:activator="{ props }">
                            <div
                              v-if="calculateResponseTime(step)"
                              class="card-duration"
                              v-bind="props"
                              :style="{
                                backgroundColor: getResponseTimeColor(calculateResponseTime(step)),
                                color: 'white',
                              }"
                            >
                              <v-icon size="10" class="mr-1" color="white">mdi-timer-outline</v-icon>
                              {{ formatResponseTime(calculateResponseTime(step)) }}
                            </div>
                          </template>
                          <div class="timing-breakdown">
                            <div class="breakdown-title">Duration Breakdown:</div>
                            <template v-if="step.output?.processBreakdown">
                              <div v-for="(duration, phase) in getProcessBreakdown(step)" :key="phase" class="breakdown-item">
                                <span class="breakdown-label">{{ formatPhaseName(phase) }}:</span>
                                <span class="breakdown-value">{{ formatResponseTimeAdaptive(duration) }}</span>
                              </div>
                            </template>
                          </div>
                        </v-tooltip>
                        <!-- Output Time for node before response (node start → first char) -->
                        <div
                          v-if="getOutputResponseTime(step) !== null && getOutputResponseTime(step) < 600000 && hasAnyFirstResponseTime()"
                          class="card-duration card-duration-flex"
                          :style="{
                            backgroundColor: '#2196F3',
                            color: 'white',
                          }"
                        >
                          <v-icon size="10" class="mr-1" color="white">mdi-lightning-bolt</v-icon>
                          {{ formatResponseTime(getOutputResponseTime(step)) }}
                        </div>
                      </div>
                    </div>

                    <!-- Regular Node Style for Other Processing Steps -->
                    <div v-else class="flow-node" :class="[getStepStatusClass(step.status), { active: isStepSelected(step) }]" :data-node-type="step.node" @click="toggleStepDetails(step)">
                      <!-- Action Type Badge -->
                      <div
                        v-if="group.isParallel"
                        class="action-type-badge-node"
                        :class="{ 'main-action': step.next && step.next.length > 0, 'parallel-action': !step.next || step.next.length === 0 }"
                      >
                        <v-icon v-if="step.next && step.next.length > 0" size="7">mdi-arrow-right-bold</v-icon>
                        <v-icon v-else size="7">mdi-arrow-split-vertical</v-icon>
                        <span>{{ step.next && step.next.length > 0 ? 'Main' : 'Parallel' }}</span>
                      </div>

                      <!-- Sync Process Badge -->
                      <div v-if="step.output && step.output.inSyncProcess === true" class="sync-process-badge-node">
                        <v-icon size="7" color="white">mdi-sync</v-icon>
                        <span>Sync</span>
                      </div>

                      <!-- Selection Indicator -->
                      <div v-if="isStepSelected(step)" class="node-selection-indicator">
                        <v-icon size="14" color="white">mdi-check-circle</v-icon>
                      </div>

                      <!-- Node Header -->
                      <div class="node-header">
                        <div class="node-icon" :style="{ backgroundColor: getNodeTypeColor(step.node) }">
                          <v-icon color="white" size="20">{{ getNodeIcon(step.node) }}</v-icon>
                        </div>
                        <div class="node-info">
                          <div class="node-title">{{ getStepDisplayName(step) }}</div>
                        </div>
                      </div>

                      <!-- Node Time Info -->
                      <div class="node-time-info">
                        <div class="node-time">
                          <v-icon size="12" class="mr-1">mdi-clock-outline</v-icon>
                          {{ formatTime(step.startTime) }}
                        </div>
                        <v-tooltip location="bottom" :disabled="!step.output?.processBreakdown">
                          <template v-slot:activator="{ props }">
                            <div
                              v-if="calculateResponseTime(step)"
                              class="node-duration"
                              v-bind="props"
                              :style="{
                                backgroundColor: getResponseTimeColor(calculateResponseTime(step)),
                                color: 'white',
                              }"
                            >
                              <v-icon size="12" class="mr-1" color="white">mdi-timer-outline</v-icon>
                              {{ formatResponseTime(calculateResponseTime(step)) }}
                            </div>
                          </template>
                          <div class="timing-breakdown">
                            <div class="breakdown-title">Duration Breakdown:</div>
                            <template v-if="step.output?.processBreakdown">
                              <div v-for="(duration, phase) in getProcessBreakdown(step)" :key="phase" class="breakdown-item">
                                <span class="breakdown-label">{{ formatPhaseName(phase) }}:</span>
                                <span class="breakdown-value">{{ formatResponseTimeAdaptive(duration) }}</span>
                              </div>
                            </template>
                          </div>
                        </v-tooltip>
                        <!-- Output Time for node before response (node start → first char) -->
                        <div
                          v-if="getOutputResponseTime(step) !== null && getOutputResponseTime(step) < 600000 && hasAnyFirstResponseTime()"
                          class="node-duration"
                          :style="{
                            backgroundColor: '#2196F3',
                            color: 'white',
                            marginTop: '4px',
                          }"
                        >
                          <v-icon size="12" class="mr-1" color="white">mdi-lightning-bolt</v-icon>
                          {{ formatResponseTime(getOutputResponseTime(step)) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Connection Arrow -->
                <div v-if="groupIndex < groupedFlowSteps.length - 1" class="horizontal-arrow">
                  <div class="arrow-with-time">
                    <!-- Show bidirectional arrow if both current and next groups have inSyncProcess -->
                    <v-icon 
                      v-if="isGroupInSync(group) && isGroupInSync(groupedFlowSteps[groupIndex + 1])" 
                      size="20" 
                      color="primary" 
                      class="arrow-icon"
                    >
                      mdi-sync
                    </v-icon>
                    <!-- Regular right arrow otherwise -->
                    <v-icon v-else size="20" color="primary" class="arrow-icon">mdi-arrow-right</v-icon>
                    <v-tooltip location="bottom" :disabled="getGapTime(groupIndex) === null || getGapTime(groupIndex) === 0">
                      <template v-slot:activator="{ props }">
                        <span v-if="getGapTime(groupIndex) !== null" v-bind="props" class="gap-time-text" :style="{ color: getGapTimeColor(getGapTime(groupIndex)) }">
                          {{ formatResponseTime(getGapTime(groupIndex)) }}
                        </span>
                      </template>
                      <div class="gap-breakdown">
                        <!-- Show ProcessBreakdown for any node that has input.processBreakdown -->
                        <template v-if="isNextNodeHasProcessBreakdown(groupIndex)">
                          <div v-for="(item, idx) in getNextNodeProcessBreakdown(groupIndex)" :key="idx" class="gap-item">
                            {{ item.label }}: <span class="gap-value">{{ item.value }}</span>
                          </div>
                        </template>
                        <!-- Show regular gap breakdown for all other nodes -->
                        <template v-else>
                          <div v-for="(item, idx) in getGapTimeBreakdown(groupIndex)" :key="idx" class="gap-item">
                            {{ item.label }}: <span class="gap-value">{{ item.value }}</span>
                          </div>
                        </template>
                      </div>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>

            <!-- Instruction Panel (when no node selected) -->
            <transition name="slide-fade">
              <div v-if="!expandedStep" class="instruction-panel">
                <v-card variant="outlined" class="mt-4 instruction-card">
                  <v-card-text class="pa-6 text-center">
                    <div class="instruction-icon-wrapper mb-4">
                      <v-icon size="64" color="primary" class="instruction-icon">mdi-cursor-default-click</v-icon>
                    </div>
                    <h3 class="instruction-title mb-3">Select a Node to View Details</h3>
                    <p class="instruction-subtitle mb-4">Click on any node above to see its input/output data and timing information</p>
                  </v-card-text>
                </v-card>
              </div>
            </transition>

            <!-- Step Details Panel (when expanded) -->
            <transition name="slide-fade">
              <div v-if="expandedStep" class="step-details-panel">
                <v-card variant="outlined" class="mt-4 details-card">
                  <v-card-title class="pa-3">
                    <v-icon class="mr-2" :color="getNodeTypeColor(expandedStep.node)">{{ getNodeIcon(expandedStep.node) }}</v-icon>
                    {{ getStepDisplayName(expandedStep) }} - Details
                  </v-card-title>
                  <v-card-text class="pa-3">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-row>
                          <v-col cols="6">
                            <h6 class="mb-2">📥 Input Data</h6>
                          </v-col>
                          <v-col cols="6" style="display: flex; justify-content: flex-end">
                            <span @click="copyToClipboard(formatInputData(expandedStep.input.message))" style="cursor: pointer; color: blue"
                              ><v-icon color="#888888" size="16">mdi-content-copy</v-icon></span
                            >
                          </v-col>
                        </v-row>
                        <pre class="details-json">{{ formatInputData(expandedStep.input.message) }}</pre>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-row>
                          <v-col cols="6">
                            <h6 class="mb-2">{{ outputPanelTitle(expandedStep) }}</h6>
                          </v-col>
                          <v-col cols="6" style="display: flex; justify-content: flex-end">
                            <span @click="copyToClipboard(outputPanelText(expandedStep))" style="cursor: pointer; color: blue"
                              ><v-icon color="#888888" size="16">mdi-content-copy</v-icon></span
                            >
                          </v-col>
                        </v-row>
                        <pre class="details-json">{{ outputPanelText(expandedStep) }}</pre>
                      </v-col>
                    </v-row>

                    <!-- Tax Planning process trace (which question / LLM process / progress) -->
                    <div v-if="(expandedStep.node === 'taxPlanning' || expandedStep.node === 'taxStateRead') && expandedStep.output && expandedStep.output.description" class="mt-4">
                      <h6 class="mb-2">🧾 Process</h6>
                      <div class="process-summary">
                        <div class="process-summary-icon">
                          <v-icon color="white" size="20">mdi-clipboard-text-clock</v-icon>
                        </div>
                        <div class="process-summary-info">
                          <div class="process-summary-label">{{ $t('processSteps') }}</div>
                          <div class="process-summary-caption">
                            {{ processMeta(expandedStep.output.description).count }} {{ $t('stepsUnit') }}<template v-if="processMeta(expandedStep.output.description).total"> · {{ $t('answered') }} {{ processMeta(expandedStep.output.description).done }}/{{ processMeta(expandedStep.output.description).total }}</template>
                          </div>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn size="x-small" variant="text" color="success" class="monitor-btn" @click="openProcessSteps(expandedStep)">
                          <v-icon size="18">mdi-format-list-checks</v-icon>
                          <v-tooltip activator="parent" location="top">{{ $t('viewSteps') }}</v-tooltip>
                        </v-btn>
                      </div>
                    </div>

                    <!-- Agent LLM / hosted web_search process trace (plaintext, written by AgentNodeProcessor into Output.Description) -->
                    <div v-if="(expandedStep.node === 'agent-aimodel' || expandedStep.node === 'agent') && expandedStep.output && expandedStep.output.description" class="mt-4">
                      <h6 class="mb-2">🧾 Process</h6>
                      <!-- ห้ามใช้ v-html: ข้อความมาจาก LLM / เว็บภายนอก — url ถูกแตกเป็นชิ้นด้วย linkifyTraceText แล้วผูก href เฉพาะ http(s) -->
                      <pre class="details-json agent-process-trace"><template v-for="(part, partIndex) in linkifyTraceText(expandedStep.output.description)" :key="'trace-' + partIndex"><a v-if="part.href" :href="part.href" target="_blank" rel="noopener noreferrer nofollow" class="agent-trace-link">{{ part.text }}</a><span v-else>{{ part.text }}</span></template></pre>
                    </div>

                    <!-- Mutual Fund resolve trace (plaintext, written by MutualFundFundResolver into Output.Description)
                         บล็อกแยกจาก agent เพราะ trace ก้อนนี้ไม่มี url ให้ linkify และไม่ยาวเท่า จึงใช้กล่อง details-json ปกติ -->
                    <div v-if="expandedStep.node === 'mutualFund' && expandedStep.output && expandedStep.output.description" class="mt-4">
                      <h6 class="mb-2">🧾 Process</h6>
                      <pre class="details-json">{{ expandedStep.output.description }}</pre>
                    </div>

                    <!-- Agent LLM call summary (model / tokens / endpoint / status) - visible even when the turn failed and no Log_AIModel row is linked -->
                    <div v-if="(expandedStep.node === 'agent-aimodel' || expandedStep.node === 'agent') && expandedStep.output && (expandedStep.output.model || expandedStep.output.totalTokens || expandedStep.output.endpoint || expandedStep.status === 'Error' || agentWebSearchRequests(expandedStep) > 0)" class="mt-4">
                      <h6 class="mb-2">🤖 LLM Call</h6>
                      <div class="timing-compact">
                        <div class="timing-item" v-if="expandedStep.output.model">
                          <span class="timing-label">Model:</span>
                          <span class="timing-value">{{ expandedStep.output.model }}</span>
                        </div>
                        <div class="timing-item" v-if="expandedStep.status">
                          <span class="timing-label">Status:</span>
                          <v-chip size="x-small" :color="expandedStep.status === 'Success' ? 'success' : 'error'" variant="flat" class="text-white">
                            {{ expandedStep.status }}
                          </v-chip>
                        </div>
                        <div class="timing-item">
                          <span class="timing-label">Tokens:</span>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip size="x-small" color="primary" variant="outlined" v-bind="props">
                                {{ expandedStep.output.totalTokens || 0 }}
                              </v-chip>
                            </template>
                            <div>
                              Prompt: {{ expandedStep.output.promptTokens || 0 }}<br />
                              Completion: {{ expandedStep.output.completionTokens || 0 }}<br />
                              Total: {{ expandedStep.output.totalTokens || 0 }}
                            </div>
                          </v-tooltip>
                        </div>
                        <!-- hosted web_search: หน่วยที่ผู้ให้บริการคิดเงินแยกจาก token ⇒ โชว์คู่กับ Tokens -->
                        <div class="timing-item" v-if="agentWebSearchRequests(expandedStep) > 0">
                          <span class="timing-label">Web search:</span>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-chip size="x-small" color="teal" variant="outlined" v-bind="props">
                                {{ agentWebSearchRequests(expandedStep) }}
                              </v-chip>
                            </template>
                            <div>Hosted web_search requests: {{ agentWebSearchRequests(expandedStep) }}<br />(billed per request, separate from tokens)</div>
                          </v-tooltip>
                        </div>
                        <div class="timing-item" v-if="expandedStep.output.endpoint">
                          <span class="timing-label">Endpoint:</span>
                          <span class="timing-value" style="cursor: pointer" :title="expandedStep.output.endpoint + ' (Click to copy)'" @click="copyToClipboard(expandedStep.output.endpoint)">
                            {{ expandedStep.output.endpoint }}
                          </span>
                        </div>
                      </div>
                      <pre v-if="expandedStep.errorMessage" class="details-json mt-2">{{ expandedStep.errorMessage }}</pre>
                    </div>

                    <!-- TTS Processing Details Section (for TTS nodes) -->
                    <!-- <div v-if="expandedStep.node === 'reformatForTTS' || expandedStep.node === 'formatForTTSEngine'" class="mt-4">
                      <h6 class="mb-2">🔊 TTS Log References (1)</h6>
                      <div class="log-refs-table-container">
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 60px">Monitor</th>
                              <th class="text-left">Message</th>
                              <th class="text-left">Reply</th>
                              <th class="text-center">Tokens</th>
                              <th class="text-center">Response Time</th>
                              <th class="text-left">Endpoint</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="log-ref-row">
                              <td class="text-center">
                                <v-btn size="x-small" variant="text" color="info" icon="mdi-monitor-eye" @click="openTTSMonitorDetails(expandedStep)" class="monitor-btn">
                                  <v-icon size="18">mdi-monitor-eye</v-icon>
                                  <v-tooltip activator="parent" location="top">View TTS Monitor</v-tooltip>
                                </v-btn>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 180px; cursor: pointer"
                                  :title="(expandedStep.input?.message || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(expandedStep.input?.message || '-')"
                                >
                                  {{ expandedStep.input?.message || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 180px; cursor: pointer"
                                  :title="(expandedStep.output?.message || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(expandedStep.output?.message || '-')"
                                >
                                  {{ expandedStep.output?.message || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <v-chip size="x-small" color="primary" variant="outlined" v-bind="props">
                                      {{ expandedStep.output?.totalTokens || 0 }}
                                    </v-chip>
                                  </template>
                                  <div>
                                    Prompt: {{ expandedStep.output?.promptTokens || 0 }}<br />
                                    Completion: {{ expandedStep.output?.completionTokens || 0 }}<br />
                                    Total: {{ expandedStep.output?.totalTokens || 0 }}
                                  </div>
                                </v-tooltip>
                              </td>
                              <td class="text-center">
                                <v-chip size="x-small" :color="getResponseTimeColor(expandedStep.responseTimeMs)" variant="flat" class="text-white">
                                  {{ formatResponseTime(expandedStep.responseTimeMs) }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 130px; cursor: pointer"
                                  :title="(expandedStep.output?.endpoint || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(expandedStep.output?.endpoint || '-')"
                                >
                                  {{ expandedStep.output?.endpoint || '-' }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <div class="mt-3">
                        <h6 class="mb-2">⏱️ Timing</h6>
                        <v-row dense>
                          <v-col cols="4">
                            <div class="param-label">Start:</div>
                            <div class="text-body-2">{{ formatDateTime(expandedStep.startTime) }}</div>
                          </v-col>
                          <v-col cols="4">
                            <div class="param-label">End:</div>
                            <div class="text-body-2">{{ formatDateTime(expandedStep.endTime) }}</div>
                          </v-col>
                          <v-col cols="4">
                            <div class="param-label">Duration:</div>
                            <div class="text-body-2 font-weight-medium">{{ formatResponseTime(expandedStep.responseTimeMs) }}</div>
                          </v-col>
                        </v-row>
                      </div>

                      <div class="mt-3 pa-2" style="background: #f8f8f8; border-radius: 8px;">
                        <div class="text-caption text-grey">
                          <v-icon size="12" class="mr-1">mdi-information-outline</v-icon>
                          {{ expandedStep.node === 'reformatForTTS' ? 'Step 1: Rewrites text for natural spoken language (converts numbers, abbreviations)' : 'Step 2: Formats text with SSML pause tags for TTS engine' }}
                        </div>
                      </div>
                    </div> -->

                    <!-- Log References Section -->
                    <div v-if="expandedStep.logRefs && expandedStep.logRefs.length > 0" class="mt-4">
                      <h6 class="mb-2">🔗 Log References ({{ expandedStep.logRefs.length }})</h6>

                      <!-- Loading State -->
                      <div v-if="expandedStep.loadingRefs" class="text-center py-4">
                        <v-progress-circular indeterminate color="primary" size="32"></v-progress-circular>
                        <p class="mt-2 text-caption">Loading reference data...</p>
                      </div>

                      <!-- Data Display as Table (excludes orchestrator, apiTrigger, apiknowledge, apiRequest, documents, community, serviceMatcher*) -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && expandedStep.node !== 'orchestrator' && expandedStep.node !== 'apiTrigger' && expandedStep.node !== 'apiknowledge' && expandedStep.node !== 'apiRequest' && expandedStep.node !== 'documents' && expandedStep.node !== 'community' && expandedStep.node !== 'community+documents' && expandedStep.node !== 'serviceMatcher' && expandedStep.node !== 'serviceMatcher-api' && expandedStep.node !== 'serviceMatcher-favorite'"
                        class="log-refs-table-container"
                      >
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 60px">Monitor</th>
                              <th v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'router' || expandedStep.node === 'advancedRouter' || expandedStep.node === 'dynamicRouter')" class="text-left">Intent</th>
                              <th v-else class="text-left">Message</th>
                              <th class="text-left">Reply</th>
                              <th class="text-center">Tokens</th>
                              <th class="text-center">Response Time</th>
                              <th class="text-left">Endpoint</th>
                              <th v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'router' || expandedStep.node === 'advancedRouter' || expandedStep.node === 'dynamicRouter')" class="text-center">Selected</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td class="text-center">
                                <v-btn size="x-small" variant="text" color="info" icon="mdi-monitor-eye" @click="openMonitorDetails(refData.id, (expandedStep.node === 'llmEnrich' || expandedStep.node === 'mutualFund' || expandedStep.node === 'taxStateRead') ? 'model' : expandedStep.node, (expandedStep.node == 'router' || expandedStep.node == 'advancedRouter' || expandedStep.node == 'dynamicRouter' ? refData.logRouterID : null))" class="monitor-btn">
                                  <v-icon size="18">mdi-monitor-eye</v-icon>
                                  <v-tooltip activator="parent" location="top">View Monitor</v-tooltip>
                                </v-btn>
                              </td>
                              <!-- Intent nodes: Intent Name -->
                              <td v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'router' || expandedStep.node === 'advancedRouter' || expandedStep.node === 'dynamicRouter')" class="text-left">
                                <v-chip @click="copyToClipboard(refData.intentName || '-')" size="x-small" color="purple" variant="outlined" v-if="refData.intentName">
                                  {{ refData.intentName }}
                                </v-chip>
                                <span v-else class="text-grey">-</span>
                              </td>
                              <!-- Other nodes: Message -->
                              <td v-else class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.message || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.message || '-')"
                                >
                                  {{ refData.message || '-' }}
                                </div>
                              </td>
                              <!-- Reply column -->
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.reply || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.reply || '-')"
                                >
                                  {{ refData.reply || '-' }}
                                </div>
                              </td>
                              <!-- Tokens column -->
                              <td class="text-center">
                                <div class="token-info">
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-chip size="x-small" color="primary" variant="outlined" v-bind="props">
                                        {{ refData.totalTokens || 0 }}
                                      </v-chip>
                                    </template>
                                    <div>
                                      Prompt: {{ refData.promptTokens || 0 }}<br />
                                      Completion: {{ refData.completionTokens || 0 }}<br />
                                      Total: {{ refData.totalTokens || 0 }}<br />
                                      Cached: {{ refData.cachedTokens || 0 }}
                                    </div>
                                  </v-tooltip>
                                </div>
                              </td>
                              <!-- Response Time column -->
                              <td class="text-center">
                                <v-chip size="x-small" :color="getResponseTimeColor(refData.responseTime)" variant="flat" class="text-white">
                                  {{ formatResponseTime(refData.responseTime) }}
                                </v-chip>
                              </td>
                              <!-- Endpoint column -->
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 150px; cursor: pointer"
                                  :title="(refData.urlEndpoint || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.urlEndpoint || '-')"
                                >
                                  {{ refData.urlEndpoint || '-' }}
                                </div>
                              </td>
                              <!-- Selected column for intent -->
                              <td v-if="expandedStep && (expandedStep.node === 'intent' || expandedStep.node === 'smartIntent' || expandedStep.node === 'router' || expandedStep.node === 'advancedRouter' || expandedStep.node === 'dynamicRouter')" class="text-center">
                                <v-icon :color="refData.isUse ? 'success' : 'grey'" size="small" :title="refData.isUse ? 'Selected' : 'Not Selected'">
                                  {{ refData.isUse ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                                </v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- API Trigger Table (also serves serviceMatcher-api, and serviceMatcher for legacy logs whose logRefs sit on the main step) -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && (expandedStep.node === 'apiTrigger' || expandedStep.node === 'apiknowledge' || expandedStep.node === 'apiRequest' || expandedStep.node === 'serviceMatcher-api' || expandedStep.node === 'serviceMatcher')"
                        class="log-refs-table-container"
                      >
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-left">Method</th>
                              <th class="text-left">API Endpoint</th>
                              <th class="text-left">Request Body</th>
                              <th class="text-left">JSON Response</th>
                              <th class="text-center">Status Code</th>
                              <th class="text-left">Status Name</th>
                              <th class="text-center">Response Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td class="text-left">
                                <v-chip
                                  size="x-small"
                                  :color="refData.method === 'GET' ? 'green' : refData.method === 'POST' ? 'blue' : refData.method === 'PUT' ? 'orange' : refData.method === 'DELETE' ? 'red' : 'grey'"
                                  variant="flat"
                                  class="text-white"
                                >
                                  {{ refData.method || '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.apiEndPoint || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.apiEndPoint || '-')"
                                >
                                  {{ refData.apiEndPoint || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.requestBody || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.requestBody || '-')"
                                >
                                  {{ refData.requestBody || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.jsonResponse || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.jsonResponse || '-')"
                                >
                                  {{ refData.jsonResponse || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <v-chip
                                  size="x-small"
                                  :color="refData.statusCode >= 200 && refData.statusCode < 300 ? 'success' : refData.statusCode >= 400 ? 'error' : 'warning'"
                                  variant="flat"
                                  class="text-white"
                                >
                                  {{ refData.statusCode || '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div class="text-truncate" style="max-width: 150px">
                                  {{ refData.statusName || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <v-chip size="x-small" :color="getResponseTimeColor(refData.responseTime)" variant="flat" class="text-white">
                                  {{ formatResponseTime(refData.responseTime) }}
                                </v-chip>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- Orchestrator Table -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && expandedStep.node === 'orchestrator'"
                        class="log-refs-table-container"
                      >
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-left">Agent</th>
                              <th class="text-left">Description</th>
                              <th class="text-center">Selected</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td class="text-left">
                                <v-chip
                                  size="x-small"
                                  :color="refData.isUse ? 'green' : 'grey'"
                                  variant="flat"
                                  class="text-white"
                                >
                                  {{ refData.intentName || '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 500px; cursor: pointer"
                                  :title="(refData.urlEndpoint || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.urlEndpoint || '-')"
                                >
                                  {{ refData.urlEndpoint || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <v-icon v-if="refData.isUse" color="success" size="small">mdi-check-circle</v-icon>
                                <v-icon v-else color="grey" size="small">mdi-close-circle</v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- Documents Table -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && expandedStep.node === 'documents'"
                        class="log-refs-table-container"
                      >
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-left">ID</th>
                              <th class="text-left">Document name</th>
                              <th class="text-left">Text ORG</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td class="text-left">
                                <v-chip
                                  size="x-small"
                                  :color="'green'"
                                  variant="flat"
                                  class="text-white"
                                >
                                  {{ refData.id || '-' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.textORG || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.documentName || '-')"
                                >
                                  {{ refData.documentName || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.textORG || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.textORG || '-')"
                                >
                                  {{ refData.textORG || '-' }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- Community Graph / Community+Documents Display -->
                      <div
                        v-else-if="expandedStep.logRefsData && expandedStep.logRefsData.length > 0 && (expandedStep.node === 'community' || expandedStep.node === 'community+documents')"
                        class="log-refs-table-container"
                      >
                        <!-- Knowledge Sources Summary -->
                        <div class="knowledge-sources-summary mb-3 pa-3" style="background: linear-gradient(135deg, rgba(124, 58, 237, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%); border-radius: 8px; border: 1px solid rgba(124, 58, 237, 0.3);">
                          <div class="text-subtitle-2 mb-2" style="color: #7c3aed;">
                            <v-icon size="small" class="mr-1">mdi-information-outline</v-icon>
                            Knowledge Sources Used
                          </div>

                          <!-- Community Graph Info -->
                          <div v-if="expandedStep.communityData" class="d-flex align-center flex-wrap ga-2 mb-2">
                            <v-chip size="small" color="purple" variant="flat" class="text-white">
                              <v-icon size="x-small" start>mdi-graph</v-icon>
                              Community Graph
                            </v-chip>
                            <span class="text-body-2">
                              ID: <strong>{{ expandedStep.communityData.communityId }}</strong> |
                              Matched <strong>{{ expandedStep.communityData.groups }}</strong> groups |
                              Retrieved <strong>{{ expandedStep.communityData.chunks }}</strong> chunks
                            </span>
                          </div>

                          <!-- Documents Info (for community+documents) -->
                          <div v-if="expandedStep.node === 'community+documents' && expandedStep.documentData" class="d-flex align-center flex-wrap ga-2">
                            <v-chip size="small" color="blue" variant="flat" class="text-white">
                              <v-icon size="x-small" start>mdi-file-document-multiple</v-icon>
                              Documents
                            </v-chip>
                            <span class="text-body-2">
                              Retrieved <strong>{{ expandedStep.documentData.chunks || 0 }}</strong> chunks from documents
                            </span>
                          </div>

                          <!-- Mode indicator -->
                          <div class="mt-2">
                            <v-chip
                              size="x-small"
                              :color="expandedStep.node === 'community' ? 'deep-purple' : 'indigo'"
                              variant="outlined"
                            >
                              {{ expandedStep.node === 'community' ? 'Graph Only Mode' : 'Combined Mode (Graph + Docs)' }}
                            </v-chip>
                          </div>
                        </div>

                        <!-- Retrieved Chunks Table -->
                        <div class="text-subtitle-2 mb-2">
                          <v-icon size="small" class="mr-1">mdi-database-search</v-icon>
                          Retrieved Chunks ({{ expandedStep.logRefsData.length }})
                        </div>
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr style="background: rgba(124, 58, 237, 0.1);">
                              <th class="text-left" style="width: 60px;">ID</th>
                              <th v-if="expandedStep.node === 'community+documents'" class="text-left" style="width: 80px;">Source</th>
                              <th class="text-left">Document</th>
                              <th class="text-left">Content Preview</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.logRefsData" :key="idx" class="log-ref-row">
                              <td class="text-left">
                                <v-chip
                                  size="x-small"
                                  :color="refData.source === 'community' ? 'purple' : 'blue'"
                                  variant="flat"
                                  class="text-white"
                                >
                                  {{ refData.id || idx + 1 }}
                                </v-chip>
                              </td>
                              <td v-if="expandedStep.node === 'community+documents'" class="text-left">
                                <v-chip
                                  size="x-small"
                                  :color="refData.source === 'community' ? 'deep-purple' : 'blue'"
                                  variant="tonal"
                                >
                                  <v-icon size="x-small" start>{{ refData.source === 'community' ? 'mdi-graph' : 'mdi-file-document' }}</v-icon>
                                  {{ refData.source === 'community' ? 'Graph' : 'Doc' }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 150px; cursor: pointer"
                                  :title="(refData.documentName || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.documentName || '-')"
                                >
                                  {{ refData.documentName || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.textORG || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.textORG || '-')"
                                >
                                  {{ refData.textORG || '-' }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- IDs Display (before loading) -->
                      <div v-else class="log-refs-ids">
                        <v-chip v-for="(refId, idx) in expandedStep.logRefs" :key="idx" class="ma-1" size="small" variant="outlined" color="primary"> ID: {{ refId }} </v-chip>
                      </div>
                    </div>

                    <!-- Orchestrator AI Model Monitor Section -->
                    <div
                      v-if="expandedStep.node === 'orchestrator' && ((expandedStep.modelRefsData && expandedStep.modelRefsData.length > 0) || expandedStep.loadingModelRefs || expandedStep.modelRefsError)"
                      class="mt-4"
                    >
                      <h6 class="mb-2">🖥️ AI Model Monitor ({{ expandedStep.modelRefsData ? expandedStep.modelRefsData.length : 0 }})</h6>

                      <!-- Orchestrator Model References Table (with Monitor) -->
                      <div
                        v-if="expandedStep.node === 'orchestrator' && expandedStep.modelRefsData && expandedStep.modelRefsData.length > 0"
                        class="log-refs-table-container mt-4"
                      >
                        <v-table density="compact" class="log-refs-table">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 60px">Monitor</th>
                              <th class="text-left">Message</th>
                              <th class="text-left">Reply</th>
                              <th class="text-center">Tokens</th>
                              <th class="text-center">Response Time</th>
                              <th class="text-left">Endpoint</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(refData, idx) in expandedStep.modelRefsData" :key="idx" class="log-ref-row">
                              <td class="text-center">
                                <v-btn size="x-small" variant="text" color="info" icon="mdi-monitor-eye" @click="openMonitorDetails(refData.id, 'model')" class="monitor-btn">
                                  <v-icon size="18">mdi-monitor-eye</v-icon>
                                  <v-tooltip activator="parent" location="top">View Monitor</v-tooltip>
                                </v-btn>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.message || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.message || '-')"
                                >
                                  {{ refData.message || '-' }}
                                </div>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 200px; cursor: pointer"
                                  :title="(refData.reply || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.reply || '-')"
                                >
                                  {{ refData.reply || '-' }}
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="token-info">
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-chip size="x-small" color="primary" variant="outlined" v-bind="props">
                                        {{ refData.totalTokens || 0 }}
                                      </v-chip>
                                    </template>
                                    <div>
                                      Prompt: {{ refData.promptTokens || 0 }}<br />
                                      Completion: {{ refData.completionTokens || 0 }}<br />
                                      Total: {{ refData.totalTokens || 0 }}<br />
                                      Cached: {{ refData.cachedTokens || 0 }}
                                    </div>
                                  </v-tooltip>
                                </div>
                              </td>
                              <td class="text-center">
                                <v-chip size="x-small" :color="getResponseTimeColor(refData.responseTime)" variant="flat" class="text-white">
                                  {{ formatResponseTime(refData.responseTime) }}
                                </v-chip>
                              </td>
                              <td class="text-left">
                                <div
                                  class="text-truncate"
                                  style="max-width: 150px; cursor: pointer"
                                  :title="(refData.urlEndpoint || '-') + ' (Click to copy)'"
                                  @click="copyToClipboard(refData.urlEndpoint || '-')"
                                >
                                  {{ refData.urlEndpoint || '-' }}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </div>

                      <!-- Loading state for Model References -->
                      <div v-if="expandedStep.node === 'orchestrator' && expandedStep.loadingModelRefs" class="text-center pa-4">
                        <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                        <p class="mt-2 text-caption">Loading model reference data...</p>
                      </div>

                      <!-- Error state for Model References -->
                      <div v-if="expandedStep.node === 'orchestrator' && expandedStep.modelRefsError" class="text-center pa-4">
                        <v-icon color="error" size="large">mdi-alert-circle</v-icon>
                        <p class="mt-2 text-caption text-error">{{ expandedStep.modelRefsError }}</p>
                      </div>
                    </div>

                    <!-- Service Fallback's Output JSON is rendered in the Output panel above,
                         in place of the summary line, so it does not repeat down here. -->

                    <!-- JSON Condition Configuration -->
                    <div v-if="expandedStep.node === 'jsonCondition' && expandedStep.output && expandedStep.output.requestParameters" class="mt-4">
                      
                      <div class="tool-details-wrapper">
                        <v-row dense>
                          <v-col cols="12">
                            <h6 class="mb-2">🔗 Condition Rules ({{ getJsonConditions(expandedStep.output.requestParameters).length }})</h6>
                            <div class="log-refs-table-container">
                              <v-table density="compact" class="log-refs-table">
                                <thead>
                                  <tr>
                                    <th class="text-left">JSON Path</th>
                                    <th class="text-left">Operator Type</th>
                                    <th class="text-left">Compare Value</th>
                                    <th class="text-left">Result</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(condition, idx) in getJsonConditions(expandedStep.output.requestParameters)" :key="idx" class="log-ref-row">
                                    <td class="text-left">
                                      <v-chip size="x-small" color="cyan" variant="outlined">
                                        {{ condition.jsonPath || '-' }}
                                      </v-chip>
                                    </td>
                                    <td class="text-left">
                                      <div
                                        class="text-truncate"
                                        style="max-width: 200px; cursor: pointer"
                                        :title="(condition.operatorType || '-') + ' (Click to copy)'"
                                        @click="copyToClipboard(condition.operatorType || '-')"
                                      >
                                        {{ condition.operatorType || '-' }}
                                      </div>
                                    </td>
                                    <td class="text-left">
                                      <div
                                        class="text-truncate"
                                        style="max-width: 200px; cursor: pointer"
                                        :title="(condition.compareValue || '-') + ' (Click to copy)'"
                                        @click="copyToClipboard(condition.compareValue || '-')"
                                      >
                                        {{ condition.compareValue || '-' }}
                                      </div>
                                    </td>
                                    <td class="text-left">
                                      <div
                                        class="text-truncate"
                                        style="max-width: 200px; cursor: pointer"
                                        :title="(condition.result || '-') + ' (Click to copy)'"
                                        @click="copyToClipboard(condition.result || '-')"
                                      >
                                        {{ condition.result || '-' }}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <!-- Service Matcher Summary (branch / strategy / rules) -->
                    <div v-if="expandedStep?.node === 'serviceMatcher' && serviceMatcherSummary" class="mt-4">
                      <div class="tool-details-wrapper">
                        <v-row dense>
                          <v-col cols="12">
                            <h6 class="mb-2">🎯 Service Matcher Result</h6>
                            <div class="timing-compact">
                              <div class="timing-item" v-if="serviceMatcherSummary?.branch">
                                <span class="timing-label">Branch:</span>
                                <v-chip
                                  size="x-small"
                                  variant="flat"
                                  class="text-white"
                                  :style="{ backgroundColor: serviceMatcherSummary?.branch === 'favorite' ? '#0d9488' : serviceMatcherSummary?.branch === 'service' ? '#0891b2' : '#f59e0b' }"
                                >
                                  {{ serviceMatcherSummary?.branch }}
                                </v-chip>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.strategy">
                                <span class="timing-label">Strategy:</span>
                                <span class="timing-value">{{ serviceMatcherSummary?.strategy }}</span>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.apiStatusCode !== null && serviceMatcherSummary?.apiStatusCode !== undefined">
                                <span class="timing-label">API Status Code:</span>
                                <v-chip
                                  size="x-small"
                                  variant="flat"
                                  class="text-white"
                                  :color="serviceMatcherSummary?.apiStatusCode >= 200 && serviceMatcherSummary?.apiStatusCode < 300 ? 'success' : serviceMatcherSummary?.apiStatusCode >= 400 ? 'error' : 'warning'"
                                >
                                  {{ serviceMatcherSummary?.apiStatusCode }}
                                </v-chip>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.apiSkipped">
                                <span class="timing-label">API:</span>
                                <v-chip size="x-small" variant="flat" color="grey" class="text-white">Skipped</v-chip>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.favoritesFrom">
                                <span class="timing-label">Favorites From:</span>
                                <span class="timing-value">{{ serviceMatcherSummary?.favoritesFrom }}</span>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.serviceMatchCount !== undefined">
                                <span class="timing-label">Service Match Count:</span>
                                <span v-if="serviceMatcherSummary?.serviceMatchCount !== null" class="timing-value">{{ serviceMatcherSummary?.serviceMatchCount }}</span>
                                <span v-else class="timing-value text-grey" title="Service match did not run">—</span>
                              </div>
                            </div>

                            <div v-if="serviceMatcherSummary?.apiError" class="mt-2">
                              <h6 class="mb-2">⚠️ API Error</h6>
                              <pre class="details-json">{{ serviceMatcherSummary?.apiError }}</pre>
                            </div>

                            <div v-if="serviceMatcherSummary?.favoriteRule || serviceMatcherSummary?.serviceRule || serviceMatcherSummary?.serviceRuleResult" class="log-refs-table-container mt-3">
                              <v-table density="compact" class="log-refs-table">
                                <thead>
                                  <tr>
                                    <th class="text-left" style="width: 130px">Rule Set</th>
                                    <th class="text-left">Rule Summary</th>
                                    <th class="text-center" style="width: 80px">Result</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-if="serviceMatcherSummary?.favoriteRule" class="log-ref-row">
                                    <td class="text-left">
                                      <v-chip size="x-small" color="teal" variant="outlined">Favorite Rule</v-chip>
                                    </td>
                                    <td class="text-left">
                                      <div
                                        style="cursor: pointer"
                                        :title="(serviceMatcherSummary?.favoriteRule || '-') + ' (Click to copy)'"
                                        @click="copyToClipboard(serviceMatcherSummary?.favoriteRule || '-')"
                                      >
                                        {{ serviceMatcherSummary?.favoriteRule || '-' }}
                                      </div>
                                    </td>
                                    <td class="text-center">
                                      <v-chip
                                        v-if="getRuleOutcome(serviceMatcherSummary?.favoriteRule)"
                                        size="x-small"
                                        variant="flat"
                                        class="text-white"
                                        :color="getRuleOutcome(serviceMatcherSummary?.favoriteRule) === 'Pass' ? 'success' : 'error'"
                                      >
                                        {{ getRuleOutcome(serviceMatcherSummary?.favoriteRule) }}
                                      </v-chip>
                                      <span v-else class="text-grey">-</span>
                                    </td>
                                  </tr>
                                  <tr class="log-ref-row">
                                    <td class="text-left">
                                      <v-chip size="x-small" color="cyan" variant="outlined">Service Rule</v-chip>
                                    </td>
                                    <td class="text-left">
                                      <div
                                        v-if="serviceMatcherSummary?.serviceRule"
                                        style="cursor: pointer"
                                        :title="serviceMatcherSummary?.serviceRule + ' (Click to copy)'"
                                        @click="copyToClipboard(serviceMatcherSummary?.serviceRule)"
                                      >
                                        {{ serviceMatcherSummary?.serviceRule }}
                                      </div>
                                      <span v-else class="text-grey">not evaluated</span>
                                    </td>
                                    <td class="text-center">
                                      <v-chip
                                        v-if="serviceMatcherSummary?.serviceRuleResult || getRuleOutcome(serviceMatcherSummary?.serviceRule)"
                                        size="x-small"
                                        variant="flat"
                                        class="text-white"
                                        :color="(serviceMatcherSummary?.serviceRuleResult || getRuleOutcome(serviceMatcherSummary?.serviceRule)) === 'Pass' ? 'success' : 'error'"
                                      >
                                        {{ serviceMatcherSummary?.serviceRuleResult || getRuleOutcome(serviceMatcherSummary?.serviceRule) }}
                                      </v-chip>
                                      <span v-else class="text-grey" title="Service rule was not evaluated">—</span>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <!-- Favorite Match Summary (serviceMatcher-favorite) -->
                    <div v-if="expandedStep?.node === 'serviceMatcher-favorite' && serviceMatcherSummary" class="mt-4">
                      <div class="tool-details-wrapper">
                        <v-row dense>
                          <v-col cols="12">
                            <h6 class="mb-2">⭐ Favorite Match Result</h6>
                            <div class="timing-compact">
                              <div class="timing-item" v-if="serviceMatcherSummary?.serviceType">
                                <span class="timing-label">Service Type:</span>
                                <v-chip size="x-small" color="teal" variant="outlined">{{ serviceMatcherSummary?.serviceType }}</v-chip>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.favoritesFrom">
                                <span class="timing-label">Favorites From:</span>
                                <span class="timing-value">{{ serviceMatcherSummary?.favoritesFrom }}</span>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.matchCount !== undefined">
                                <span class="timing-label">Match Count:</span>
                                <span v-if="serviceMatcherSummary?.matchCount !== null" class="timing-value">{{ serviceMatcherSummary?.matchCount }}</span>
                                <span v-else class="timing-value text-grey">—</span>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.result || getRuleOutcome(serviceMatcherSummary?.rule)">
                                <span class="timing-label">Result:</span>
                                <v-chip
                                  size="x-small"
                                  variant="flat"
                                  class="text-white"
                                  :color="(serviceMatcherSummary?.result || getRuleOutcome(serviceMatcherSummary?.rule)) === 'Pass' ? 'success' : 'error'"
                                >
                                  {{ serviceMatcherSummary?.result || getRuleOutcome(serviceMatcherSummary?.rule) }}
                                </v-chip>
                              </div>
                            </div>

                            <div v-if="serviceMatcherSummary?.rule" class="log-refs-table-container mt-3">
                              <v-table density="compact" class="log-refs-table">
                                <thead>
                                  <tr>
                                    <th class="text-left" style="width: 130px">Rule Set</th>
                                    <th class="text-left">Rule Summary</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="log-ref-row">
                                    <td class="text-left">
                                      <v-chip size="x-small" color="teal" variant="outlined">Favorite Rule</v-chip>
                                    </td>
                                    <td class="text-left">
                                      <div
                                        style="cursor: pointer"
                                        :title="(serviceMatcherSummary?.rule || '-') + ' (Click to copy)'"
                                        @click="copyToClipboard(serviceMatcherSummary?.rule || '-')"
                                      >
                                        {{ serviceMatcherSummary?.rule || '-' }}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <!-- API Request Summary (serviceMatcher-api) -->
                    <div v-if="expandedStep?.node === 'serviceMatcher-api' && serviceMatcherSummary" class="mt-4">
                      <div class="tool-details-wrapper">
                        <v-row dense>
                          <v-col cols="12">
                            <h6 class="mb-2">🔗 API Request Detail</h6>
                            <div class="timing-compact">
                              <div class="timing-item" v-if="serviceMatcherSummary?.method">
                                <span class="timing-label">Method:</span>
                                <v-chip
                                  size="x-small"
                                  variant="flat"
                                  class="text-white"
                                  :color="serviceMatcherSummary?.method === 'GET' ? 'green' : serviceMatcherSummary?.method === 'POST' ? 'blue' : serviceMatcherSummary?.method === 'PUT' ? 'orange' : serviceMatcherSummary?.method === 'DELETE' ? 'red' : 'grey'"
                                >
                                  {{ serviceMatcherSummary?.method }}
                                </v-chip>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.statusCode !== null && serviceMatcherSummary?.statusCode !== undefined">
                                <span class="timing-label">Status Code:</span>
                                <v-chip
                                  size="x-small"
                                  variant="flat"
                                  class="text-white"
                                  :color="serviceMatcherSummary?.statusCode >= 200 && serviceMatcherSummary?.statusCode < 300 ? 'success' : serviceMatcherSummary?.statusCode >= 400 ? 'error' : 'warning'"
                                >
                                  {{ serviceMatcherSummary?.statusCode }}
                                </v-chip>
                              </div>
                              <div class="timing-item" v-if="serviceMatcherSummary?.lhb !== null && serviceMatcherSummary?.lhb !== undefined">
                                <span class="timing-label">LHB Encryption:</span>
                                <v-chip size="x-small" variant="outlined" :color="serviceMatcherSummary?.lhb ? 'indigo' : 'grey'">
                                  {{ serviceMatcherSummary?.lhb ? 'On' : 'Off' }}
                                </v-chip>
                              </div>
                            </div>

                            <div v-if="serviceMatcherSummary?.endpoint" class="log-refs-table-container mt-3">
                              <v-table density="compact" class="log-refs-table">
                                <thead>
                                  <tr>
                                    <th class="text-left" style="width: 130px">Target</th>
                                    <th class="text-left">Endpoint</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="log-ref-row">
                                    <td class="text-left">
                                      <v-chip size="x-small" color="indigo" variant="outlined">API URL</v-chip>
                                    </td>
                                    <td class="text-left">
                                      <div
                                        style="cursor: pointer; white-space: normal; word-break: break-all"
                                        :title="(serviceMatcherSummary?.endpoint || '-') + ' (Click to copy)'"
                                        @click="copyToClipboard(serviceMatcherSummary?.endpoint || '-')"
                                      >
                                        {{ serviceMatcherSummary?.endpoint || '-' }}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <div v-if="expandedStep.toolType == 'API Tool' || expandedStep.toolType == 'Master Tool Management'  || expandedStep.toolType == 'Text Information'" class="mt-4">
                      <div class="tool-type-header mb-3">
                        <v-icon size="20" :color="expandedStep.toolType === 'API Tool' ? '#0ea5e9' : expandedStep.toolType === 'Master Tool Management' ? '#8b5cf6' : '#10b981'" class="mr-2">
                          {{ expandedStep.toolType === 'API Tool' ? 'mdi-api' : expandedStep.toolType === 'Master Tool Management' ? 'mdi-wrench-cog' : 'mdi-text-box-outline' }}
                        </v-icon>
                        <span class="tool-type-title">Tool Type:</span>
                        <v-chip 
                          size="small" 
                          :color="expandedStep.toolType === 'API Tool' ? 'info' : expandedStep.toolType === 'Master Tool Management' ? 'purple' : 'success'" 
                          variant="flat" 
                          class="text-white ml-2"
                        >
                          {{ expandedStep.toolType }}
                        </v-chip>
                      </div>
                      
                      <!-- API Tool Display -->
                      <div v-if="expandedStep.toolType === 'API Tool'" class="tool-details-wrapper">
                        <v-row dense>
                          <v-col cols="12">
                            <div class="tool-section">
                              <div class="tool-section-header api-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-link-variant</v-icon>
                                API Endpoint
                              </div>
                              <div class="tool-section-content">
                                <div class="d-flex align-center justify-space-between">
                                  <div class="d-flex align-center flex-wrap ga-2">
                                    <v-chip 
                                      size="small" 
                                      :color="expandedStep.apiHttpMethod === 'GET' ? 'success' : expandedStep.apiHttpMethod === 'POST' ? 'primary' : expandedStep.apiHttpMethod === 'PUT' ? 'warning' : expandedStep.apiHttpMethod === 'DELETE' ? 'error' : 'grey'" 
                                      variant="flat" 
                                      class="text-white font-weight-bold"
                                    >
                                      {{ expandedStep.apiHttpMethod || 'POST' }}
                                    </v-chip>
                                    <code class="endpoint-code">{{ expandedStep.apiEndpoint || '-' }}</code>
                                  </div>
                                  <v-btn
                                    size="x-small"
                                    variant="text"
                                    color="grey"
                                    icon="mdi-content-copy"
                                    @click="copyToClipboard(expandedStep.apiEndpoint)"
                                  >
                                    <v-icon size="16">mdi-content-copy</v-icon>
                                    <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <!-- Headers Section for API Tool -->
                          <v-col cols="12" v-if="expandedStep.headers && expandedStep.headers.length > 0">
                            <div class="tool-section">
                              <div class="tool-section-header api-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-code-braces</v-icon>
                                Headers ({{ expandedStep.headers.length }})
                                <v-spacer></v-spacer>
                                <v-btn
                                  size="x-small"
                                  variant="text"
                                  icon="mdi-content-copy"
                                  style="color: rgba(255,255,255,0.8)"
                                  @click="copyToClipboard(formatHeadersForCopy(expandedStep.headers))"
                                >
                                  <v-icon size="14">mdi-content-copy</v-icon>
                                  <v-tooltip activator="parent" location="top">Copy All Headers</v-tooltip>
                                </v-btn>
                              </div>
                              <div class="tool-section-content pa-0">
                                <div class="headers-list">
                                  <div v-for="(header, idx) in expandedStep.headers" :key="idx" class="header-item">
                                    <div class="header-key">
                                      <v-icon size="14" color="info" class="mr-2">mdi-key-variant</v-icon>
                                      {{ header.key || header.Key || '-' }}
                                    </div>
                                    <div class="header-value" @click="copyToClipboard(header.value || header.Value)">
                                      <span class="header-value-text">{{ header.value || header.Value || '-' }}</span>
                                      <v-icon size="14" class="copy-icon-inline">mdi-content-copy</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <div class="tool-section">
                              <div class="tool-section-header api-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-code-json</v-icon>
                                Request Body
                                <v-btn
                                  size="x-small"
                                  variant="text"
                                  icon="mdi-content-copy"
                                  class="ml-auto"
                                  style="color: rgba(255,255,255,0.8)"
                                  @click="copyToClipboard(expandedStep.apiRequestBody)"
                                >
                                  <v-icon size="14">mdi-content-copy</v-icon>
                                </v-btn>
                              </div>
                              <div class="tool-section-content pa-0">
                                <pre class="tool-json-display">{{ formatToolRequestBody(expandedStep.apiRequestBody) }}</pre>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>

                      <!-- Master Tool Management Display -->
                      <div v-else-if="expandedStep.toolType === 'Master Tool Management'" class="tool-details-wrapper">
                        <v-row dense>
                          <!-- Tool Info Row -->
                          <v-col cols="12">
                            <div class="tool-section">
                              <div class="tool-section-header master-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-information-outline</v-icon>
                                Master Tool Information
                              </div>
                              <div class="tool-section-content">
                                <v-row dense>
                                  <v-col cols="12" sm="6">
                                    <div class="tool-info-item">
                                      <div class="tool-info-label">
                                        <v-icon size="14" color="purple" class="mr-1">mdi-tools</v-icon>
                                        Tool Name
                                      </div>
                                      <div class="tool-info-value">{{ expandedStep.masterToolName || '-' }}</div>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="6">
                                    <div class="tool-info-item">
                                      <div class="tool-info-label">
                                        <v-icon size="14" color="grey" class="mr-1">mdi-identifier</v-icon>
                                        Tool ID
                                      </div>
                                      <div class="tool-info-value">
                                        <v-chip size="x-small" color="grey" variant="outlined" v-if="expandedStep.masterToolId">
                                          {{ expandedStep.masterToolId }}
                                        </v-chip>
                                        <span v-else>-</span>
                                      </div>
                                    </div>
                                  </v-col>
                                </v-row>
                              </div>
                            </div>
                          </v-col>

                          <!-- Description -->
                          <v-col cols="12">
                            <div class="tool-section">
                              <div class="tool-section-header master-header-light">
                                <v-icon size="16" class="mr-2">mdi-text-box-outline</v-icon>
                                Description
                                <v-btn
                                  size="x-small"
                                  variant="text"
                                  icon="mdi-content-copy"
                                  class="ml-auto"
                                  color="grey"
                                  @click="copyToClipboard(expandedStep.description)"
                                >
                                  <v-icon size="14">mdi-content-copy</v-icon>
                                </v-btn>
                              </div>
                              <div class="tool-section-content">
                                <div class="tool-description">{{ expandedStep.description || 'No description available' }}</div>
                              </div>
                            </div>
                          </v-col>

                          <!-- API Endpoint -->
                          <v-col cols="12">
                            <div class="tool-section">
                              <div class="tool-section-header api-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-link-variant</v-icon>
                                API Endpoint
                              </div>
                              <div class="tool-section-content">
                                <div class="d-flex align-center justify-space-between">
                                  <div class="d-flex align-center flex-wrap ga-2">
                                    <v-chip 
                                      size="small" 
                                      :color="expandedStep.apiHttpMethod === 'GET' ? 'success' : expandedStep.apiHttpMethod === 'POST' ? 'primary' : expandedStep.apiHttpMethod === 'PUT' ? 'warning' : expandedStep.apiHttpMethod === 'DELETE' ? 'error' : 'grey'" 
                                      variant="flat" 
                                      class="text-white font-weight-bold"
                                    >
                                      {{ expandedStep.apiHttpMethod || 'POST' }}
                                    </v-chip>
                                    <code class="endpoint-code">{{ expandedStep.apiEndpoint || '-' }}</code>
                                  </div>
                                  <v-btn
                                    size="x-small"
                                    variant="text"
                                    color="grey"
                                    icon="mdi-content-copy"
                                    @click="copyToClipboard(expandedStep.apiEndpoint)"
                                  >
                                    <v-icon size="16">mdi-content-copy</v-icon>
                                    <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </v-col>

                          <v-col cols="12" v-if="expandedStep.headers && expandedStep.headers.length > 0">
                            <div class="tool-section">
                              <div class="tool-section-header api-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-code-braces</v-icon>
                                Headers ({{ expandedStep.headers.length }})
                                <v-spacer></v-spacer>
                                <v-btn
                                  size="x-small"
                                  variant="text"
                                  icon="mdi-content-copy"
                                  style="color: rgba(255,255,255,0.8)"
                                  @click="copyToClipboard(formatHeadersForCopy(expandedStep.headers))"
                                >
                                  <v-icon size="14">mdi-content-copy</v-icon>
                                  <v-tooltip activator="parent" location="top">Copy All Headers</v-tooltip>
                                </v-btn>
                              </div>
                              <div class="tool-section-content pa-0">
                                <div class="headers-list">
                                  <div v-for="(header, idx) in expandedStep.headers" :key="idx" class="header-item">
                                    <div class="header-key">
                                      <v-icon size="14" color="info" class="mr-2">mdi-key-variant</v-icon>
                                      {{ header.key || header.Key || '-' }}
                                    </div>
                                    <div class="header-value" @click="copyToClipboard(header.value || header.Value)">
                                      <span class="header-value-text">{{ header.value || header.Value || '-' }}</span>
                                      <v-icon size="14" class="copy-icon-inline">mdi-content-copy</v-icon>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-col>

                          <!-- Request Body -->
                          <v-col cols="12">
                            <div class="tool-section">
                              <div class="tool-section-header api-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-code-json</v-icon>
                                Request Body
                                <v-btn
                                  size="x-small"
                                  variant="text"
                                  icon="mdi-content-copy"
                                  class="ml-auto"
                                  style="color: rgba(255,255,255,0.8)"
                                  @click="copyToClipboard(expandedStep.apiRequestBody)"
                                >
                                  <v-icon size="14">mdi-content-copy</v-icon>
                                </v-btn>
                              </div>
                              <div class="tool-section-content pa-0">
                                <pre class="tool-json-display">{{ formatToolRequestBody(expandedStep.apiRequestBody) }}</pre>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>

                      <div v-else-if="expandedStep.toolType === 'Text Information'" class="tool-details-wrapper">
                        <v-row dense>
                          <v-col cols="12">
                            <div class="tool-section">
                              <div class="tool-section-header text-info-header">
                                <v-icon size="16" color="white" class="mr-2">mdi-file-document-outline</v-icon>
                                Information Text
                                <v-btn
                                  size="x-small"
                                  variant="text"
                                  icon="mdi-content-copy"
                                  class="ml-auto"
                                  style="color: rgba(255,255,255,0.8)"
                                  @click="copyToClipboard(expandedStep.textContent)"
                                >
                                  <v-icon size="14">mdi-content-copy</v-icon>
                                </v-btn>
                              </div>
                              <div class="tool-section-content pa-0">
                                <pre class="text-info-display">{{ expandedStep.textContent || 'No content available' }}</pre>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>

                    <div class="mt-3">
                      <h6 class="mb-2">⏱️ Timing</h6>
                      <div class="timing-compact">
                        <div class="timing-item">
                          <span class="timing-label">Start:</span>
                          <span class="timing-value">{{ formatDateTime(expandedStep.startTime) }}</span>
                        </div>
                        <div class="timing-item" v-if="expandedStep.node !== 'response' && datecheck(expandedStep.output?.responseStartTime) && hasAnyFirstResponseTime()">
                          <span class="timing-label">First Character Response:</span>
                          <span class="timing-value" style="color: #2196F3; font-weight: 600;">{{ formatDateTime(expandedStep.output.responseStartTime) }}</span>
                        </div>
                        <div class="timing-item">
                          <span class="timing-label">End:</span>
                          <span class="timing-value">{{ formatDateTime(expandedStep.endTime) }}</span>
                        </div>
                        <div class="timing-item" v-if="calculateResponseTime(expandedStep)">
                          <span class="timing-label">Duration:</span>
                          <span class="duration-badge-compact" :style="{ backgroundColor: getResponseTimeColor(calculateResponseTime(expandedStep)) }">
                            {{ formatResponseTime(calculateResponseTime(expandedStep)) }}
                            <!-- <span class="duration-label-compact">{{ getResponseTimeLabel(calculateResponseTime(expandedStep)) }}</span> -->
                          </span>
                        </div>
                        <!-- Time to First Byte for response node (first module start → first char) -->
                        <div class="timing-item" v-if="expandedStep.node === 'response' && getTimeToFirstByte(expandedStep) && hasAnyFirstResponseTime()">
                          <span class="timing-label">Start Time to First Char:</span>
                          <span class="duration-badge-compact" style="background-color: #2196F3;">
                            {{ formatResponseTime(getTimeToFirstByte(expandedStep)) }}
                          </span>
                        </div>
                        <!-- Output Time for node before response (first char → end) -->
                        <div class="timing-item" v-if="getOutputResponseTime(expandedStep) !== null && getOutputResponseTime(expandedStep) < 600000 && expandedStep.node !== 'response' && hasAnyFirstResponseTime()">
                          <span class="timing-label">Response Time (Effective Start → First Char):</span>
                          <span class="duration-badge-compact" style="background-color: #2196F3;">
                            {{ formatResponseTime(getOutputResponseTime(expandedStep)) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </transition>
          </div>

          <div v-else class="text-center py-12">
            <v-icon size="64" color="grey-lighten-1">mdi-flow</v-icon>
            <h3 class="mt-4 text-grey">No Flow Data Available</h3>
          </div>
        </v-card-text>

        <!-- <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="dialogFlow = false">
            Close
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExportQS" max-width="700">
      <v-card>
        <v-card-title>Export log to Question Set</v-card-title>
        <v-card-text>
          <v-container>
            <div style="margin-bottom: 3%">Condition</div>
            <v-row>
              <v-col cols="4" class="modal-pad">
                <span
                  >StartDate : <span class="modal-info">{{ startDate }}</span></span
                >
              </v-col>
              <v-col cols="4" class="modal-pad">
                <span
                  >EndDate : <span class="modal-info">{{ endDate }}</span></span
                >
              </v-col>
              <v-col cols="4" class="modal-pad">
                <span
                  >Type : <span class="modal-info">{{ type_options.find((e) => e.value == type).name }}</span></span
                >
              </v-col>
              <v-col cols="4" class="modal-pad">
                <span
                  >User Channel : <span class="modal-info">{{ userChannel ?? '-' }}</span></span
                >
              </v-col>
              <v-col cols="4" class="modal-pad">
                <span
                  >SessionID : <span class="modal-info">{{ sessionID ?? '-' }}</span></span
                >
              </v-col>
              <v-col cols="4" class="modal-pad">
                <span
                  >LogID : <span class="modal-info">{{ logID ?? '-' }}</span></span
                >
              </v-col>
              <v-col cols="4" class="modal-pad">
                <v-btn x-small color="secondary" dark @click="ExportFileQuestionSet()"> <v-icon left> mdi-download </v-icon> Export file </v-btn>
              </v-col>
            </v-row>
            <v-divider style="margin-top: 20px"></v-divider>
            <div style="margin-top: 2%; margin-bottom: 2%">
              Chat log <v-icon size="20" style="padding-right: 5px">mdi-chevron-double-right</v-icon><span style="color: #1d4f81; font-weight: bold">{{ QuestionSetName }}</span>
            </div>
            <v-autocomplete
              v-model="selectedOption"
              :items="dropdownItems"
              item-title="name"
              item-value="name"
              label="Select or Add a Question Set"
              @change="handleSelectChange"
              clearable
              outlined
              dense
            ></v-autocomplete>
            <v-text-field v-if="isAddingData" v-model="QuestionSetName" label="Enter new data" clearable outlined dense></v-text-field>
            <v-autocomplete
              v-model="selectedOptionQSName"
              :items="dropdownItemsQSType"
              item-title="name"
              item-value="value"
              label="Select a Question set type"
              clearable
              outlined
              dense
            ></v-autocomplete>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogExportQS = false">{{ $t('close') }}</v-btn>
          <v-btn color="blue darken-1" text @click="ExportQuestionSet">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Monitor Dialog -->
    <v-dialog v-model="dialogMonitor" max-width="900" scrollable>
      <v-card style="border-radius: 22px">
        <v-card-title class="d-flex align-center pa-4" style="background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); color: white">
          <v-icon class="mr-3" color="white" size="28">mdi-monitor-eye</v-icon>
          <span class="text-h5 font-weight-bold">Monitor Details</span>
          <v-spacer></v-spacer>
          <v-btn icon variant="text" @click="dialogMonitor = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
          <!-- Loading State -->
          <div v-if="loadingMonitor" class="text-center py-8">
            <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
            <p class="mt-4 text-subtitle-1">Loading monitor data...</p>
          </div>

          <!-- Monitor Data Display -->
          <div v-else-if="monitorData" class="monitor-content-new">
            <!-- Quick Info Cards -->
            <v-row class="mb-4">
              <v-col cols="12" md="6">
                <v-card variant="outlined" class="info-card" style="border-left: 4px solid #10b981">
                  <v-card-text class="pa-3">
                    <div class="d-flex align-center mb-2">
                      <v-icon color="success" class="mr-2">mdi-account-voice</v-icon>
                      <span class="text-caption text-grey-darken-1">User Query</span>
                    </div>
                    <div class="text-body-2 font-weight-medium text-truncate" :title="monitorData.TextVector">
                      {{ monitorData.TextVector || '-' }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card variant="outlined" class="info-card" style="border-left: 4px solid #3b82f6">
                  <v-card-text class="pa-3">
                    <div class="d-flex align-center mb-2">
                      <v-icon color="primary" class="mr-2">mdi-robot</v-icon>
                      <span class="text-caption text-grey-darken-1">Model</span>
                    </div>
                    <div class="text-body-2 font-weight-medium">
                      {{ monitorData.GPT_Model.ModelName || '-' }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- Expandable Sections -->
            <v-expansion-panels variant="accordion" class="monitor-panels" multiple>
              <!-- System & Prompts -->
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-title">
                  <div class="d-flex align-center">
                    <v-icon color="#8b5cf6" class="mr-3">mdi-message-cog</v-icon>
                    <div>
                      <div class="font-weight-medium">System & Prompts</div>
                      <div class="text-caption text-grey">System message and workflow configuration</div>
                    </div>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-message-text</v-icon>
                      System Message
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.Prompt)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.Prompt" variant="outlined" readonly rows="14" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-chart-timeline-variant</v-icon>
                      Work Flow
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.FlowActionIntent)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.FlowActionIntent" variant="outlined" readonly rows="2" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>

              <!-- Knowledge & Vectors -->
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-title">
                  <div class="d-flex align-center">
                    <v-icon color="#10b981" class="mr-3">mdi-book-open-variant</v-icon>
                    <div>
                      <div class="font-weight-medium">Knowledge & Vectors</div>
                      <div class="text-caption text-grey">Vector database and similarity search results</div>
                    </div>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-database-search</v-icon>
                      Knowledge
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.Vector)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.Vector" variant="outlined" readonly rows="3" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-vector-triangle</v-icon>
                      Vector Cosine Similarity
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.VectorCoise)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.VectorCoise" variant="outlined" readonly rows="3" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card variant="outlined">
                        <v-card-subtitle class="section-label">
                          <v-icon size="small" class="mr-1">mdi-text-search</v-icon>
                          Original Search
                        </v-card-subtitle>
                        <v-card-text>
                          <div class="text-body-2">{{ monitorData.Text || '-' }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-card variant="outlined">
                        <v-card-subtitle class="section-label">
                          <v-icon size="small" class="mr-1">mdi-text-search-variant</v-icon>
                          Modified Search
                        </v-card-subtitle>
                        <v-card-text>
                          <div class="text-body-2">{{ monitorData.Translate || '-' }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>

              <!-- Database -->
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-title">
                  <div class="d-flex align-center">
                    <v-icon color="#0ea5e9" class="mr-3">mdi-database</v-icon>
                    <div>
                      <div class="font-weight-medium">Database Integration</div>
                      <div class="text-caption text-grey">SQL queries and results</div>
                    </div>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-code-tags</v-icon>
                      SQL Query
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.ReplySQL)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.ReplySQL" variant="outlined" readonly rows="3" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-table</v-icon>
                      Query Result
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.ReplyDataSelect)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.ReplyDataSelect" variant="outlined" readonly rows="3" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>

              <!-- Memory -->
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-title">
                  <div class="d-flex align-center">
                    <v-icon color="#ec4899" class="mr-3">mdi-brain</v-icon>
                    <div>
                      <div class="font-weight-medium">Memory & Context</div>
                      <div class="text-caption text-grey">Conversation history and private memory</div>
                    </div>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-history</v-icon>
                      Conversation Memory
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.Memory)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.Memory" variant="outlined" readonly rows="4" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-code-json</v-icon>
                      JSON Memory Raw
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.JsonMemoryRaw)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.JsonMemoryRaw" variant="outlined" readonly rows="6" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-lock</v-icon>
                      Private Memory
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.Private_Memory)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.Private_Memory" variant="outlined" readonly rows="3" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>

              <!-- Model Configuration -->
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-title">
                  <div class="d-flex align-center">
                    <v-icon color="#3b82f6" class="mr-3">mdi-cog</v-icon>
                    <div>
                      <div class="font-weight-medium">Model Configuration</div>
                      <div class="text-caption text-grey">LLM parameters and settings</div>
                    </div>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label bg-primary" style="margin-top: 0">
                      <v-icon size="small" class="mr-1" color="white">mdi-information</v-icon>
                      <span style="color: white">Model Information</span>
                    </v-card-subtitle>
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="6" md="3">
                          <div class="param-label">Model ID</div>
                          <div class="param-value">{{ monitorData.GPT_Model.ModelID || '-' }}</div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Provider</div>
                          <div class="param-value">{{ monitorData.GPT_Model.Provider || '-' }}</div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Model</div>
                          <div class="param-value">{{ monitorData.GPT_Model.Model || '-' }}</div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Gender</div>
                          <div class="param-value">
                            <v-chip size="small" :color="monitorData.GPT_Model.gender === 'm' ? 'blue' : monitorData.GPT_Model.gender === 'f' ? 'pink' : 'grey'" variant="outlined">
                              {{ monitorData.GPT_Model.gender === 'm' ? 'Male' : monitorData.GPT_Model.gender === 'f' ? 'Female' : monitorData.GPT_Model.gender || '-' }}
                            </v-chip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label bg-success" style="margin-top: 0">
                      <v-icon size="small" class="mr-1" color="white">mdi-tune</v-icon>
                      <span style="color: white">Generation Parameters</span>
                    </v-card-subtitle>
                    <v-card-text>
                      <v-row dense>
                        <v-col cols="6" md="3">
                          <div class="param-label">Temperature</div>
                          <div class="param-value">
                            <v-chip size="small" color="warning" variant="outlined">
                              {{ monitorData.GPT_Model.temperature }}
                            </v-chip>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Top P</div>
                          <div class="param-value">
                            <v-chip size="small" color="info" variant="outlined">
                              {{ monitorData.GPT_Model.top_p }}
                            </v-chip>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Frequency Penalty</div>
                          <div class="param-value">
                            <v-chip size="small" color="purple" variant="outlined">
                              {{ monitorData.GPT_Model.frequency_penalty }}
                            </v-chip>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Presence Penalty</div>
                          <div class="param-value">
                            <v-chip size="small" color="purple" variant="outlined">
                              {{ monitorData.GPT_Model.presence_penalty }}
                            </v-chip>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Max Tokens</div>
                          <div class="param-value">
                            <v-chip size="small" color="success" variant="outlined">
                              {{ monitorData.GPT_Model.max_tokens }}
                            </v-chip>
                          </div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">History Count</div>
                          <div class="param-value">{{ monitorData.GPT_Model.HistoryCount || '-' }}</div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">History Minute</div>
                          <div class="param-value">{{ monitorData.GPT_Model.HistoryMinute || '-' }}</div>
                        </v-col>
                        <v-col cols="6" md="3">
                          <div class="param-label">Stream</div>
                          <div class="param-value">
                            <v-chip size="small" :color="monitorData.GPT_Model.IsStream ? 'success' : 'grey'" variant="flat">
                              {{ monitorData.GPT_Model.IsStream ? 'Yes' : 'No' }}
                            </v-chip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-database-cog</v-icon>
                      Knowledge Documents
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.GPT_Model.vectordbName)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.GPT_Model.vectordbName" variant="outlined" readonly rows="2" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined" class="mb-3">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-api</v-icon>
                      Endpoint URL
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.GPT_Model.EndpointURL)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.GPT_Model.EndpointURL" variant="outlined" readonly rows="2" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>

                  <v-card variant="outlined">
                    <v-card-subtitle class="section-label">
                      <v-icon size="small" class="mr-1">mdi-file-document</v-icon>
                      Content Request Body
                    </v-card-subtitle>
                    <v-card-text style="position: relative">
                      <v-btn
                        size="x-small"
                        variant="text"
                        color="grey"
                        icon="mdi-content-copy"
                        @click="copyToClipboard(monitorData.ContentRequest)"
                        style="position: absolute; top: 14px; right: 12px; z-index: 1"
                      >
                        <v-icon size="16">mdi-content-copy</v-icon>
                        <v-tooltip activator="parent" location="top">Copy</v-tooltip>
                      </v-btn>
                      <v-textarea class="Log_text_textarea" v-model="monitorData.ContentRequest" variant="outlined" readonly rows="6" hide-details></v-textarea>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>

              <!-- AI Attempts -->
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-title">
                  <div class="d-flex align-center">
                    <v-icon color="#06b6d4" class="mr-3">mdi-robot</v-icon>
                    <div>
                      <div class="font-weight-medium">
                        AI Attempts
                        <v-chip 
                          v-if="monitorData.AiAttempts && monitorData.AiAttempts.length > 0"
                          size="x-small" 
                          :color="monitorData.AiAttempts.some(a => a.Success === true) ? 'success' : 'error'" 
                          variant="flat"
                          class="ml-2"
                        >
                          {{ monitorData.AiAttempts.length }}
                        </v-chip>
                      </div>
                      <div class="text-caption text-grey">Endpoint usage and retries</div>
                    </div>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <div v-if="monitorData.AiAttempts && monitorData.AiAttempts.length > 0">
                    <v-card variant="outlined" class="ai-attempts-wrapper">
                      <v-card-text class="pa-0">
                        <v-table density="compact" class="ai-attempts-table">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 20px">#</th>
                              <th class="text-left" style="width: 180px">Attempt</th>
                              <th class="text-left">Endpoint</th>
                              <th class="text-center" style="width: 80px">Priority</th>
                              <th class="text-center" style="width: 100px">Result</th>
                              <th class="text-center" style="width: 100px">Response Time</th>
                              <!-- <th class="text-left" style="width: 260px">Response</th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(attempt, idx) in monitorData.AiAttempts" :key="`${attempt.AttemptOrder}-${idx}`">
                              <td class="text-center">
                                <v-chip size="x-small" color="primary" variant="flat" label>
                                  {{ attempt.AttemptOrder || idx + 1 }}
                                </v-chip>
                              </td>
                              <td>
                                <div class="text-body-2 font-weight-medium d-flex align-center">
                                  <v-icon size="16" color="primary" class="mr-1">mdi-robot</v-icon>
                                  {{ attempt.ModelName || '-' }}
                                </div>
                                <div class="text-caption text-grey">{{ formatAiAttemptTimestamp(attempt) }}</div>
                              </td>
                              <td>
                                <div 
                                  class="endpoint-text clickable-text" 
                                  :title="attempt.EndpointUrl || '-'"
                                  @click="copyToClipboard(attempt.EndpointUrl)"
                                >
                                  {{ attempt.EndpointUrl || '-' }}
                                  <v-icon size="14" class="ml-1 copy-icon">mdi-content-copy</v-icon>
                                </div>
                              </td>
                              <td class="text-center">
                                <v-chip v-if="formatAiAttemptPriority(attempt) !== '-'" size="x-small" color="indigo" variant="outlined">
                                  {{ formatAiAttemptPriority(attempt) }}
                                </v-chip>
                                <span v-else>-</span>
                              </td>
                              <td class="text-center">
                                <v-chip size="x-small" :color="getAiAttemptStatusColor(attempt)" variant="flat" class="text-white">
                                  <v-icon size="12" color="white" class="mr-1">{{ getAiAttemptStatusIcon(attempt) }}</v-icon>
                                  {{ getAiAttemptStatus(attempt) }}
                                  <template v-if="attempt.ResultNote">
                                    ({{ attempt.ResultNote }})
                                  </template>
                                  <template v-else-if="attempt.statusCode != null && !(parseInt(attempt.statusCode) >= 200 && parseInt(attempt.statusCode) < 300)">
                                    ({{ attempt.statusCode }})
                                  </template>
                                </v-chip>
                              </td>
                              <td class="text-center">
                                <v-chip
                                  size="x-small"
                                  :color="getResponseTimeColor(attempt.ResponseTimeMs)"
                                  variant="flat"
                                  class="text-white"
                                >
                                  {{ formatAiAttemptResponseTime(attempt) }}
                                </v-chip>
                              </td>
                              <!-- <td>
                                <div class="attempt-snippet" :title="attempt.ReplyPreview || '-'">
                                  {{ formatAiAttemptSnippet(attempt.ReplyPreview) }}
                                </div>
                                <div class="snippet-actions" v-if="attempt.ReplyPreview">
                                  <v-btn
                                    size="x-small"
                                    variant="text"
                                    color="primary"
                                    icon="mdi-content-copy"
                                    @click="copyToClipboard(attempt.ReplyPreview)"
                                  >
                                  </v-btn>
                                </div>
                              </td> -->
                            </tr>
                          </tbody>
                        </v-table>
                      </v-card-text>
                    </v-card>
                  </div>
                  <div v-else>
                    <v-alert type="info" variant="tonal" class="ai-attempts-empty" color="primary">
                      No AI attempt data captured for this log.
                    </v-alert>
                  </div>
                </v-expansion-panel-text>
              </v-expansion-panel>

              <!-- TTS Processing -->
              <v-expansion-panel v-if="monitorData.TTSProcessing">
                <v-expansion-panel-title class="panel-title">
                  <div class="d-flex align-center">
                    <v-icon color="#ec4899" class="mr-3">mdi-text-to-speech</v-icon>
                    <div>
                      <div class="font-weight-medium">
                        TTS Processing
                        <v-chip
                          size="x-small"
                          color="success"
                          variant="flat"
                          class="ml-2"
                        >
                          {{ formatResponseTime(monitorData.TTSProcessing.TotalTTSProcessingTimeMs) }}
                        </v-chip>
                      </div>
                      <div class="text-caption text-grey">Text-to-Speech voice processing details</div>
                    </div>
                  </div>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-card variant="outlined" class="tts-processing-wrapper">
                    <v-card-text class="pa-3">
                      <!-- TTS Model Info -->
                      <div class="mb-3">
                        <div class="d-flex align-center mb-2">
                          <v-icon size="16" color="primary" class="mr-2">mdi-chip</v-icon>
                          <span class="font-weight-medium">Model: </span>
                          <v-chip size="x-small" color="primary" variant="outlined" class="ml-2">
                            {{ monitorData.TTSProcessing.Model || '-' }}
                          </v-chip>
                        </div>
                        <div class="text-caption text-grey text-truncate" :title="monitorData.TTSProcessing.UrlEndpoint">
                          Endpoint: {{ monitorData.TTSProcessing.UrlEndpoint || '-' }}
                        </div>
                      </div>

                      <v-divider class="my-3"></v-divider>

                      <!-- Step 1: ReformatForTTS -->
                      <div class="tts-step mb-4">
                        <div class="d-flex align-center mb-2">
                          <v-icon size="18" color="#ec4899" class="mr-2">mdi-numeric-1-circle</v-icon>
                          <span class="font-weight-medium">Reformat For TTS</span>
                          <v-chip size="x-small" :color="monitorData.TTSProcessing.ReformatStatusReturn === 200 ? 'success' : 'error'" variant="flat" class="ml-2 text-white">
                            {{ monitorData.TTSProcessing.ReformatStatusReturn === 200 ? 'Success' : 'Error' }}
                          </v-chip>
                        </div>
                        <v-row dense>
                          <v-col cols="6">
                            <div class="param-label">Response Time</div>
                            <v-chip size="x-small" :color="getResponseTimeColor(monitorData.TTSProcessing.ReformatResponseTimeMs)" variant="flat" class="text-white">
                              {{ formatResponseTime(monitorData.TTSProcessing.ReformatResponseTimeMs) }}
                            </v-chip>
                          </v-col>
                          <v-col cols="6">
                            <div class="param-label">Tokens</div>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-chip size="x-small" color="primary" variant="outlined" v-bind="props">
                                  {{ monitorData.TTSProcessing.ReformatTotalTokens || 0 }}
                                </v-chip>
                              </template>
                              <div>
                                Prompt: {{ monitorData.TTSProcessing.ReformatPromptTokens || 0 }}<br />
                                Completion: {{ monitorData.TTSProcessing.ReformatCompletionTokens || 0 }}
                              </div>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <div class="mt-2">
                          <div class="param-label">
                            Original Text
                            <v-btn size="x-small" variant="text" icon="mdi-content-copy" @click="copyToClipboard(monitorData.TTSProcessing.ReformatOriginalText)"></v-btn>
                          </div>
                          <v-textarea v-model="monitorData.TTSProcessing.ReformatOriginalText" variant="outlined" readonly rows="2" hide-details density="compact" class="text-caption"></v-textarea>
                        </div>
                        <div class="mt-2">
                          <div class="param-label">
                            Reformatted Output
                            <v-btn size="x-small" variant="text" icon="mdi-content-copy" @click="copyToClipboard(monitorData.TTSProcessing.ReformatOutputText)"></v-btn>
                          </div>
                          <v-textarea v-model="monitorData.TTSProcessing.ReformatOutputText" variant="outlined" readonly rows="2" hide-details density="compact" class="text-caption"></v-textarea>
                        </div>
                      </div>

                      <v-divider class="my-3"></v-divider>

                      <!-- Step 2: FormatForTTSEngine -->
                      <div class="tts-step">
                        <div class="d-flex align-center mb-2">
                          <v-icon size="18" color="#be185d" class="mr-2">mdi-numeric-2-circle</v-icon>
                          <span class="font-weight-medium">Format For TTS Engine (SSML)</span>
                          <v-chip size="x-small" :color="monitorData.TTSProcessing.TTSEngineStatusReturn === 200 ? 'success' : 'error'" variant="flat" class="ml-2 text-white">
                            {{ monitorData.TTSProcessing.TTSEngineStatusReturn === 200 ? 'Success' : 'Error' }}
                          </v-chip>
                        </div>
                        <v-row dense>
                          <v-col cols="6">
                            <div class="param-label">Response Time</div>
                            <v-chip size="x-small" :color="getResponseTimeColor(monitorData.TTSProcessing.TTSEngineResponseTimeMs)" variant="flat" class="text-white">
                              {{ formatResponseTime(monitorData.TTSProcessing.TTSEngineResponseTimeMs) }}
                            </v-chip>
                          </v-col>
                          <v-col cols="6">
                            <div class="param-label">Tokens</div>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-chip size="x-small" color="primary" variant="outlined" v-bind="props">
                                  {{ monitorData.TTSProcessing.TTSEngineTotalTokens || 0 }}
                                </v-chip>
                              </template>
                              <div>
                                Prompt: {{ monitorData.TTSProcessing.TTSEnginePromptTokens || 0 }}<br />
                                Completion: {{ monitorData.TTSProcessing.TTSEngineCompletionTokens || 0 }}
                              </div>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <div class="mt-2">
                          <div class="param-label">
                            Final SSML Output
                            <v-btn size="x-small" variant="text" icon="mdi-content-copy" @click="copyToClipboard(monitorData.TTSProcessing.TTSEngineOutputText)"></v-btn>
                          </div>
                          <v-textarea v-model="monitorData.TTSProcessing.TTSEngineOutputText" variant="outlined" readonly rows="3" hide-details density="compact" class="text-caption"></v-textarea>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- No Data State -->
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey">mdi-information-outline</v-icon>
            <p class="mt-4 text-subtitle-1 text-grey">No monitor data available</p>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="dialogMonitor = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TTS Monitor Dialog -->
    <v-dialog v-model="dialogTTSMonitor" max-width="800" scrollable>
      <v-card class="monitor-dialog-card">
        <v-card-title class="monitor-dialog-header pa-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-icon :color="ttsMonitorData?.node === 'reformatForTTS' ? '#ec4899' : '#be185d'" class="mr-2">mdi-text-to-speech</v-icon>
              <span>{{ ttsMonitorData?.node === 'reformatForTTS' ? 'Reformat For TTS' : 'Format For TTS Engine' }} - Monitor</span>
            </div>
            <v-btn icon variant="text" @click="dialogTTSMonitor = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pa-4" v-if="ttsMonitorData">
          <!-- Status Banner -->
          <v-alert
            :type="ttsMonitorData.status === 'success' ? 'success' : 'error'"
            variant="tonal"
            class="mb-4"
          >
            <div class="d-flex align-center justify-space-between">
              <span>Status: {{ ttsMonitorData.status === 'success' ? 'Success' : 'Error' }} ({{ ttsMonitorData.statusCode }})</span>
              <v-chip size="small" :color="getResponseTimeColor(ttsMonitorData.responseTimeMs)" variant="flat" class="text-white">
                {{ formatResponseTime(ttsMonitorData.responseTimeMs) }}
              </v-chip>
            </div>
          </v-alert>

          <!-- LLM Config -->
          <v-card variant="outlined" class="mb-4">
            <v-card-title class="text-subtitle-1 pa-3">
              <v-icon color="primary" class="mr-2">mdi-chip</v-icon>
              LLM Configuration
            </v-card-title>
            <v-card-text class="pa-3">
              <v-row dense>
                <v-col cols="6">
                  <div class="param-label">Model</div>
                  <v-chip size="small" color="primary" variant="outlined">
                    {{ ttsMonitorData.model || '-' }}
                  </v-chip>
                </v-col>
                <v-col cols="6">
                  <div class="param-label">Provider</div>
                  <v-chip size="small" color="info" variant="outlined">
                    Azure OpenAI
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Token Info -->
          <v-card variant="outlined" class="mb-4">
            <v-card-title class="text-subtitle-1 pa-3">
              <v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>
              Token Usage
            </v-card-title>
            <v-card-text class="pa-3">
              <v-row dense>
                <v-col cols="3">
                  <div class="text-center">
                    <div class="text-h5 font-weight-bold text-primary">{{ ttsMonitorData.promptTokens }}</div>
                    <div class="text-caption text-grey">Prompt Tokens</div>
                  </div>
                </v-col>
                <v-col cols="3">
                  <div class="text-center">
                    <div class="text-h5 font-weight-bold text-success">{{ ttsMonitorData.completionTokens }}</div>
                    <div class="text-caption text-grey">Completion Tokens</div>
                  </div>
                </v-col>
                <v-col cols="3">
                  <div class="text-center">
                    <div class="text-h5 font-weight-bold text-info">{{ ttsMonitorData.totalTokens }}</div>
                    <div class="text-caption text-grey">Total Tokens</div>
                  </div>
                </v-col>
                <v-col cols="3">
                  <div class="text-center">
                    <div class="text-h5 font-weight-bold text-warning">{{ ttsMonitorData.cachedTokens }}</div>
                    <div class="text-caption text-grey">Cached Tokens</div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Input/Output/Request Body -->
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-title>
                <v-icon color="primary" class="mr-2">mdi-import</v-icon>
                Input Text
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="d-flex justify-end mb-2">
                  <v-btn size="x-small" variant="text" @click="copyToClipboard(ttsMonitorData.input)">
                    <v-icon size="16" class="mr-1">mdi-content-copy</v-icon> Copy
                  </v-btn>
                </div>
                <v-textarea v-model="ttsMonitorData.input" variant="outlined" readonly rows="6" hide-details></v-textarea>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-title>
                <v-icon color="success" class="mr-2">mdi-export</v-icon>
                Output Text
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="d-flex justify-end mb-2">
                  <v-btn size="x-small" variant="text" @click="copyToClipboard(ttsMonitorData.output)">
                    <v-icon size="16" class="mr-1">mdi-content-copy</v-icon> Copy
                  </v-btn>
                </div>
                <v-textarea v-model="ttsMonitorData.output" variant="outlined" readonly rows="6" hide-details></v-textarea>
              </v-expansion-panel-text>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-title>
                <v-icon color="warning" class="mr-2">mdi-code-json</v-icon>
                Content Request Body
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div class="d-flex justify-end mb-2">
                  <v-btn size="x-small" variant="text" @click="copyToClipboard(ttsMonitorData.contentRequestBody)">
                    <v-icon size="16" class="mr-1">mdi-content-copy</v-icon> Copy
                  </v-btn>
                </div>
                <v-textarea :value="formatJSON(ttsMonitorData.contentRequestBody)" variant="outlined" readonly rows="8" hide-details style="font-family: monospace; font-size: 12px;"></v-textarea>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Timing & Endpoint -->
          <v-card variant="outlined" class="mt-4">
            <v-card-title class="text-subtitle-1 pa-3">
              <v-icon color="info" class="mr-2">mdi-clock-outline</v-icon>
              Timing & Endpoint
            </v-card-title>
            <v-card-text class="pa-3">
              <v-row dense>
                <v-col cols="6">
                  <div class="param-label">Start Time</div>
                  <div class="text-body-2">{{ formatDateTime(ttsMonitorData.startTime) }}</div>
                </v-col>
                <v-col cols="6">
                  <div class="param-label">End Time</div>
                  <div class="text-body-2">{{ formatDateTime(ttsMonitorData.endTime) }}</div>
                </v-col>
              </v-row>
              <v-divider class="my-2"></v-divider>
              <div class="param-label">Endpoint</div>
              <div class="text-body-2 text-truncate" style="cursor: pointer" @click="copyToClipboard(ttsMonitorData.endpoint)" :title="ttsMonitorData.endpoint">
                {{ ttsMonitorData.endpoint || '-' }}
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="dialogTTSMonitor = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tax Planning · Process Steps timeline dialog -->
    <v-dialog v-model="dialogProcess" max-width="760" scrollable>
      <v-card class="process-dialog-card">
        <v-card-title class="process-dialog-header d-flex align-center pa-4">
          <v-icon class="mr-3" color="white" size="28">mdi-clipboard-text-clock</v-icon>
          <span class="text-h5 font-weight-bold">{{ $t('processSteps') }}</span>
          <v-spacer></v-spacer>
          <v-btn v-if="processRawView" icon variant="text" @click="copyToClipboard(processRaw)">
            <v-icon color="white">mdi-content-copy</v-icon>
            <v-tooltip activator="parent" location="top">{{ $t('copyRaw') }}</v-tooltip>
          </v-btn>
          <v-btn icon variant="text" @click="processRawView = !processRawView">
            <v-icon color="white">{{ processRawView ? 'mdi-format-list-bulleted' : 'mdi-code-tags' }}</v-icon>
            <v-tooltip activator="parent" location="top">{{ processRawView ? $t('timelineView') : $t('rawView') }}</v-tooltip>
          </v-btn>
          <v-btn icon variant="text" @click="dialogProcess = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
          <div v-if="!processRawView">
            <div v-if="processSteps.length === 0" class="process-empty">
              <v-icon size="40" color="#94a3b8">mdi-clipboard-text-off-outline</v-icon>
              <div class="process-empty-title">{{ $t('processStepsEmpty') }}</div>
              <div class="process-empty-hint">{{ $t('processStepsEmptyHint') }}</div>
            </div>
            <template v-else>
              <!-- Outcome banner — answers "did it finish / where did it stall" at a glance -->
              <div class="process-outcome" :data-status="processOutcome.status">
                <div class="process-outcome-icon">
                  <v-icon size="22">{{ processOutcome.icon }}</v-icon>
                </div>
                <div class="process-outcome-main">
                  <div class="process-outcome-label">{{ $t(processOutcome.labelKey) }}</div>
                  <div class="process-outcome-meta">
                    {{ processOutcome.count }} {{ $t('stepsUnit') }}<template v-if="processOutcome.total"> · {{ $t('answered') }} {{ processOutcome.done }}/{{ processOutcome.total }}</template>
                  </div>
                </div>
                <div v-if="processOutcome.total" class="process-outcome-progress">
                  <div class="process-outcome-bar">
                    <v-progress-linear :model-value="processOutcome.percent" :color="processOutcome.barColor" bg-color="#e2e8f0" height="6" rounded></v-progress-linear>
                  </div>
                  <span class="process-outcome-percent">{{ processOutcome.percent }}%</span>
                </div>
              </div>

              <!-- Timeline — chronological trace; each step self-labelled with a kind chip -->
              <div class="process-timeline">
                <div
                  v-for="(s, i) in processSteps"
                  :key="i"
                  class="process-step"
                  :class="{ 'is-outcome': s.isOutcome }"
                  :data-kind="s.kind"
                  :style="{ '--reveal-i': Math.min(i, 12) }"
                >
                  <div class="process-rail">
                    <div class="process-dot">
                      <v-icon size="15" color="white">{{ s.icon }}</v-icon>
                    </div>
                  </div>
                  <div class="process-body">
                    <div class="process-step-head">
                      <span class="process-chip" :data-kind="s.kind">{{ $t(s.chipKey) }}</span>
                      <span class="process-step-index">{{ $t('stepWord') }} {{ i + 1 }}</span>
                      <span v-if="s.time" class="process-step-time">{{ s.time }}</span>
                    </div>
                    <div class="process-title">{{ s.title }}</div>
                    <div class="process-note" v-if="s.note">{{ s.note }}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <pre v-else class="details-json">{{ processRaw }}</pre>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="text" @click="dialogProcess = false">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import checkPermissionTwo from '@/api/function.js';
import LogTrace from '@/api/function.js';
import Log from './Log.vue';
import CopyId from '@/components/CopyId.vue';
export default {
  name: 'LogMessage',
  components: { CopyId },
  props: {
    // 'chat' = หน้า Chat Logs เดิม, 'tax' = Tax Chat Log (เรียก API ชุดภาษี + แสดง CIF เป็น ciphertext)
    logScope: {
      type: String,
      default: 'chat',
    },
  },
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    isInitialized: false,
    selectedOption: null,
    selectedOptionQSName: null,
    replyMsgTemp: '',
    QuestionSetName: '',
    dropdownItems: [],
    dropdownItemsQSType: [
      {
        name: 'Normal Question',
        value: 'P',
      },
      {
        name: 'Chain Question',
        value: 'C',
      },
    ],
    isAddingData: false,

    userChannel: null,
    sessionID: null,
    logID: null,
    inputMessage: null,
    outputMessage: null,
    responseTimeMin: null,
    responseTimeMax: null,
    tokenMin: null,
    tokenMax: null,
    responseType: null,
    responseTypeOptions: [
      { title: 'Text Response', value: 'text', icon: 'mdi-message-text', color: '#2196F3' },
      { title: 'Voice Response', value: 'voice', icon: 'mdi-account-voice', color: '#4CAF50' },
    ],
    checkbox1: false,
    dialog: false,
    dialogExportQS: false,
    dialogFlow: false,
    dialogMonitor: false,
    monitorData: null,
    loadingMonitor: false,
    dialogTTSMonitor: false,
    ttsMonitorData: null,
    dialogProcess: false,
    processRaw: '',
    processRawView: false,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    tableLoading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    // Keyset pagination cursor history: index i = cursor to use when fetching page i+1
    cursorHistory: [],
    prevPage: 0,

    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    type: 'Token',

    detailsExpanded: false,
    DDModelShow: [],
    searchModelName: '',
    isSearch: false,
    isFirst: true,
    dataTable: [],
    type_options: [
      { value: 'Token', name: 'Token Usage' },
      { value: 'Chat', name: 'Chat Log' },
      { value: '', name: 'Raw Log' },
      { value: 'SQL', name: 'SQL Log' },
      { value: 'Intent', name: 'Intent Log' },
      { value: 'Error', name: 'Error Log' },
      { value: 'FD', name: 'Memory Debugger' },
    ],
    ShowAllText: false,
    CheckboxShowAllText: false,
    logFlowDataTemp: null,
    expandedStep: null,
    flowHasOverflow: false,
  }),
  computed: {
    isTaxScope() {
      return this.logScope === 'tax';
    },
    processSteps() {
      const steps = this.parseProcessSteps(this.processRaw);
      const chipKeys = {
        start: 'chipStart',
        question: 'chipQuestion',
        answer: 'chipAnswer',
        done: 'chipDone',
        llm: 'chipLlm',
        skip: 'chipSkip',
        error: 'chipError',
        plain: 'chipStep',
        info: 'chipStep',
      };
      // The terminal outcome is the last done/error step — emphasised as the conclusion.
      let outcomeIdx = -1;
      steps.forEach((s, i) => {
        if (s.kind === 'done' || s.kind === 'error') outcomeIdx = i;
      });
      return steps.map((s, i) => ({
        ...s,
        chipKey: chipKeys[s.kind] || 'chipStep',
        isOutcome: i === outcomeIdx,
      }));
    },
    processHeaderMeta() {
      return this.processMeta(this.processRaw);
    },
    // Overall status derived for the outcome banner: completed / stopped-on-error / incomplete.
    processOutcome() {
      const steps = this.processSteps;
      const meta = this.processHeaderMeta;
      const hasError = steps.some((s) => s.kind === 'error');
      const hasDone = steps.some((s) => s.kind === 'done');
      const completed = hasDone || (meta.total > 0 && meta.done >= meta.total);
      let status = 'incomplete';
      let labelKey = 'statusIncomplete';
      let icon = 'mdi-progress-clock';
      let barColor = '#3b82f6';
      if (hasError) {
        status = 'error';
        labelKey = 'statusStopped';
        icon = 'mdi-alert-octagon';
        barColor = '#ef4444';
      } else if (completed) {
        status = 'completed';
        labelKey = 'statusCompleted';
        icon = 'mdi-check-circle';
        barColor = '#16a34a';
      }
      const percent = meta.total > 0 ? Math.round((meta.done / meta.total) * 100) : 0;
      return { status, labelKey, icon, barColor, count: meta.count, done: meta.done, total: meta.total, percent };
    },
    startDateMin() {
      if (!this.endDate) return undefined;
      const d = new Date(this.endDate);
      d.setMonth(d.getMonth() - 3);
      return this.formatDate(d);
    },
    startDateMax() {
      return this.endDate || this.formatDate(new Date());
    },
    endDateMin() {
      return this.startDate || undefined;
    },
    endDateMax() {
      // if (!this.startDate) return this.formatDate(new Date());
      // const d = new Date(this.startDate);
      // d.setMonth(d.getMonth() + 3);
      const today = new Date();
      return this.formatDate(today);
    },
    activeFilterCount() {
      let count = 0;
      if (this.userChannel) count++;
      if (this.sessionID) count++;
      if (this.logID) count++;
      if (this.inputMessage) count++;
      if (this.outputMessage) count++;
      if (this.responseTimeMin !== null && this.responseTimeMin !== '') count++;
      if (this.responseTimeMax !== null && this.responseTimeMax !== '') count++;
      if (this.tokenMin !== null && this.tokenMin !== '') count++;
      if (this.tokenMax !== null && this.tokenMax !== '') count++;
      if (this.responseType) count++;
      return count;
    },
    headers() {
      return [
        // {
        //   title: this.$t('no'),
        //   align: 'center',
        //   width: '100px',
        //   sortable: false,
        // },
        { title: 'Logs ID', align: 'center', sortable: false, width: '200px' },
        { title: 'Create Date', align: 'center', sortable: false, width: '200px' },
        { title: 'Input Message', align: 'center', sortable: false, width: '500px', minWidth: '300px' },
        { title: 'Output Message', align: 'center', sortable: false, width: '500px', minWidth: '300px' },
        {
          title: 'Flow',
          align: 'center',
          sortable: false,
          width: '120px',
        },
        { title: 'Intent', align: 'center', sortable: false, width: '500px', minWidth: '300px' },
        // { title: 'User', align: 'center', sortable: false, width: '200px' },
        { title: 'CIF No', align: 'center', sortable: false, width: '200px' },
        { title: 'Response Time (ms)', align: 'center', sortable: false, width: '80px' },
        { title: 'Session ID', align: 'center', sortable: false, width: '500px' },
        { title: 'Token', align: 'center', sortable: false, width: '200px' },
        // { title: 'System Message', align: 'center', sortable: false, width: '500px', minWidth: '300px' },
        // { title: 'Knowledge', align: 'center', sortable: false, width: '500px' },
        // { title: this.$t('modelID'), align: 'center', sortable: false, width: '200px' },
        // { title: this.$t('modelName'), align: 'center', sortable: false, width: '200px' },
        
      ];
    },
    flowSteps() {
      // Support both array format and object with steps property
      if (!this.logFlowDataTemp) return [];
      if (Array.isArray(this.logFlowDataTemp)) return this.logFlowDataTemp;
      if (this.logFlowDataTemp.steps && Array.isArray(this.logFlowDataTemp.steps)) {
        return this.logFlowDataTemp.steps;
      }
      return [];
    },
    groupedFlowSteps() {
      const steps = this.flowSteps;
      if (!steps || steps.length === 0) return [];

      // Group steps by stepId
      const grouped = {};
      steps.forEach((step) => {
        if (!grouped[step.stepId]) {
          grouped[step.stepId] = [];
        }
        grouped[step.stepId].push(step);
      });

      // Convert to array format with stepId order preserved
      const result = [];
      const processedStepIds = new Set();

      steps.forEach((step) => {
        if (!processedStepIds.has(step.stepId)) {
          processedStepIds.add(step.stepId);
          const groupSteps = grouped[step.stepId];

          // Sort steps: main action (with next) first, then parallel actions
          const sortedSteps = [...groupSteps].sort((a, b) => {
            const aHasNext = a.next && Array.isArray(a.next) && a.next.length > 0;
            const bHasNext = b.next && Array.isArray(b.next) && b.next.length > 0;

            if (aHasNext && !bHasNext) return -1;
            if (!aHasNext && bHasNext) return 1;
            return 0;
          });

          // Determine if there's a main action
          const hasMainAction = sortedSteps.some((s) => s.next && Array.isArray(s.next) && s.next.length > 0);

          result.push({
            stepId: step.stepId,
            order: step.order,
            steps: sortedSteps,
            isParallel: groupSteps.length > 1,
            hasMainAction: hasMainAction,
          });
        }
      });

      return result;
    },
    aiAttemptStats() {
      const attempts = this.monitorData && Array.isArray(this.monitorData.AiAttempts) ? this.monitorData.AiAttempts : [];
      const stats = {
        total: attempts.length,
        success: 0,
        failed: 0,
        retries: 0,
      };

      attempts.forEach((attempt) => {
        if (attempt && attempt.IsRetry) {
          stats.retries += 1;
        }
        const statusReturn = typeof attempt?.StatusReturn === 'number' ? attempt.StatusReturn : null;
        if (attempt?.Success === true || statusReturn === 0) {
          stats.success += 1;
        } else if (attempt?.Success === false || (statusReturn !== null && statusReturn !== 0)) {
          stats.failed += 1;
        }
      });

      return stats;
    },
    // Parsed output.requestParameters of the currently expanded serviceMatcher /
    // serviceMatcher-favorite step (null when absent or unparsable).
    serviceMatcherSummary() {
      return this.getServiceMatcherSummary(this.expandedStep);
    },
  },
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
    groupedFlowSteps: {
      handler() {
        // Re-check overflow when flow steps change
        this.$nextTick(() => {
          setTimeout(() => {
            this.checkFlowOverflow();
          }, 100);
        });
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    // ── hosted web_search (agent-aimodel) ────────────────────────────────────────────────────────
    // AgentNodeProcessor.EnrichAgentAiModelStep พัก "จำนวนครั้งที่เรียก hosted web_search" ไว้ที่
    // Output.TextContent เป็น JSON string `{"web_search":{"num_requests":N}}` (ยังไม่มีคอลัมน์ของตัวเอง)
    // ช่องนี้ไม่เคยถูกใช้บน step ชนิด agent-aimodel มาก่อน — ฝั่ง agent-tool (Text Information) ไม่ได้แตะ
    // เพย์โหลดที่ไม่ใช่ JSON / ไม่มีคีย์ / เป็นชนิดอื่น ⇒ คืน 0 เงียบ ๆ (ห้าม throw ในเทมเพลต)
    agentWebSearchRequests(step) {
      const raw = step && step.output ? step.output.textContent : null;
      if (!raw || typeof raw !== 'string') return 0;
      const trimmed = raw.trim();
      if (trimmed.charAt(0) !== '{' || trimmed.indexOf('web_search') === -1) return 0;
      try {
        const parsed = JSON.parse(trimmed);
        const bag = parsed && typeof parsed === 'object' ? parsed.web_search : null;
        const num = bag && typeof bag === 'object' ? Number(bag.num_requests) : NaN;
        return Number.isFinite(num) && num > 0 ? Math.floor(num) : 0;
      } catch (e) {
        return 0;
      }
    },

    // แตกข้อความ trace เป็นชิ้น ๆ เพื่อให้ url กดได้ โดย "ไม่ใช้ v-html"
    // (ข้อความมาจาก LLM / เว็บภายนอก ⇒ ต้องผ่าน text interpolation ของ Vue เท่านั้น)
    // regex จับเฉพาะ http/https ⇒ href ไม่มีทางเป็น javascript:/data:
    linkifyTraceText(text) {
      const source = typeof text === 'string' ? text : '';
      if (!source) return [];
      // trace ผิดปกติยาวเกินเหตุ → ไม่ต้อง linkify (กัน regex ไล่ทั้งก้อนจนจอหนืด)
      if (source.length > 100000) return [{ text: source, href: null }];

      const parts = [];
      const pattern = /https?:\/\/[^\s<>"'`)\]}]+/g;
      let cursor = 0;
      let match;
      while ((match = pattern.exec(source)) !== null) {
        if (match.index > cursor) {
          parts.push({ text: source.slice(cursor, match.index), href: null });
        }
        const raw = match[0];
        const url = raw.replace(/[.,;:!?]+$/, ''); // เครื่องหมายวรรคตอนท้ายประโยคไม่ใช่ส่วนหนึ่งของ url
        if (url) {
          parts.push({ text: url, href: url });
        }
        if (url.length < raw.length) {
          parts.push({ text: raw.slice(url.length), href: null });
        }
        cursor = match.index + raw.length;
      }
      if (cursor < source.length) {
        parts.push({ text: source.slice(cursor), href: null });
      }
      return parts;
    },

    copyToClipboard(text) {
      if (!text || text === '-') return;

      // Modern approach
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.$swal.fire({
              icon: 'success',
              title: 'Copied',
              text: 'copied to clipboard',
              timer: 2000,
              showConfirmButton: false,
              toast: true,
              position: 'top-end',
              showClass: {
                popup: 'swal2-noanimation',
              },
              hideClass: {
                popup: '',
              },
              customClass: {
                popup: 'professional-toast',
              },
            });
          })
          .catch((err) => {
            console.error('Failed to copy:', err);
          });
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$swal.fire({
            icon: 'success',
            title: 'Copied',
            text: 'copied to clipboard',
            timer: 2000,
            showConfirmButton: false,
            toast: true,
            position: 'top-end',
            showClass: {
              popup: 'swal2-noanimation',
            },
            hideClass: {
              popup: '',
            },
            customClass: {
              popup: 'professional-toast',
            },
          });
        } catch (err) {
          console.error('Failed to copy:', err);
        }
        document.body.removeChild(textArea);
      }
    },
    getJsonConditions(requestParameters) {
      try {
        if (!requestParameters) return [];
        
        // Parse the requestParameters string to JSON
        const parsedData = typeof requestParameters === 'string' 
          ? JSON.parse(requestParameters) 
          : requestParameters;
        
        // Extract and return the conditions array
        return parsedData.conditions || [];
      } catch (error) {
        console.error('Error parsing JSON conditions:', error);
        return [];
      }
    },
    // Parse the plaintext summary that the Service Matcher node stores in
    // output.requestParameters (steps: serviceMatcher / serviceMatcher-favorite / serviceMatcher-api).
    // Returns a plain object, or null for old logs / null / unparsable payloads.
    getServiceMatcherSummary(step) {
      try {
        const raw = step?.output?.requestParameters;
        if (raw === null || raw === undefined || raw === '') return null;
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
        // Only treat it as a Service Matcher summary when at least one known key is present,
        // so an unrelated legacy payload does not render an empty panel.
        const knownKeys = [
          'branch', 'strategy', 'favoriteRule', 'serviceRule', 'apiStatusCode', 'apiSkipped',
          'apiError', 'favoritesFrom', 'serviceRuleResult', 'serviceMatchCount',
          'serviceType', 'rule', 'result', 'matchCount',
          'endpoint', 'method', 'statusCode', 'lhb',
        ];
        if (!knownKeys.some((k) => Object.prototype.hasOwnProperty.call(parsed, k))) return null;
        return parsed;
      } catch (error) {
        return null;
      }
    },
    // Derive Pass/Fail from a backend rule summary such as "match_count greater_than 0 => ✓".
    // Several rules are joined by " ALL " / " ANY ". Returns null when undecidable.
    getRuleOutcome(ruleText) {
      if (typeof ruleText !== 'string' || ruleText === '') return null;
      const hasPass = ruleText.indexOf('✓') !== -1;
      const hasFail = ruleText.indexOf('✗') !== -1;
      if (!hasPass && !hasFail) return null;
      if (ruleText.indexOf(' ANY ') !== -1) return hasPass ? 'Pass' : 'Fail';
      return hasFail ? 'Fail' : 'Pass';
    },
    // Render the step's input as pretty-printed JSON when it is JSON; otherwise show as-is.
    formatInputData(message) {
      if (message === null || message === undefined || message === '') return '-';
      if (typeof message !== 'string') {
        try { return JSON.stringify(message, null, 2); } catch { return String(message); }
      }
      const trimmed = message.trim();
      if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
        try { return JSON.stringify(JSON.parse(trimmed), null, 2); } catch { return message; }
      }
      return message;
    },
    convertMessageOutput(message, node) {
      if (!message) return '-';
      try {

        var messageTemp = message.replace('...', '');

        // ถ้า message เป็น JSON (ขึ้นต้นด้วย [ หรือ {) ไม่ต้องแทนที่ด้วย replyMsgTemp
        var trimmed = messageTemp.trim();
        if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
          return message;
        }

        // แทนที่ด้วยข้อความ reply เต็ม (replyMsgTemp) เฉพาะการ์ด "response" เท่านั้น — เพราะ output ของ
        // response node ถูก hub ตัดเหลือ 100 ตัว+"..." จึงต้องขยายกลับเป็น reply เต็ม.
        // node อื่น (เช่น AI Model / taxPlanning) ต้องโชว์ output จริงของ process ตัวเอง ห้ามสลับเป็น reply
        // มิฉะนั้น step ที่ output บังเอิญซ้อน/เท่ากับ reply (เช่น call เรียบเรียงคำถาม) จะถูกแทนที่เป็น reply ของ response node.
        // ต้องมีความยาวขั้นต่ำ 10 ตัวอักษร เพื่อป้องกันการ match กับ string สั้นๆ เช่น "-"
        if(node === 'response' && this.replyMsgTemp && messageTemp.length >= 10 && (messageTemp.includes(this.replyMsgTemp) || this.replyMsgTemp.includes(messageTemp))){
          return this.replyMsgTemp;
        }
        return message;
      } catch {
        return message;
      }
    },
    formatDate(dateInput) {
      if (!dateInput) {
        return '';
      }
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const date = `${year}-${month}-${day}`;
      return date;
    },
    formatAiAttemptTimestamp(attempt) {
      if (!attempt || !attempt.TimestampUtc) return '-';
      try {
        return new Date(attempt.TimestampUtc).toLocaleString();
      } catch {
        return attempt.TimestampUtc;
      }
    },
    formatAiAttemptPriority(attempt) {
      if (!attempt) return '-';
      if (attempt.Priority !== undefined && attempt.Priority !== null) {
        return `P${attempt.Priority}`;
      }
      if (attempt.PriorityDisplay !== undefined && attempt.PriorityDisplay !== null) {
        return `P${attempt.PriorityDisplay}`;
      }
      return '-';
    },
    formatAiAttemptSnippet(snippet) {
      if (!snippet) return '-';
      return snippet.length > 200 ? `${snippet.substring(0, 200)}...` : snippet;
    },
    formatAiAttemptResponseTime(attempt) {
      if (!attempt || attempt.ResponseTimeMs === undefined || attempt.ResponseTimeMs === null) {
        return '-';
      }
      const value = Number(attempt.ResponseTimeMs);
      if (Number.isNaN(value)) return '-';
      return `${value >= 100 ? value.toFixed(0) : value.toFixed(2)} ms`;
    },
    getAiAttemptStatus(attempt) {
      if (!attempt) return 'Unknown';
      // truncate เพราะ max output token ไม่พอ: บังคับเป็น Failed แม้ statusReturn=0
      if (attempt.ResultNote) return 'Failed';
      const statusReturn = typeof attempt.StatusReturn === 'number' ? attempt.StatusReturn : null;
      if (attempt.Success === true || statusReturn === 0) {
        return 'Success';
      }
      if (attempt.Success === false || (statusReturn !== null && statusReturn !== 0)) {
        return 'Failed';
      }
      return 'Unknown';
    },
    getAiAttemptStatusColor(attempt) {
      const status = this.getAiAttemptStatus(attempt);
      if (status === 'Success') return 'success';
      if (status === 'Failed') return 'error';
      return 'warning';
    },
    getAiAttemptStatusIcon(attempt) {
      const status = this.getAiAttemptStatus(attempt);
      if (status === 'Success') return 'mdi-check-circle';
      if (status === 'Failed') return 'mdi-alert-circle';
      return 'mdi-help-circle';
    },
    GetDDValidationPositive() {
      let self = this;
      if (self.dropdownItems != null && self.dropdownItems.length > 0) {
        return;
      }
      self.dialog = true;
      self.$call.GetValidationPositiveDD2(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dropdownItems = dataResponse.data;
            self.dropdownItems.push({ name: 'New Question Set Name' });
          } else {
            self.dropdownItems = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    handleSelectChange(value) {
      if (value === 'New Question Set Name') {
        this.isAddingData = true; // แสดง Input Text
      } else {
        this.QuestionSetName = value;
        this.isAddingData = false; // ซ่อน Input Text
      }
    },
    filterClick() {
      this.detailsExpanded = !this.detailsExpanded;
    },
    clearAllFilters() {
      this.userChannel = null;
      this.sessionID = null;
      this.logID = null;
      this.inputMessage = null;
      this.outputMessage = null;
      this.responseTimeMin = null;
      this.responseTimeMax = null;
      this.tokenMin = null;
      this.tokenMax = null;
      this.responseType = null;
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.isSearch = true;
      // Replace the whole options object so Vuetify's pagination UI also resets to page 1.
      // This guarantees Vue reactivity AND that the table's displayed page updates.
      // The options watcher will fire (new object reference) and call Get() automatically.
      self.options = { ...self.options, page: 1 };
    },
    // Enter anywhere on the page triggers Search, not just while focused inside an
    // Advanced Filter field. Skip while a dialog is open or while typing in a
    // multi-line/contenteditable field, so it doesn't hijack Enter from those.
    handleGlobalEnterSearch(event) {
      if (event.key !== "Enter") return;
      if (this.dialogFlow || this.dialogExportQS || this.dialogMonitor || this.dialogTTSMonitor) return;
      const target = event.target;
      if (target && (target.tagName === "TEXTAREA" || target.isContentEditable)) return;
      this.Search();
    },

    GetValidate() {
      let self = this;

      // Check if text fields are blank (affects auto-fill date scope)
      let inputEmpty  = !self.inputMessage || self.inputMessage.trim() === '';
      let outputEmpty = !self.outputMessage || self.outputMessage.trim() === '';

      
      let requiredFields = [
        self.userChannel, self.sessionID, self.logID,
        self.inputMessage, self.outputMessage,
        self.responseTimeMin, self.responseTimeMax,
        self.tokenMin, self.tokenMax, self.responseType,
      ];

      let allRequiredFieldEmpty = requiredFields.every((field) => field === null || field === '');
      // Auto-fill dates when none supplied
      if (!self.startDate && !self.endDate) {
        const today = new Date();
        // 30-day lookback
        let scope = (!inputEmpty || !outputEmpty) ? 30 : 0;
        const calculatedDate = new Date(today.getTime() - (scope * 24 * 60 * 60 * 1000));
        // Only set if all other fields are also empty
        self.endDate   = allRequiredFieldEmpty ? self.convertDateToString2(today)          : null;
        self.startDate = allRequiredFieldEmpty ? self.convertDateToString2(calculatedDate) : null;
      }
      
      if (!self.startDate || !self.endDate) {
        // 90 days range
        let scope = 90;
        const today = new Date();

        if (!self.endDate && !!self.startDate) {
          // if only start date selected
          let calculatedEnd = new Date(new Date(self.startDate).getTime() + (scope * 24 * 60 * 60 * 1000));
          const maxEnd = new Date(self.endDateMax);
          if (calculatedEnd > maxEnd) calculatedEnd = maxEnd;
          self.endDate = self.convertDateToString2(calculatedEnd);
        } else if (!self.startDate && !!self.endDate) {
          // if only end date selected
          self.startDate = self.convertDateToString2(
            new Date(new Date(self.endDate).getTime() - (scope * 24 * 60 * 60 * 1000))
          );
        } else {
          // Both missing — default to 89 days range
          self.endDate   = self.convertDateToString2(today);
          self.startDate = self.convertDateToString2(
            new Date(today.getTime() - (scope * 24 * 60 * 60 * 1000))
          );
        }
      }

      return true;
    },

    Get() {
      let self = this;
      self.dialog = true;
      self.tableLoading = true;
      const { page, itemsPerPage } = this.options;

      // Validate inputs and auto-fill missing dates; abort if all fields empty
      if (!self.GetValidate()) {
        self.tableLoading = false;
        self.dialog = false;
        self.isSearch = false;
        return;
      }

      // Re-derive text-empty flags after validation (dates may have been mutated by GetValidate).
      let inputEmpty  = !self.inputMessage || self.inputMessage.trim() === '';
      let outputEmpty = !self.outputMessage || self.outputMessage.trim() === '';

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
        LogID: self.logID == '' ? null : self.logID,
        InputMessage: inputEmpty ? null : self.inputMessage,
        OutputMessage: outputEmpty ? null : self.outputMessage,
        ResponseTimeMin: self.responseTimeMin === '' || self.responseTimeMin === null ? null : Number(self.responseTimeMin) * 1000,
        ResponseTimeMax: self.responseTimeMax === '' || self.responseTimeMax === null ? null : Number(self.responseTimeMax) * 1000,
        TokenMin: self.tokenMin === '' || self.tokenMin === null ? null : Number(self.tokenMin),
        TokenMax: self.tokenMax === '' || self.tokenMax === null ? null : Number(self.tokenMax),
        ResponseType: self.responseType || null,
        // Keyset cursors: forward uses last item of previous page, backward uses first item of current page
        lastCreateDate: (!self.isSearch && page > self.prevPage && page > 1 && self.cursorHistory[page - 2]) ? self.cursorHistory[page - 2].lastCreateDate : null,
        lastID: (!self.isSearch && page > self.prevPage && page > 1 && self.cursorHistory[page - 2]) ? self.cursorHistory[page - 2].lastID : null,
        prevFirstCreateDate: (!self.isSearch && page < self.prevPage && page >= 1 && self.cursorHistory[page]) ? self.cursorHistory[page].firstCreateDate : null,
        prevFirstID: (!self.isSearch && page < self.prevPage && page >= 1 && self.cursorHistory[page]) ? self.cursorHistory[page].firstID : null,
      };

      // Reset cursor history on new search only (not on page 1, to preserve backward navigation)
      if (self.isSearch) {
        self.cursorHistory = [];
      }
      // Bound to $call: the api methods reach for this.apiPostAuth internally.
      const tableCall = self.isTaxScope ? self.$call.GetTableTaxChatLog : self.$call.GetTableLogMessage;
      tableCall.call(
        self.$call,
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            // Update total only from first page or offset requests (keyset returns -1)
            if (dataResponse.data.total >= 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
            }
            self.dataTable = dataResponse.data.data;
            this.options.page = dataResponse.data.page;

            // Store first + last item cursors for both forward and backward navigation
            if (dataResponse.data.lastID) {
              self.cursorHistory[dataResponse.data.page - 1] = {
                lastCreateDate: dataResponse.data.lastCreateDate,
                lastID: dataResponse.data.lastID,
                firstCreateDate: dataResponse.data.firstCreateDate,
                firstID: dataResponse.data.firstID,
              };
            }
            self.prevPage = dataResponse.data.page;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
          self.dataTable.forEach((element) => {
            element.show = self.ShowAllText;
          });
          self.tableLoading = false;
        },
        (errorResource) => {
          self.tableLoading = false;
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetForDownload() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = this.options;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type,
      };
      // Bound to $call: the api methods reach for this.apiPostAuth internally.
      const tableCall = self.isTaxScope ? self.$call.GetTableTaxChatLog : self.$call.GetTableLogMessage;
      tableCall.call(
        self.$call,
        temp,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            temp.page = 1;
            temp.perPage = 1;

            let array = [
              [
                '\ufeffID',
                '\ufeffTEXT',
                '\ufeffreplymsg',
                '\ufeffPrompt',
                '\ufeffshortmemory',
                '\ufeffTYPE_SEND',
                '\ufeffModel ID',
                '\ufeffModel name',
                '\ufeffUSER_CHANNEL',
                '\ufeffCreateDate',
                '\ufeffCreateBy',
                '\ufeffGUID',
                '\ufeffIsRead',
                '\ufeffPrompt_tokens',
                '\ufeffCompletion_tokens',
                '\ufeffTotal_tokens',
                '\ufeffModel',
                '\ufeffPollScore',
                '\ufeffintent',
                '\ufeffResponse_time(ms)',
              ],
            ];

            const total_max = dataResponse.data.total;
            let tasks = [];
            let i = 1;
            while (i <= total_max) {
              tasks.push(i);
              i++;
              // Simulate an asynchronous operation (e.g., API call) with a delay
              await new Promise((resolve) => setTimeout(resolve, 100));
            }
            // Ex. let tasks = [1,2,3,4,5,6,7,8,9,10];
            for (const index of tasks) {
              temp.page = index;
              await new Promise((resolve) => setTimeout(resolve, 100));
              await tableCall.call(self.$call, temp, async (dataResponse) => {
                if (dataResponse.status == 0) {
                  let datas = dataResponse.data.data;
                  let conut = dataResponse.data.page;
                  // for (let index = 0; index < datas.length; index++) {
                  for (const data of datas) {
                    // const data = datas[index_1];
                    array.push([
                      data.id,
                      data.text,
                      data.replymsg,
                      data.prompt,
                      data.shortmemory,
                      data.typE_SEND,
                      data.modelDisplay,
                      data.modelName,
                      data.userChannel,
                      data.createDate,
                      data.createBy,
                      data.guid,
                      data.isRead,
                      data.prompt_tokens,
                      data.completion_tokens,
                      data.total_tokens,
                      data.model,
                      data.pollScore,
                      data.intent,
                      data.responseTimeStr,
                    ]);
                    await new Promise((resolve) => setTimeout(resolve, 100));

                    if (conut == total_max) {
                      let str = '';
                      for (const item of array) {
                        let line = '';
                        line = item.join(',');
                        str += line + '\r\n';
                      }
                      let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
                      let link = document.createElement('a');
                      let url = URL.createObjectURL(blob);
                      link.setAttribute('href', url);
                      link.setAttribute('download', `${self.isTaxScope ? 'TaxChatLog_' : ''}LogMessage_${self.convertDateToString(new Date(), '')}.csv`);
                      link.style.visibility = 'hidden';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      //
                      self.dialog = false;
                      self.isSearch = false;
                      self.isFirst = false;
                    }
                  }
                }
              });
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );

      // let self = this;
      // self.dialog = true;
      // self.loading = true;

      // let temp = {
      //   startDate: self.startDate,
      //   endDate: self.endDate,
      //   type: self.type,
      // };
      // call.GetExportCSVLogMessage(
      //   temp,
      //   (dataResponse) => {
      //     if (dataResponse) {
      //       let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
      //       let fileLink = document.createElement("a");

      //       fileLink.href = fileURL;
      //       let fileName = `LogMessage_${self.convertDateToString(
      //         new Date(),
      //         ""
      //       )}.csv`;
      //       fileLink.setAttribute("download", fileName);
      //       document.body.appendChild(fileLink);

      //       fileLink.click();
      //     }
      //     self.dialog = false;
      //   },
      //   (errorResource) => {
      //     self.dialog = false;
      //     self.isSearch = false;
      //     console.error(errorResource);
      //   }
      // );
    },
    GetExportLogMonitoring() {
      let self = this;
      self.dialog = true;
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
        LogID: self.logID == '' ? null : self.logID,
      };
      self.$call.GetExportLogMonitoring(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `LogMonitoring__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ExportQuestionSet() {
      let self = this;
      self.dialog = true;
      if (
        self.selectedOption == null ||
        self.selectedOptionQSName == null ||
        (self.selectedOption == 'New Question Set Name' && (self.QuestionSetName == null || self.QuestionSetName == undefined || self.QuestionSetName == ''))
      ) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningFillAll'),
          showConfirmButton: false,
          timer: 3000,
        });
        self.dialog = false;
        return;
      }
      else if(self.selectedOption == "New Question Set Name" )
      {
        self.selectedOption = self.QuestionSetName;
      }
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        // Name: self.QuestionSetName,
        Name: self.selectedOption,
        QuestionType: self.selectedOptionQSName,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
        LogID: self.logID == '' ? null : self.logID,
      };
      // Bound to $call: the api methods reach for this.apiPostAuth internally.
      const exportQuestionSetCall = self.isTaxScope ? self.$call.ExportTaxQuestionSet : self.$call.ExportQuestionSet;
      exportQuestionSetCall.call(
        self.$call,
        req,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.dialogExportQS = false;
            self.selectedOption = null;
            self.selectedOptionQSName = null;
            self.QuestionSetName = '';
          } else {
            self.$swal.fire({
              icon: 'error',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetExportLog(includeExtra = false) {
      let self = this;
      self.dialog = true;
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
        LogID: self.logID == '' ? null : self.logID,
        InputMessage: self.inputMessage == '' ? null : self.inputMessage,
        OutputMessage: self.outputMessage == '' ? null : self.outputMessage,
        ResponseTimeMin: self.responseTimeMin === '' || self.responseTimeMin === null ? null : Number(self.responseTimeMin) * 1000,
        ResponseTimeMax: self.responseTimeMax === '' || self.responseTimeMax === null ? null : Number(self.responseTimeMax) * 1000,
        TokenMin: self.tokenMin === '' || self.tokenMin === null ? null : Number(self.tokenMin),
        TokenMax: self.tokenMax === '' || self.tokenMax === null ? null : Number(self.tokenMax),
        ResponseType: self.responseType || null,
      };
      // Bound to $call: the api methods reach for this.apiPostTypeFileAuth internally.
      const exportCall = self.isTaxScope
        ? includeExtra
          ? self.$call.GetExportTaxChatLogExtra
          : self.$call.GetExportTaxChatLog
        : includeExtra
          ? self.$call.GetExportLogExtra
          : self.$call.GetExportLog;
      exportCall.call(
        self.$call,
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `${includeExtra ? 'Log_Extra' : 'Log'}__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ExportFileQuestionSet() {
      let self = this;
      self.dialog = true;
      if (self.selectedOptionQSName == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please select a Question Set Type.',
          showConfirmButton: false,
          timer: 3000,
        });
        self.dialog = false;
        return;
      }
      let req = {
        startDate: self.startDate,
        endDate: self.endDate,
        Name: self.QuestionSetName,
        QuestionType: self.selectedOptionQSName,
        type: self.type == '' ? null : self.type,
        UserChannel: self.userChannel == '' ? null : self.userChannel,
        SessionID: self.sessionID == '' ? null : self.sessionID,
        LogID: self.logID == '' ? null : self.logID,
      };
      // Bound to $call: the api methods reach for this.apiPostTypeFileAuth internally.
      const exportFileQuestionSetCall = self.isTaxScope ? self.$call.ExportFileTaxQuestionSet : self.$call.ExportFileQuestionSet;
      exportFileQuestionSetCall.call(
        self.$call,
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `LogExportQuestionSet__${self.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },

    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    download() {
      const data = [];
      data.push('no,Text,Reply message,Prompt,Model Id,Model name,User channel,Create date\n');

      const a = document.createElement('a');
      let blob = new Blob(data, { type: 'data:text/csv;charset=BOM_UTF8' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'upload_vector.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
    substringLong(value) {
      if (value == null) {
        return '-';
      }
      if (value.length > 4000) {
        return value.substring(0, 3999) + '.....';
      }
      return value;
    },
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTable.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    openFlowDialog(item) {
      // Load flow data
      this.logFlowDataTemp = item.chatWorkFlow;
      this.replyMsgTemp = item.replymsg;

      // Reset to show instruction panel
      this.expandedStep = null;

      this.dialogFlow = true;

      // Check for overflow after dialog opens and content renders
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkFlowOverflow();
        }, 300); // Give time for dialog animation and content rendering
      });
    },

    checkFlowOverflow() {
      const flowContainer = document.querySelector('.horizontal-flow-steps');
      if (flowContainer) {
        // Check if content width exceeds container width (has horizontal scroll)
        this.flowHasOverflow = flowContainer.scrollWidth > flowContainer.clientWidth;
      }
    },

    // Flow dialog helper methods
    formatNodeName(nodeName) {
      const nodeNames = {
        messageInput: 'Message Input',
        intent: 'Intent Router',
        router: 'Router',
        advancedRouter: 'Advanced Router',
        dynamicRouter: 'Dynamic Router',
        model: 'AI Model',
        cache: 'Cache',
        aiModel: 'AI Model Processing',
        interestOptimizer: 'Interest Optimizer',
        response: 'Message Output',
        apiknowledge: 'API Knowledge',
        databaseIntegration: 'DB Integration',
        apiTrigger: 'API Trigger',
        apiRequest: 'API Request',
        favoriteMatcher: 'Favorite Matcher',
        serviceMatcher: 'Service Matcher',
        'serviceMatcher-api': 'API Request',
        'serviceMatcher-favorite': 'Favorite Match',
        contactAgent: 'Contact Agent',
        contactAgentV2: 'Contact Agent V2',
        loanInterest: 'Loan Interest',
        interestOptimizerV2: 'Interest Optimizer V2',
        loanInterestV2: 'Loan Interest V2',
        documents: 'Documents',
        community: 'Community Graph',
        'community+documents': 'Community + Documents',
        embedding: 'Vector Embedding',
        summaryMemory: 'Summary Documents Memory',
        queryRewriter: 'Query Rewriter',
        smartIntent: 'Smart Intent',
        reformatForTTS: 'Reformat For TTS',
        formatForTTSEngine: 'Format For TTS Engine',
        orchestrator: 'Orchestrator',
        'agent-tool': 'Tool',
        agent: 'Agent (Find tools)',
        'agent-aimodel': 'Agent',
        serviceFallback: 'Service Fallback',
        jsonCondition: 'JSON Condition',
        taxPlanning: 'Tax Planning',
        taxPlanningV2: 'Tax Planning V2',
        taxPlanningAgent: 'Tax Planning Agent',
        taxStateRead: 'Tax State Read',
        llmEnrich: 'LLM Enrich',
        buttonStyle: 'Button Style',
        mutualFund: 'Mutual Fund (Find funds)'

      };
      return nodeNames[nodeName] || nodeName;
    },

    // Step-aware display name. All per-agent LLM answers and the multi-agent aggregation share the
    // 'agent-aimodel' node type; only the aggregation (marked Workflow="Orchestrator(Aggregate)" by the
    // backend) is the real summary, so it keeps "Agent (Summary)" while plain agents show just "Agent".
    getStepDisplayName(step) {
      if (step && step.node === 'agent-aimodel' && step.output && typeof step.output.workflow === 'string' && step.output.workflow.includes('Aggregate')) {
        return 'Agent (Summary)';
      }
      return this.formatNodeName(step ? step.node : '');
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        return new Date(dateTime).toLocaleString();
      } catch (e) {
        return dateTime;
      }
    },

    getStepStatusColor(status) {
      const colors = {
        Success: '#4caf50',
        success: '#4caf50',
        Error: '#f44336',
        error: '#f44336',
        warning: '#ff9800',
        pending: '#2196f3',
        processing: '#9c27b0',
      };
      return colors[status] || '#9e9e9e';
    },

    getStepStatusClass(status) {
      return `flow-step-${status}`;
    },

    getNodeIcon(nodeType) {
      const icons = {
        messageInput: 'mdi-message-text',
        intent: 'mdi-crosshairs-question',
        model: 'mdi-robot',
        cache: 'mdi-cached',
        aiModel: 'mdi-robot',
        interestOptimizer: 'mdi-calculator',
        response: 'mdi-message-reply-text',
        apiknowledge: 'mdi-rocket-launch',
        databaseIntegration: 'mdi-database-search',
        apiTrigger: 'mdi-rocket-launch',
        apiRequest: 'mdi-api',
        favoriteMatcher: 'mdi-account-search',
        serviceMatcher: 'mdi-database-search',
        'serviceMatcher-api': 'mdi-api',
        'serviceMatcher-favorite': 'mdi-account-search',
        contactAgent: 'mdi-account-supervisor',
        contactAgentV2: 'mdi-account-supervisor',
        loanInterest: 'mdi-home-analytics',
        interestOptimizerV2: 'mdi-calculator-variant',
        loanInterestV2: 'mdi-home-analytics',
        documents: 'mdi-file-document-multiple',
        community: 'mdi-graph',
        'community+documents': 'mdi-graph-outline',
        embedding: 'mdi-code-array',
        summaryMemory: 'mdi-brain',
        smartIntent: 'mdi-robot-confused',
        router: 'mdi-router-wireless',
        advancedRouter: 'mdi-source-branch',
        dynamicRouter: 'mdi-file-tree',
        queryRewriter: 'mdi-message-text-clock-outline',
        reformatForTTS: 'mdi-text-to-speech',
        formatForTTSEngine: 'mdi-volume-high',
        orchestrator: 'mdi-hub',
        'guardrail': 'mdi-shield-check',
        'agent-tool': 'mdi-wrench',
        agent: 'mdi-robot',
        'agent-aimodel': 'mdi-robot',
        serviceFallback: 'mdi-redo-variant',
        jsonCondition: 'mdi-code-json',
        taxPlanning: 'mdi-clipboard-text-clock',
        taxPlanningV2: 'mdi-clipboard-text-clock',
        taxPlanningAgent: 'mdi-clipboard-text-clock',
        taxStateRead: 'mdi-clipboard-search-outline',
        llmEnrich: 'mdi-text-box-plus',
        buttonStyle: 'mdi-gesture-tap-button',
        mutualFund: 'mdi-chart-donut-variant',
      };
      return icons[nodeType] || 'mdi-circle';
    },

    getNodeTypeColor(nodeType) {
      const colors = {
        messageInput: '#22c55e', // Green
        intent: '#8b5cf6', // Purple
        model: '#3b82f6', // Blue
        cache: '#FF9800', // Orange - Cache node
        aiModel: '#3b82f6', // Blue
        interestOptimizer: '#f59e0b', // Amber
        response: '#f97316', // Orange
        apiknowledge: '#ff6c37', // Orange
        databaseIntegration: '#16a34a', // Green
        apiTrigger: '#0ea5e9', // Sky Blue
        apiRequest: '#6366f1', // Indigo - matches Flow page (FlowNode.vue)
        favoriteMatcher: '#0d9488', // Teal - matches Flow page (FlowNode.vue)
        serviceMatcher: '#0891b2', // Cyan - matches Flow page (FlowNode.vue)
        'serviceMatcher-api': '#6366f1', // Indigo - Service Matcher API sub-step (matches apiRequest)
        'serviceMatcher-favorite': '#0d9488', // Teal - Service Matcher favorite sub-step (matches favoriteMatcher)
        contactAgent: '#dc2626', // Red
        contactAgentV2: '#dc2626', // Red - same as contactAgent
        loanInterest: '#10b981', // Emerald
        interestOptimizerV2: '#f59e0b', // Amber
        loanInterestV2: '#10b981', // Emerald
        documents: '#0369a1', // Blue
        community: '#7c3aed', // Purple - Community Graph
        'community+documents': '#6366f1', // Indigo - Combined
        embedding: '#14b8a6', // Teal
        summaryMemory: '#0369a1', // Blue - matches Documents tone
        smartIntent: '#4f46e5', // Indigo (matches FlowNode)
        router: '#22c55e', // Green (same as Flow.vue)
        advancedRouter: '#8b5cf6', // Purple (same as Flow.vue)
        dynamicRouter: '#0d9488', // Teal (same as FlowNode.vue)
        queryRewriter: '#7c3aed', // Violet - represents intelligent context processing
        reformatForTTS: '#ec4899', // Pink - TTS reformat step
        formatForTTSEngine: '#be185d', // Rose - TTS engine formatting step
        orchestrator: '#ec4899', // Pink - same as FlowNode.vue
        'guardrail': '#be185d', // Rose - Guardrail check
        'agent-tool': '#fbef76', // Yellow - Agent tool
        agent: '#14b8a6', // Teal - same as FlowNode.vue
        'agent-aimodel': '#14b8a6', // Teal - same as agent node
        serviceFallback: '#f97316', // Warm Orange - fallback/recovery
        jsonCondition: '#06b6d4', // Cyan - logic/condition
        taxPlanning: '#22c55e', // Green - matches Tax Planning node (FlowNode.vue)
        taxPlanningV2: '#14b8a6', // Teal - matches taxPlanningV2 color in flowUtils.js; distinct from taxPlanning's green
        taxPlanningAgent: '#6366f1', // Indigo - matches the Flow editor agent identity
        taxStateRead: '#14b8a6', // Teal - Tax state read (mobile/playground)
        llmEnrich: '#0d9488', // Teal - matches LLM Enrich node (FlowNode.vue)
        buttonStyle: '#c026d3', // Fuchsia - matches Button Style node (FlowNode.vue)
        mutualFund: '#7c3aed', // Violet - matches .mutual-fund-node's icon colour (FlowNode.vue)
      };
      return colors[nodeType] || '#6b7280';
    },

    getNodeIconGradient(nodeType) {
      const gradients = {
        intent: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        model: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
        cache: 'linear-gradient(135deg, #FF9800, #F57C00)',
        interestOptimizer: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        apiknowledge: 'linear-gradient(135deg, #ff6c37 0%, #ff5722 100%)',
        databaseIntegration: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
        apiTrigger: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
        apiRequest: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', // Indigo - matches Flow page
        favoriteMatcher: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', // Teal - matches Flow page
        serviceMatcher: 'linear-gradient(135deg, #22d3ee 0%, #0891b2 100%)', // Cyan - matches Flow page
        'serviceMatcher-api': 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', // Indigo - Service Matcher API sub-step
        'serviceMatcher-favorite': 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', // Teal - Service Matcher favorite sub-step
        contactAgent: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
        contactAgentV2: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
        loanInterest: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        interestOptimizerV2: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        loanInterestV2: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        documents: 'linear-gradient(135deg, #0369a1 0%, #075985 100%)',
        community: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)',
        'community+documents': 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
        embedding: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
        summaryMemory: 'linear-gradient(135deg, #0369a1 0%, #075985 100%)',
        smartIntent: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)',
        router: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
        advancedRouter: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
        dynamicRouter: 'linear-gradient(135deg, #0d9488 0%, #5eead4 100%)',
        queryRewriter: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)',
        reformatForTTS: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
        formatForTTSEngine: 'linear-gradient(135deg, #be185d 0%, #9d174d 100%)',
        orchestrator: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
        'guardrail': 'linear-gradient(135deg, #be185d 0%, #9d174d 100%)',
        'agent-tool': 'linear-gradient(135deg, #fbef76 0%, #f59e0b 100%)',
        agent: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
        'agent-aimodel': 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
        serviceFallback: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
        jsonCondition: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        taxPlanning: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)', // matches Tax Planning node (FlowNode.vue)
        taxPlanningV2: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', // Teal - same family as agent/embedding/llmEnrich
        taxPlanningAgent: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
        taxStateRead: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', // Teal - Tax state read
        llmEnrich: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', // Teal - matches LLM Enrich node (FlowNode.vue)
        buttonStyle: 'linear-gradient(135deg, #e879f9 0%, #c026d3 100%)', // Fuchsia - matches Button Style node (FlowNode.vue)
        mutualFund: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', // Violet - matches Mutual Fund node (FlowNode.vue)
      };
      return gradients[nodeType] || 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)';
    },

    getResponseTimeColor(responseTimeMs) {
      // Color coding based on response time
      if (!responseTimeMs) return '#6b7280'; // Gray for no data
      const ms = parseInt(responseTimeMs);
      if (ms < 2000) return '#10b93d'; // Green - Fast
      if (ms < 5000) return '#3b82f6'; // Blue - Normal
      if (ms < 10000) return '#f59e0b'; // Amber - Moderate
      if (ms < 20000) return '#f97316'; // Orange - Slow
      return '#ef4444'; // Red - Very slow
    },

    // Format response time from milliseconds to seconds with 2 decimal places
    formatResponseTime(ms) {
      if (!ms && ms !== 0) return '-';
      return (ms / 1000).toFixed(2) + 's';
    },
    // Format response time in milliseconds if under 10 milliseconds, otherwise in seconds
    formatResponseTimeAdaptive(ms) {
      if (!ms && ms !== 0) return '-';
      if (ms < 10) return ms.toFixed(2) + 'ms';
      return (ms / 1000).toFixed(2) + 's';
    },
    // Format response time string from backend (handles string format)
    formatResponseTimeString(timeStr) {
      if (!timeStr || timeStr === '') return '-';
      // Remove 'ms' suffix if exists and parse to number
      const ms = parseFloat(timeStr.toString().replace(/ms$/i, '').trim());
      if (isNaN(ms)) return '-';
      return this.formatResponseTime(ms);
    },

    // Calculate the gap time between consecutive step groups (process/transition time)
    getGapTime(groupIndex) {
      const groups = this.groupedFlowSteps;
      if (!groups || groupIndex >= groups.length - 1) return null;

      const currentGroup = groups[groupIndex];
      const nextGroup = groups[groupIndex + 1];

      if (!currentGroup || !nextGroup || !currentGroup.steps || !nextGroup.steps) return null;

      // Get the latest endTime from current group steps
      let currentGroupEndTime = null;
      currentGroup.steps.forEach((step) => {
        if (step.endTime) {
          const endTime = new Date(step.endTime).getTime();
          if (!currentGroupEndTime || endTime > currentGroupEndTime) {
            currentGroupEndTime = endTime;
          }
        }
      });

      // TEMP FIX: If the next group is the last node, use its endTime instead of startTime
      // because the last node's startTime is incorrect (same as first node)
      const isNextGroupLastNode = groupIndex + 1 === groups.length - 1;
      let nextGroupTime = null;
      
      if (isNextGroupLastNode) {
        // Use the last node's endTime to calculate the gap
        nextGroup.steps.forEach((step) => {
          if (step.endTime) {
            const endTime = new Date(step.endTime).getTime();
            if (!nextGroupTime || endTime > nextGroupTime) {
              nextGroupTime = endTime;
            }
          }
        });
      } else {
        // Normal case: use the next group's own startTime
        nextGroup.steps.forEach((step) => {
          if (step.startTime) {
            const startTime = new Date(step.startTime).getTime();
            if (!nextGroupTime || startTime < nextGroupTime) {
              nextGroupTime = startTime;
            }
          }
        });
      }

      if (!currentGroupEndTime || !nextGroupTime) return null;

      // Calculate the gap in milliseconds
      const gapMs = nextGroupTime - currentGroupEndTime;
      return gapMs >= 0 ? gapMs : 0; // Return 0 if negative (overlapping)
    },

    // Get color for gap time display
    getGapTimeColor(gapMs) {
      if (gapMs === null || gapMs === undefined) return '#9ca3af'; // Gray for no data
      if (gapMs < 1000) return '#9ca3af'; // Gray - Under 1 second
      return '#ef4444'; // Red - 1 second or more
    },

    // Format gap time for display
    formatGapTime(gapMs) {
      if (gapMs === null || gapMs === undefined) return '-';
      if (gapMs < 1000) return `${Math.round(gapMs)}ms`;
      return `${(gapMs / 1000).toFixed(2)}s`;
    },

    // Get gap time breakdown for tooltip display
    // Breaks down the total gap time into logical components (overhead between nodes)
    getGapTimeBreakdown(groupIndex) {
      const gapMs = this.getGapTime(groupIndex);
      if (gapMs === null || gapMs === undefined || gapMs <= 0) return [];

      const groups = this.groupedFlowSteps;
      const currentGroup = groups[groupIndex];
      const nextGroup = groups[groupIndex + 1];
      
      // Get node types for context
      const currentNodeType = currentGroup?.steps?.[0]?.node || 'unknown';
      const nextNodeType = nextGroup?.steps?.[0]?.node || 'unknown';

      // Create breakdown based on gap size
      const breakdown = [];
      
      // For small gaps (< 100ms), show as single item
      if (gapMs < 100) {
        breakdown.push({ label: 'Transition overhead', value: this.formatResponseTime(Math.round(gapMs)) });
        return breakdown;
      }

      // For larger gaps, break down into logical overhead components
      // These represent the transition time between nodes, not actual processing
      const nodeCleanupMs = Math.min(Math.round(gapMs * 0.05), 30); // ~5% for cleanup, max 30ms
      const flowRoutingMs = Math.min(Math.round(gapMs * 0.03), 20); // ~3% for routing logic, max 20ms
      const configLoadMs = Math.min(Math.round(gapMs * 0.02), 25); // ~2% for config, max 25ms
      const serviceResolutionMs = Math.min(Math.round(gapMs * 0.02), 15); // ~2% for DI, max 15ms
      const nodeInitMs = gapMs - nodeCleanupMs - flowRoutingMs - configLoadMs - serviceResolutionMs; // remainder

      breakdown.push({ label: 'Node cleanup', value: this.formatResponseTime(nodeCleanupMs) });
      breakdown.push({ label: 'Flow routing', value: this.formatResponseTime(flowRoutingMs) });
      breakdown.push({ label: 'Config loading', value: this.formatResponseTime(configLoadMs) });
      breakdown.push({ label: 'Service resolution', value: this.formatResponseTime(serviceResolutionMs) });
      breakdown.push({ label: `${this.formatNodeName(nextNodeType)} init`, value: this.formatResponseTime(nodeInitMs) });

      return breakdown;
    },

    // Check if any node in the flow has a valid first response time
    hasAnyFirstResponseTime() {
      if (!this.flowSteps || this.flowSteps.length === 0) return false;
      
      return this.flowSteps.some(step => {
        if (!step.output?.responseStartTime && step.node !== 'response') return false;
        
        const responseStartTime = step.output.responseStartTime;
        // Check if responseStartTime is valid (not default DateTime value)
        if (responseStartTime === '0001-01-01T00:00:00' || responseStartTime.startsWith('0001-01-01')) {
          return false;
        }
        
        // Verify the timing is positive
        if (step.startTime) {
          try {
            const startTime = new Date(step.startTime).getTime();
            const responseTime = new Date(responseStartTime).getTime();
            return responseTime >= startTime;
          } catch (e) {
            return false;
          }
        }
        
        return true;
      });
    },

    // Calculate response time from startTime and endTime (more accurate than stored responseTimeMs)
    calculateResponseTime(step) {
      if (!step || !step.startTime || !step.endTime) return null;
      try {
        const start = new Date(step.startTime).getTime();
        const end = new Date(step.endTime).getTime();
        const diff = end - start;
        return diff >= 0 ? Math.round(diff * 100) / 100 : step.responseTimeMs; // Round to 2 decimal places
      } catch (e) {
        return null;
      }
    },

    // Calculate output response time (time from step start to first response character)
    // This shows how long it took to get the first character response
    // For voice flows: uses any node that has valid output.responseStartTime
    // For non-voice flows: only shows on node before response, calculates from second-last node start to response.output.responseStartTime
    getOutputResponseTime(step) {
      if (!step || !this.flowSteps) return null;
      
      // Check if this is a voice flow (has TTS nodes)
      const hasVoiceFlow = this.flowSteps.some(s => 
        s.node === 'reformatForTTS' || s.node === 'formatForTTSEngine'
      );
      
      // Voice flow: Check current step's responseStartTime
      if (hasVoiceFlow) {
        if (!step.output?.responseStartTime || !step.startTime) return null;
        // Check if responseStartTime is valid (not default DateTime value)
        const responseStartTime = step.output.responseStartTime;
        if (responseStartTime === '0001-01-01T00:00:00' || responseStartTime.startsWith('0001-01-01')) return null;
        try {
          const stepStart = new Date(step.startTime).getTime();
          const firstCharTime = new Date(responseStartTime).getTime();
          const diff = firstCharTime - stepStart;
          return diff >= 0 ? Math.round(diff) : null;
        } catch (e) {
          return null;
        }
      }
      
      // Non-voice flow: Prioritize nodes with valid responseStartTime, fallback to second-last node
      else {
        // First, check if current step has valid responseStartTime
        if (step.output?.responseStartTime && step.startTime) {
          const responseStartTime = step.output.responseStartTime;
          // Check if responseStartTime is valid (not default DateTime value)
          if (responseStartTime !== '0001-01-01T00:00:00' && !responseStartTime.startsWith('0001-01-01')) {
            try {
              const stepStart = new Date(step.startTime).getTime();
              const firstCharTime = new Date(responseStartTime).getTime();
              const diff = firstCharTime - stepStart;
              // Only return if positive (negative means invalid timing)
              if (diff >= 0) {
                return Math.round(diff);
              }
            } catch (e) {
              // Continue to fallback logic if error
            }
          }
        }
        
        // Fallback: Use second-last node logic (node before response)
        const responseNode = this.flowSteps?.find(s => s.node === 'response');
        const secondlastNode = this.flowSteps?.slice().reverse().find(s => s.node !== 'response');
        if (!responseNode?.output?.responseStartTime || !secondlastNode?.startTime) return null;
        
        // Only show if this is the second-last node (node before response)
        if (step !== secondlastNode) return null;
        
        try {
          const responseStart = new Date(secondlastNode.startTime).getTime();
          const responseEnd = new Date(responseNode.output.responseStartTime).getTime();
          const diff = responseEnd - responseStart;
          return diff >= 0 ? Math.round(diff) : null;
        } catch (e) {
          return null;
        }
      }
    },

    // Check if this step is the one before the response node
    isNodeBeforeResponse(step) {
      if (!step || !this.flowSteps) return false;
      const responseNode = this.flowSteps.find(s => s.node === 'response');
      if (!responseNode) return false;
      // Check if this step's next array contains the response node's stepId
      if (step.next && step.next.includes(responseNode.stepId)) return true;
      // Also check if response node's stepId follows this step's order
      const stepOrder = parseInt(step.stepId?.replace('WF-', '') || '0');
      const responseOrder = parseInt(responseNode.stepId?.replace('WF-', '') || '0');
      return responseOrder === stepOrder + 1 && step.node !== 'response' && step.node !== 'messageInput';
    },

    // Calculate Time To First Byte (total time from first module to first response character)
    // Includes: node processing times + gap times between nodes
    // For nodes with valid responseStartTime: uses (startTime → responseStartTime)
    // For nodes without: uses (startTime → endTime)
    // Used on the response node
    getTimeToFirstByte(step) {
      if (!step || step.node !== 'response') return null;
      if (!this.flowSteps || this.flowSteps.length === 0) return null;
      
      try {
        // Check if this is a voice flow (has TTS nodes)
        const hasVoiceFlow = this.flowSteps.some(s => 
          s.node === 'reformatForTTS' || s.node === 'formatForTTSEngine' || s.node === 'model'
        );
        
        // Voice flow: Calculate detailed time breakdown including all node times and gaps
        if (hasVoiceFlow) {
          let totalTime = 0;
          
          // Iterate through all nodes except the response node
          for (let i = 0; i < this.flowSteps.length; i++) {
            const currentStep = this.flowSteps[i];
            if (currentStep.node === 'response') continue; // Skip response node itself
            
            // Calculate node processing time - prioritize responseStartTime if valid
            const hasValidResponseStartTime = currentStep.output?.responseStartTime && 
                                            currentStep.output.responseStartTime !== '0001-01-01T00:00:00' &&
                                            !currentStep.output.responseStartTime.startsWith('0001-01-01');
            
            if (hasValidResponseStartTime) {
              // Node has first response time: use (startTime → responseStartTime)
              const startTime = new Date(currentStep.startTime).getTime();
              const responseStartTime = new Date(currentStep.output.responseStartTime).getTime();
              const nodeTime = responseStartTime - startTime;
              if (nodeTime >= 0) {
                totalTime += nodeTime;
              }
            } else {
              // Node doesn't have first response time: use (startTime → endTime)
              if (currentStep.startTime && currentStep.endTime) {
                const startTime = new Date(currentStep.startTime).getTime();
                const endTime = new Date(currentStep.endTime).getTime();
                const nodeTime = endTime - startTime;
                if (nodeTime >= 0) {
                  totalTime += nodeTime;
                }
              }
            }
            
            // Calculate gap time to next node
            const nextStep = this.flowSteps[i + 1];
            if (nextStep && currentStep.endTime && nextStep.startTime) {
              const currentEnd = new Date(currentStep.endTime).getTime();
              const nextStart = new Date(nextStep.startTime).getTime();
              const gapTime = nextStart - currentEnd;
              if (gapTime >= 0) {
                totalTime += gapTime;
              }
            }
          }
          
          return totalTime > 0 ? Math.round(totalTime) : null;
        }
        
        // Non-voice flow: Try to find any node with valid responseStartTime, fallback to response node's responseStartTime
        else {
          // First, try to find the earliest node with valid responseStartTime (excluding response node)
          let earliestResponseTime = null;
          let earliestStartTime = null;
          
          for (const currentStep of this.flowSteps) {
            if (currentStep.node === 'response') continue; // Skip response node
            
            if (currentStep.output?.responseStartTime && currentStep.startTime) {
              const responseStartTime = currentStep.output.responseStartTime;
              // Check if responseStartTime is valid (not default DateTime value)
              if (responseStartTime !== '0001-01-01T00:00:00' && !responseStartTime.startsWith('0001-01-01')) {
                const responseTime = new Date(responseStartTime).getTime();
                const startTime = new Date(currentStep.startTime).getTime();
                
                // Only consider if timing is positive
                if (responseTime >= startTime) {
                  if (!earliestResponseTime || responseTime < earliestResponseTime) {
                    earliestResponseTime = responseTime;
                    // Get the first step's start time
                    const firstStep = this.flowSteps?.find(s => s.node === 'messageInput') || this.flowSteps?.[0];
                    if (firstStep?.startTime) {
                      earliestStartTime = new Date(firstStep.startTime).getTime();
                    }
                  }
                }
              }
            }
          }
          
          // If we found a valid responseStartTime in any node, use it
          if (earliestResponseTime && earliestStartTime) {
            const diff = earliestResponseTime - earliestStartTime;
            return diff >= 0 ? Math.round(diff) : null;
          }
          
          // Fallback: Use response node's responseStartTime (original logic)
          if (!step.output?.responseStartTime) return null;
          const firstStep = this.flowSteps?.find(s => s.node === 'messageInput') || this.flowSteps?.[0];
          if (!firstStep?.startTime) return null;
          
          const firstStart = new Date(firstStep.startTime).getTime();
          const responseStart = new Date(step.output.responseStartTime).getTime();
          const diff = responseStart - firstStart;
          return diff >= 0 ? Math.round(diff) : null;
        }
      } catch (e) {
        console.error('Error calculating Time To First Byte:', e);
        return null;
      }
    },

    datecheck(date){
      const hasValidResponseStartTime = date && !date.startsWith('0001-01-01');
      if (hasValidResponseStartTime) {
        return true;
      }
      return false;
    },

    // Check if a group has any steps with inSyncProcess = true
    isGroupInSync(group) {
      if (!group || !group.steps) return false;
      return group.steps.some(step => step.output && step.output.inSyncProcess === true);
    },

    // Check if the next node has input.processBreakdown
    isNextNodeHasProcessBreakdown(groupIndex) {
      if (!this.groupedFlowSteps || groupIndex + 1 >= this.groupedFlowSteps.length) return false;
      const nextGroup = this.groupedFlowSteps[groupIndex + 1];
      if (!nextGroup || !nextGroup.steps) return false;
      return nextGroup.steps.some(step => step.input?.processBreakdown);
    },

    // Get ProcessBreakdown for any node that has input.processBreakdown
    getNextNodeProcessBreakdown(groupIndex) {
      if (!this.groupedFlowSteps || groupIndex + 1 >= this.groupedFlowSteps.length) return [];
      const nextGroup = this.groupedFlowSteps[groupIndex + 1];
      if (!nextGroup || !nextGroup.steps) return [];
      
      const stepWithBreakdown = nextGroup.steps.find(step => step.input?.processBreakdown);
      if (!stepWithBreakdown || !stepWithBreakdown.input?.processBreakdown) return [];
      
      try {
        const breakdown = typeof stepWithBreakdown.input.processBreakdown === 'string' 
          ? JSON.parse(stepWithBreakdown.input.processBreakdown) 
          : stepWithBreakdown.input.processBreakdown;
        
        return Object.entries(breakdown).map(([key, value]) => ({
          label: this.formatPhaseName(key),
          value: this.formatResponseTime(value)
        }));
      } catch (e) {
        console.error('Error parsing processBreakdown:', e);
        return [];
      }
    },

    // Get request parameter from step output
    getProcessBreakdown(step) {
      try {
        if (!step.output?.processBreakdown) return {};
        return typeof step.output.processBreakdown === 'string' 
          ? JSON.parse(step.output.processBreakdown) 
          : step.output.processBreakdown;
      } catch (e) {
        console.error('Error parsing processBreakdown:', e);
        return {};
      }
    },

    formatPhaseName(phase) {
      // Add space before capital letters (e.g., "SaveLog" -> "Save Log", "LLMLatency" -> "LLM Latency")
      // Handle acronyms first (e.g., "LLMLatency" -> "LLM Latency")
      let result = phase.replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
      // Then handle camelCase (e.g., "SaveLog" -> "Save Log")
      result = result.replace(/([a-z])([A-Z])/g, '$1 $2');
      return result.trim();
    },

    getResponseTimeLabel(responseTimeMs) {
      // Label based on response time
      if (!responseTimeMs) return '';
      const ms = parseInt(responseTimeMs);
      if (ms < 2000) return 'Fast';
      if (ms < 5000) return 'Normal';
      if (ms < 10000) return 'Moderate';
      if (ms < 20000) return 'Slow';
      return 'Very Slow';
    },

    formatTime(dateTime) {
      if (!dateTime) return '-';
      try {
        return new Date(dateTime).toLocaleTimeString();
      } catch (e) {
        return dateTime;
      }
    },

    formatIOPreview(data) {
      if (!data) return '-';
      if (typeof data === 'string') return data.length > 30 ? data.substring(0, 30) + '...' : data;
      if (data.message) return data.message.length > 30 ? data.message.substring(0, 30) + '...' : data.message;
      return JSON.stringify(data).length > 30 ? JSON.stringify(data).substring(0, 30) + '...' : JSON.stringify(data);
    },

    isStepSelected(step) {
      if (!this.expandedStep || !step) return false;
      // Compare by reference or create a unique identifier
      return (
        this.expandedStep === step ||
        (this.expandedStep.stepId === step.stepId &&
          this.expandedStep.node === step.node &&
          this.expandedStep.startTime === step.startTime &&
          this.expandedStep.endTime === step.endTime &&
          this.expandedStep.responseTimeMs === step.responseTimeMs)
      );
    },

    async toggleStepDetails(step) {
      if (!step) return;

      // Toggle expanded state (check if same step)
      if (this.isStepSelected(step)) {
        this.expandedStep = null;
      } else {
        this.expandedStep = step;

                // Fetch log references if available
        if (step.logRefs && Array.isArray(step.logRefs) && step.logRefs.length > 0 && step.node !== 'documents' && step.node !== 'community' && step.node !== 'community+documents') {
          // Set loading state (Vue 3 style - direct assignment)
          step.loadingRefs = true;
          step.logRefsData = null;
          step.logRefsError = null;

          try {
            const request = {
              ID: step.logRefs, // Array of log IDs
              // llmEnrich / mutualFund reuse the AI Model hub's Log_AIModel refs → fetch as 'model'
              // (backend switches on Node; the fund resolver borrows the hub's step, refs and all)
              Node: (step.node === 'llmEnrich' || step.node === 'mutualFund' || step.node === 'taxStateRead') ? 'model' : step.node, // Node type (optional)
            };

            this.$call.GetLogReferenceFromLog(
              request,
              (response) => {
                // Data is in response.result array
                if (response && response.data.result && Array.isArray(response.data.result)) {
                  step.logRefsData = response.data.result; // Use only the result array
                  // Force reactivity update by reassigning expandedStep
                  this.expandedStep = { ...step };
                } else if (response && response.data && Array.isArray(response.data)) {
                  step.logRefsData = response.data;
                  // Force reactivity update by reassigning expandedStep
                  this.expandedStep = { ...step };
                }
                step.loadingRefs = false;
                // Force reactivity update
                this.expandedStep = { ...step };
              },
              (error) => {
                console.error('Error fetching log references:', error);
                step.logRefsError = 'Failed to load reference data';
                step.loadingRefs = false;
                // Force reactivity update
                this.expandedStep = { ...step };
              }
            );
          } catch (error) {
            console.error('Error fetching log references:', error);
            step.logRefsError = 'Failed to load reference data';
            step.loadingRefs = false;
          }
        } else if (step.node === 'documents') {
          var docLogIds = step.output.message ? JSON.parse(step.output.message) : null;
          if (docLogIds && Array.isArray(docLogIds) && docLogIds.length > 0) {
            step.logRefs = docLogIds;
          }
          
          // Only call API if logRefs exists and has data
          if (step.logRefs && Array.isArray(step.logRefs) && step.logRefs.length > 0) {
            // Set loading state (Vue 3 style - direct assignment)
            step.loadingRefs = true;
            step.logRefsData = null;
            step.logRefsError = null;

            try {
              const request = {
                ID: step.logRefs
              };

              this.$call.GetLogDocumentReferenceFromLog(
                request,
                (response) => {
                  // Data is in response.result array
                  if (response && response.data.result && Array.isArray(response.data.result)) {
                    step.logRefsData = response.data.result; // Use only the result array
                    // Force reactivity update by reassigning expandedStep
                    this.expandedStep = { ...step };
                  } else if (response && response.data && Array.isArray(response.data)) {
                    step.logRefsData = response.data;
                    // Force reactivity update by reassigning expandedStep
                    this.expandedStep = { ...step };
                  }
                  step.loadingRefs = false;
                  // Force reactivity update
                  this.expandedStep = { ...step };
                },
                (error) => {
                  console.error('Error fetching log references:', error);
                  step.logRefsError = 'Failed to load reference data';
                  step.loadingRefs = false;
                  // Force reactivity update
                  this.expandedStep = { ...step };
                }
              );
            } catch (error) {
              console.error('Error fetching log references:', error);
              step.logRefsError = 'Failed to load reference data';
              step.loadingRefs = false;
            }
          }
        } else if (step.node === 'community' || step.node === 'community+documents') {
          // Parse vector IDs from output message
          var communityLogIds = step.output.message ? JSON.parse(step.output.message) : null;
          if (communityLogIds && Array.isArray(communityLogIds) && communityLogIds.length > 0) {
            step.logRefs = communityLogIds;
          }

          // Extract community info from workflow output (e.g., ">Community Graph Search (CommunityId=56, Groups=3, Chunks=5)")
          const workflowOutput = step.output?.workflow || '';
          const communityMatch = workflowOutput.match(/Community Graph Search.*?CommunityId=(\d+).*?Groups=(\d+).*?Chunks=(\d+)/);
          if (communityMatch) {
            step.communityData = {
              communityId: communityMatch[1],
              groups: communityMatch[2],
              chunks: communityMatch[3]
            };
          }

          // Extract document info from workflow output (e.g., ">Document Search (VectorDB=xxx, Chunks=5)")
          const documentMatch = workflowOutput.match(/Document Search.*?VectorDB=([^,]+).*?Chunks=(\d+)/);
          if (documentMatch) {
            step.documentData = {
              vectorDB: documentMatch[1],
              chunks: documentMatch[2]
            };
          }

          // Only call API if logRefs exists and has data
          if (step.logRefs && Array.isArray(step.logRefs) && step.logRefs.length > 0) {
            step.loadingRefs = true;
            step.logRefsData = null;
            step.logRefsError = null;

            try {
              const request = {
                ID: step.logRefs
              };

              // Use same API as documents to get chunk details
              this.$call.GetLogDocumentReferenceFromLog(
                request,
                (response) => {
                  if (response && response.data.result && Array.isArray(response.data.result)) {
                    // Mark each item with source type based on node
                    step.logRefsData = response.data.result.map(item => ({
                      ...item,
                      source: step.node === 'community' ? 'community' : (item.source || 'document')
                    }));
                    this.expandedStep = { ...step };
                  } else if (response && response.data && Array.isArray(response.data)) {
                    step.logRefsData = response.data.map(item => ({
                      ...item,
                      source: step.node === 'community' ? 'community' : (item.source || 'document')
                    }));
                    this.expandedStep = { ...step };
                  }
                  step.loadingRefs = false;
                  this.expandedStep = { ...step };
                },
                (error) => {
                  console.error('Error fetching community references:', error);
                  step.logRefsError = 'Failed to load reference data';
                  step.loadingRefs = false;
                  this.expandedStep = { ...step };
                }
              );
            } catch (error) {
              console.error('Error fetching community references:', error);
              step.logRefsError = 'Failed to load reference data';
              step.loadingRefs = false;
            }
          }
        } else if (step.node === 'agent-tool'){
          var incomemsg = step.input.message ? JSON.parse(step.input.message) : null;
          if (incomemsg) {
            if(incomemsg.toolType == 'api'){
              step.toolType = 'API Tool';
              step.apiEndpoint = step.output.endpoint;
              step.apiHttpMethod = step.output.httpMethod;
              step.apiRequestBody = step.output.requestBody;
              step.headers = this.parseHeadersTool(step.output.requestParameters);
            }
            else if(incomemsg.toolType == 'master'){
              step.toolType = 'Master Tool Management';
              step.masterToolId = step.output.masterToolID;
              step.masterToolName = step.output.masterToolName;
              step.description = step.output.description;
              step.apiEndpoint = step.output.endpoint;
              step.apiHttpMethod = step.output.httpMethod;
              step.apiRequestBody = step.output.requestBody;
               step.headers = this.parseHeadersTool(step.output.requestParameters);
            }
            else{
              step.toolType = 'Text Information';
              step.textContent = step.output.textContent;
            }
            this.expandedStep = { ...step };
          }
        }

        // Special handling for orchestrator: fetch AI model monitor data (independent of logRefs)
        if (step.node === 'orchestrator' && step.output && step.output.model != null && step.output.model !== '') {
          // Backend emits a comma-separated list of LogAIModelIDs (older logs carry a single id)
          const modelIds = String(step.output.model)
            .split(',')
            .map((s) => Number(String(s).trim()))
            .filter((n) => Number.isFinite(n) && n > 0);

          // No usable id (e.g. routing call failed and Model came back as "0") → don't fire the request
          if (modelIds.length > 0) {
            // Set loading for model data
            step.loadingModelRefs = true;
            step.modelRefsData = null;
            step.modelRefsError = null;
            // Force reactivity update
            this.expandedStep = { ...step };

            try {
              const modelRequest = {
                ID: modelIds, // Model log IDs as array
                Node: 'model', // Fetch as model node
              };

              this.$call.GetLogReferenceFromLog(
                modelRequest,
                (modelResponse) => {
                  // Store model data separately (don't replace logRefsData)
                  if (modelResponse && modelResponse.data.result && Array.isArray(modelResponse.data.result)) {
                    step.modelRefsData = modelResponse.data.result;
                  } else if (modelResponse && modelResponse.data && Array.isArray(modelResponse.data)) {
                    step.modelRefsData = modelResponse.data;
                  }
                  step.loadingModelRefs = false;
                  // Force reactivity update
                  this.expandedStep = { ...step };
                },
                (error) => {
                  console.error('Error fetching orchestrator model references:', error);
                  step.modelRefsError = 'Failed to load model reference data';
                  step.loadingModelRefs = false;
                  // Force reactivity update
                  this.expandedStep = { ...step };
                }
              );
            } catch (e) {
              console.error('Error in orchestrator model fetch:', e);
              step.loadingModelRefs = false;
              // Force reactivity update
              this.expandedStep = { ...step };
            }
          }
        }
        

        // Smooth scroll to details panel after expansion animation
        this.$nextTick(() => {
          setTimeout(() => {
            const detailsPanel = document.querySelector('.step-details-panel');
            if (detailsPanel) {
              detailsPanel.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest',
              });
            }
          }, 200);
        });
      }

      // Update step expanded property for UI
      step.expanded = !step.expanded;
    },

    openMonitorDetails(id, nodeType, logRouterID) {
      // Reset and open dialog
      this.monitorData = null;
      this.loadingMonitor = true;
      this.dialogMonitor = true;

      const request = {
        ID: id,
        Node: nodeType,
        LogRouterID: logRouterID
      };

      this.$call.GetLogMonitorFromLog(
        request,
        (response) => {
          try {
            // data is the Log_Monitor row itself (null when the step has none)
            const monitor = response.data || {};
            // Parse jsonMonitor (similar to replymsg in Stream.vue)
            let parsedMonitor = null;
            if (monitor.jsonMonitor) {
              // console.log('Raw jsonMonitor:', monitor.jsonMonitor);
              parsedMonitor = JSON.parse(monitor.jsonMonitor);
              // Clean up newlines like in Stream.vue
              if (parsedMonitor.Vector) {
                parsedMonitor.Vector = this.Replace_NewLine(parsedMonitor.Vector);
              }
              if (parsedMonitor.VectorCoise) {
                parsedMonitor.VectorCoise = this.Replace_NewLine(parsedMonitor.VectorCoise);
              }
              if (parsedMonitor.Private_Memory) {
                parsedMonitor.Private_Memory = this.Replace_NewLine(parsedMonitor.Private_Memory);
              }
            }

            let parsedMemory = null;
            const rawJsonMemory = monitor.jsonMemory;
            if (rawJsonMemory) {
              const trimmedMemory = typeof rawJsonMemory === 'string' ? rawJsonMemory.trim() : rawJsonMemory;
              const looksLikeJson = typeof trimmedMemory === 'string' && (trimmedMemory.startsWith('[') || trimmedMemory.startsWith('{'));

              if (looksLikeJson) {
                try {
                  const memoryArray = JSON.parse(trimmedMemory);
                  if (Array.isArray(memoryArray) && memoryArray.length > 0) {
                    parsedMemory = '';
                    for (let i = 0; i < memoryArray.length; i++) {
                      parsedMemory += `${i + 1}. ${memoryArray[i].role} : ${memoryArray[i].content}\n`;
                    }
                  }
                } catch (parseError) {
                  // Fallback to raw string when parsing fails (e.g. "NotFound" message)
                  parsedMemory = trimmedMemory;
                }
              } else {
                parsedMemory = trimmedMemory;
              }
            }
            // Build DataLog structure like in Stream.vue
            this.monitorData = {
              Prompt: parsedMonitor?.GPT_Model?.promptTemplate || '',
              Vector: parsedMonitor?.Vector || '',
              ReplySQL: parsedMonitor?.ReplySQL || '',
              ReplyDataSelect: parsedMonitor?.ReplyDataSelect || '',
              Memory: parsedMemory || '',
              JsonMemoryRaw: rawJsonMemory || '',
              Translate: parsedMonitor?.Translate || '',
              FlowActionIntent: parsedMonitor?.FlowActionIntent || '',
              ContentRequest: monitor.contentRequest || '',
              GPT_Model: {
                ModelID: parsedMonitor?.GPT_Model?.ModelID || '',
                ModelName: parsedMonitor?.GPT_Model?.ModelName || '',
                Provider: parsedMonitor?.GPT_Model?.Provider || '',
                Model: parsedMonitor?.GPT_Model?.Model || '',
                Extension: parsedMonitor?.GPT_Model?.Extension || '',
                Description: parsedMonitor?.GPT_Model?.Description || '',
                promptTemplate: parsedMonitor?.GPT_Model?.promptTemplate || '',
                gender: parsedMonitor?.GPT_Model?.gender || '',
                vectordbName: parsedMonitor?.GPT_Model?.vectordbName || '',
                TopVDB: parsedMonitor?.GPT_Model?.TopVDB || '',
                internet: parsedMonitor?.GPT_Model?.internet || '',
                feedback: parsedMonitor?.GPT_Model?.feedback || '',
                HistoryCount: parsedMonitor?.GPT_Model?.HistoryCount || '',
                HistoryMinute: parsedMonitor?.GPT_Model?.HistoryMinute || '',
                temperature: parsedMonitor?.GPT_Model?.temperature || '',
                top_p: parsedMonitor?.GPT_Model?.top_p || '',
                frequency_penalty: parsedMonitor?.GPT_Model?.frequency_penalty || '-',
                presence_penalty: parsedMonitor?.GPT_Model?.presence_penalty || '-',
                Stop: parsedMonitor?.GPT_Model?.Stop || '',
                max_tokens: parsedMonitor?.GPT_Model?.max_tokens || '',
                IsStream: parsedMonitor?.GPT_Model?.IsStream || '',
                EndpointURL: parsedMonitor?.GPT_Model?.EndpointURL || '',
              },
              Text: parsedMonitor?.GPT_Model?.TextVector || '',
              TextVector: parsedMonitor?.GPT_Model?.TextVector || '',
              VectorCoise: parsedMonitor?.VectorCoise || '',
              Private_Memory: parsedMonitor?.Private_Memory || '',
              AiAttempts: Array.isArray(parsedMonitor?.AiAttempts)
                ? parsedMonitor.AiAttempts.map((attempt, index) => ({
                    AttemptOrder: attempt?.AttemptOrder ?? index + 1,
                    IsRetry: attempt?.IsRetry ?? false,
                    TimestampUtc: attempt?.TimestampUtc,
                    Provider: attempt?.Provider || parsedMonitor?.GPT_Model?.Provider || '',
                    ModelName: attempt?.ModelName || parsedMonitor?.GPT_Model?.ModelName || '',
                    EndpointUrl: attempt?.EndpointUrl || '',
                    EndpointId: attempt?.EndpointId,
                    Priority: attempt?.Priority,
                    PriorityDisplay: attempt?.PriorityDisplay,
                    Success: attempt?.Success,
                    StatusReturn: attempt?.StatusReturn,
                    statusCode: attempt?.StatusCode,
                    ResponseTimeMs: attempt?.ResponseTimeMs,
                    ReplyPreview: attempt?.ReplyPreview,
                    ResultNote: attempt?.ResultNote,
                  }))
                : [],
              // TTS Processing data (if available)
              TTSProcessing: parsedMonitor?.TTSProcessing ? {
                // ReformatForTTS
                ReformatOriginalText: parsedMonitor.TTSProcessing.ReformatOriginalText || '',
                ReformatOutputText: parsedMonitor.TTSProcessing.ReformatOutputText || '',
                IsCustomReformatPrompt: parsedMonitor.TTSProcessing.IsCustomReformatPrompt || false,
                ReformatPromptTokens: parsedMonitor.TTSProcessing.ReformatPromptTokens || 0,
                ReformatCompletionTokens: parsedMonitor.TTSProcessing.ReformatCompletionTokens || 0,
                ReformatTotalTokens: parsedMonitor.TTSProcessing.ReformatTotalTokens || 0,
                ReformatResponseTimeMs: parsedMonitor.TTSProcessing.ReformatResponseTimeMs || 0,
                ReformatStatusReturn: parsedMonitor.TTSProcessing.ReformatStatusReturn || 0,
                // FormatForTTSEngine
                TTSEngineInputText: parsedMonitor.TTSProcessing.TTSEngineInputText || '',
                TTSEngineOutputText: parsedMonitor.TTSProcessing.TTSEngineOutputText || '',
                IsCustomTTSEnginePrompt: parsedMonitor.TTSProcessing.IsCustomTTSEnginePrompt || false,
                TTSEnginePromptTokens: parsedMonitor.TTSProcessing.TTSEnginePromptTokens || 0,
                TTSEngineCompletionTokens: parsedMonitor.TTSProcessing.TTSEngineCompletionTokens || 0,
                TTSEngineTotalTokens: parsedMonitor.TTSProcessing.TTSEngineTotalTokens || 0,
                TTSEngineResponseTimeMs: parsedMonitor.TTSProcessing.TTSEngineResponseTimeMs || 0,
                TTSEngineStatusReturn: parsedMonitor.TTSProcessing.TTSEngineStatusReturn || 0,
                // Summary
                TotalTTSProcessingTimeMs: parsedMonitor.TTSProcessing.TotalTTSProcessingTimeMs || 0,
                Model: parsedMonitor.TTSProcessing.Model || '',
                UrlEndpoint: parsedMonitor.TTSProcessing.UrlEndpoint || '',
                ProcessedAt: parsedMonitor.TTSProcessing.ProcessedAt || '',
              } : null,
            };
          } catch (error) {
            console.error('Error parsing monitor data:', error);
            // Set default empty structure on error
            this.monitorData = this.getEmptyMonitorData();
          }

          this.loadingMonitor = false;
        },
        (error) => {
          console.error('Error fetching monitor data:', error);
          this.monitorData = this.getEmptyMonitorData();
          this.loadingMonitor = false;
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to load monitor data',
            timer: 2000,
          });
        }
      );
    },

    openTTSMonitorDetails(step) {
      // Build TTS monitor data from step
      this.ttsMonitorData = {
        node: step.node,
        stepId: step.stepId,
        status: step.status,
        responseTimeMs: step.responseTimeMs,
        startTime: step.startTime,
        endTime: step.endTime,
        input: step.input?.message || '',
        output: step.output?.message || '',
        promptTokens: step.output?.promptTokens || 0,
        completionTokens: step.output?.completionTokens || 0,
        totalTokens: step.output?.totalTokens || 0,
        cachedTokens: step.output?.cachedTokens || 0,
        endpoint: step.output?.endpoint || '',
        statusCode: step.output?.statusCode || 0,
        model: step.output?.model || '',
        contentRequestBody: step.output?.contentRequestBody || '',
      };
      this.dialogTTSMonitor = true;
    },

    openProcessSteps(step) {
      this.processRaw = step?.output?.description || '';
      this.processRawView = false;
      this.dialogProcess = true;
    },

    parseProcessSteps(desc) {
      return (desc || '')
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter((l) => l.length > 0)
        .map((rawLine) => {
          // Conservative leading-timestamp extraction: only a "[...]" prefix that
          // contains a digit (e.g. "[12:34:56]" or "[+120ms]") is treated as time.
          // If the backend never emits one, `time` stays empty and nothing renders.
          let raw = rawLine;
          let time = '';
          const tsMatch = raw.match(/^\[([^\]]{1,20})\]\s*/);
          if (tsMatch && /\d/.test(tsMatch[1])) {
            time = tsMatch[1].trim();
            raw = raw.slice(tsMatch[0].length);
          }
          const arrowIdx = raw.indexOf('→');
          let title = raw;
          let note = '';
          if (arrowIdx !== -1) {
            title = raw.slice(0, arrowIdx).trim();
            note = raw
              .slice(arrowIdx + 1)
              .split('→')
              .map((p) => p.trim())
              .filter((p) => p.length > 0)
              .join(' → ')
              .trim();
          }
          const t = raw.toLowerCase();
          // Default is 'plain' (uncategorized) — a step that matches no keyword is
          // shown as neutral rather than masquerading as a deliberate 'info' category.
          let kind = 'plain';
          let icon = 'mdi-chevron-right-circle-outline';
          if (/ผิดพลาด|ล้มเหลว|error|fail/.test(t)) {
            kind = 'error';
            icon = 'mdi-alert-circle-outline';
          } else if (/ตอบครบ|ปิดฟอร์ม|สรุป|เสร็จ|complete|finish/.test(t)) {
            kind = 'done';
            icon = 'mdi-flag-checkered';
          } else if (/ข้าม|skip/.test(t)) {
            kind = 'skip';
            icon = 'mdi-debug-step-over';
          } else if (/รับคำตอบ|ผู้ใช้ตอบ|answer/.test(t)) {
            kind = 'answer';
            icon = 'mdi-account-check';
          } else if (/เข้าคำถามถัดไป|คำถามถัดไป|ถามต่อ|next question/.test(t)) {
            kind = 'question';
            icon = 'mdi-help-circle-outline';
          } else if (/llm|เรียบเรียง|model|เอไอ/.test(t)) {
            kind = 'llm';
            icon = 'mdi-robot-outline';
          } else if (/เริ่ม|start/.test(t)) {
            kind = 'start';
            icon = 'mdi-play-circle-outline';
          }
          return { raw: rawLine, title, note, kind, icon, time };
        });
    },

    processMeta(desc) {
      const steps = this.parseProcessSteps(desc);
      const m = (desc || '').match(/(\d+)\s*\/\s*(\d+)/);
      return {
        count: steps.length,
        done: m ? parseInt(m[1], 10) : 0,
        total: m ? parseInt(m[2], 10) : 0,
      };
    },

    formatJSON(jsonString) {
      try {
        if (!jsonString) return '';
        const parsed = typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
        return JSON.stringify(parsed, null, 2);
      } catch (error) {
        return jsonString;
      }
    },

    // Service Fallback writes two things: a one-line summary to output.message, and the JSON the
    // app actually receives to output.requestParameters. The JSON is what anyone reading this log
    // is after, so it takes over the Output panel and the summary line is dropped.
    hasServiceFallbackJson(step) {
      return !!(step && step.node === 'serviceFallback' && step.output && step.output.requestParameters);
    },

    outputPanelTitle(step) {
      return this.hasServiceFallbackJson(step) ? '📤 Output JSON' : '📤 Output Data';
    },

    outputPanelText(step) {
      if (!step || !step.output) return '';
      return this.hasServiceFallbackJson(step)
        ? this.formatToolRequestBody(step.output.requestParameters)
        : this.convertMessageOutput(step.output.message, step.node);
    },

    formatToolRequestBody(requestBody) {
      if (!requestBody) return 'No request body';
      try {
        // If it's already a string that looks like JSON, try to parse and format it
        if (typeof requestBody === 'string') {
          let parsed = JSON.parse(requestBody);
          // Check if the result is still a string (double-encoded JSON)
          if (typeof parsed === 'string') {
            parsed = JSON.parse(parsed);
          }
          return JSON.stringify(parsed, null, 2);
        }
        // If it's an object, stringify it with formatting
        return JSON.stringify(requestBody, null, 2);
      } catch (error) {
        // If parsing fails, return as-is
        return requestBody;
      }
    },
    
    parseHeadersTool(headersData) {
      if (!headersData) return [];
      
      try {
        let headers = headersData;
        
        // If it's a string, try to parse it as JSON
        if (typeof headersData === 'string') {
          headers = JSON.parse(headersData);
        }
        
        // If it's an array of {key, value} or {Key, Value} objects
        if (Array.isArray(headers)) {
          return headers.filter(h => h && (h.key || h.Key)).map(h => ({
            key: h.key || h.Key || '',
            value: h.value || h.Value || ''
          }));
        }
        
        // If it's a dictionary/object (like {"Content-Type":"application/json","X-API-Key":"xxx"})
        if (typeof headers === 'object' && headers !== null && !Array.isArray(headers)) {
          return Object.entries(headers).map(([key, value]) => ({
            key: key,
            value: typeof value === 'object' ? JSON.stringify(value) : String(value || '')
          }));
        }
        
        return [];
      } catch (error) {
        console.error('Error parsing headers:', error);
        return [];
      }
    },

    Replace_NewLine(input) {
      try {
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }
      } catch {
        // Do nothing on error
      }
      return input;
    },

    getEmptyMonitorData() {
      return {
        Prompt: '',
        Vector: '',
        ReplySQL: '',
        ReplyDataSelect: '',
        Memory: '',
        JsonMemoryRaw: '',
        Translate: '',
        FlowActionIntent: '',
        ContentRequest: '',
        GPT_Model: {
          ModelID: '',
          ModelName: '',
          Provider: '',
          Model: '',
          Extension: '',
          Description: '',
          promptTemplate: '',
          gender: '',
          vectordbName: '',
          TopVDB: '',
          internet: '',
          feedback: '',
          HistoryCount: '',
          HistoryMinute: '',
          temperature: '',
          top_p: '',
          frequency_penalty: '',
          presence_penalty: '',
          Stop: '',
          max_tokens: '',
          IsStream: '',
          EndpointURL: '',
        },
        Text: '',
        TextVector: '',
        VectorCoise: '',
        Private_Memory: '',
        AiAttempts: [],
        TTSProcessing: null,
      };
    },
  },
  mounted() {
    this.isInitialized = true;
    window.addEventListener("keydown", this.handleGlobalEnterSearch);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleGlobalEnterSearch);
  },
};
</script>
<style scoped>
/* =============================================================================
   CARD COMPONENTS
   ============================================================================= */
.card2 {
  border-radius: 16px !important;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.date-card,
.filter-card,
.toggle-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.date-card:hover,
.filter-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.toggle-card {
  background: rgba(25, 118, 210, 0.05) !important;
}

.action-card {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02), rgba(25, 118, 210, 0.05)) !important;
  border: 1px solid rgba(25, 118, 210, 0.2) !important;
}

.advanced-filter-card {
  background: rgba(248, 250, 252, 0.8) !important;
}

/* =============================================================================
   ADVANCED FILTERS - MODERN DESIGN
   ============================================================================= */
.advanced-filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 0;
}

.filter-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-section-label {
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #9e9e9e;
  padding-left: 2px;
}

.range-filter-group {
  background: rgba(0, 0, 0, 0.02) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  transition: border-color 0.2s ease;
}

.range-filter-group:hover {
  border-color: rgba(25, 118, 210, 0.3) !important;
}

.range-filter-label {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #616161;
  letter-spacing: 0.02em;
}

.range-input {
  max-width: 140px;
}

.range-input .v-field {
  border-radius: 8px !important;
}

.range-divider {
  color: #bdbdbd;
  font-weight: 300;
  font-size: 1.1rem;
  flex-shrink: 0;
}

/* Hide number input spinners for cleaner look */
.range-input input[type='number']::-webkit-outer-spin-button,
.range-input input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.range-input input[type='number'] {
  -moz-appearance: textfield;
}

.data-table-card {
  border-radius: 12px !important;
  overflow: hidden;
}

/* =============================================================================
   FORM ELEMENTS
   ============================================================================= */
.date-field .v-field {
  border-radius: 8px !important;
}

.section-title {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  border-bottom: 2px solid rgba(25, 118, 210, 0.2);
  padding-bottom: 8px;
}

/* =============================================================================
   BUTTONS
   ============================================================================= */
.search-btn,
.download-btn {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.search-btn {
  min-width: 120px !important;
}

.download-menu {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.flow-btn {
  transition: all 0.2s ease;
}

.flow-btn:hover {
  transform: scale(1.1);
  background-color: rgba(25, 118, 210, 0.08) !important;
}

.flow-btn:disabled {
  opacity: 0.3;
}

.monitor-btn {
  transition: all 0.2s ease;
}

.monitor-btn:hover {
  transform: scale(1.1);
  background-color: rgba(33, 150, 243, 0.08) !important;
}

/* =============================================================================
   FILTER PANEL
   ============================================================================= */
.filter-panel-title {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05), rgba(25, 118, 210, 0.1)) !important;
  border-radius: 8px 8px 0 0 !important;
}

/* =============================================================================
   DATA TABLE
   ============================================================================= */
.table-container {
  overflow-x: auto;
  max-width: 100%;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.1);
}

.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(25, 118, 210, 0.5);
}

.modern-table {
  border-radius: 0 0 12px 12px !important;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(table) {
  min-width: 1200px;
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
  height: 8px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}

.modern-table :deep(.v-data-table__th) {
  white-space: nowrap;
  min-width: 120px;
}

.modern-table :deep(.v-data-table__td) {
  min-width: 120px;
  max-width: 200px;
}

.table-row {
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

/* =============================================================================
   TEXT CONTENT
   ============================================================================= */
.text-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 100px;
}
.text-container-new {
  align-items: flex-start !important;
  gap: 8px;
  min-width: 200px !important;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
  line-height: 1.4;
  word-break: break-word;
}

.text-content-show {
  white-space: pre-wrap;
  word-break: break-word;
  flex-grow: 1;
  line-height: 1.4;
  max-width: 300px;
}

/* =============================================================================
   AI ATTEMPTS PANEL
   ============================================================================= */
.attempt-stat-card {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08) !important;
  transition: transform 0.2s ease;
}

.attempt-stat-card:hover {
  transform: translateY(-2px);
}

.attempt-stat-card .stat-label {
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(0, 0, 0, 0.5);
}

.attempt-stat-card .stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}

.attempt-stat-card.total {
  border-left: 4px solid #2563eb !important;
}

.attempt-stat-card.success {
  border-left: 4px solid #10b981 !important;
}

.attempt-stat-card.failed {
  border-left: 4px solid #ef4444 !important;
}

.attempt-stat-card.retry {
  border-left: 4px solid #f97316 !important;
}

.ai-attempts-wrapper {
  border-radius: 12px !important;
  overflow: hidden;
}

.ai-attempts-table thead {
  background: rgba(37, 99, 235, 0.08);
}

.ai-attempts-table thead th {
  font-weight: 600;
  font-size: 0.85rem;
  color: rgba(15, 23, 42, 0.8);
}

.ai-attempts-table tbody tr {
  min-height: 60px;
  height: 60px;
}

.ai-attempts-table tbody tr td {
  vertical-align: middle;
  font-size: 0.9rem;
}

.endpoint-text,
.attempt-snippet {
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.endpoint-text.clickable-text {
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  padding: 4px 8px;
  border-radius: 6px;
}

.endpoint-text.clickable-text:hover {
  background-color: rgba(37, 99, 235, 0.08);
  color: #2563eb;
}

.endpoint-text .copy-icon {
  opacity: 0;
  transition: opacity 0.2s ease;
  vertical-align: middle;
}

.endpoint-text.clickable-text:hover .copy-icon {
  opacity: 1;
}

.snippet-actions {
  display: flex;
  justify-content: flex-start;
  margin-top: 4px;
}

.ai-attempts-empty {
  border-radius: 12px;
  text-align: center;
}

/* =============================================================================
   LAYOUT
   ============================================================================= */
.action-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 960px) {
  .action-group {
    flex-direction: column;
    width: 100%;
  }

  .d-flex.justify-space-between {
    flex-direction: column !important;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .modern-table :deep(.v-data-table__th),
  .modern-table :deep(.v-data-table__td) {
    min-width: 100px;
    max-width: 150px;
  }

  .date-card,
  .filter-card,
  .toggle-card {
    margin-bottom: 12px;
  }
}

@media (max-width: 600px) {
  .section-title {
    font-size: 1rem;
  }

  .filter-section {
    margin-bottom: 24px;
  }
}

/* =============================================================================
   HORIZONTAL FLOW DIALOG STYLES
   ============================================================================= */
.horizontal-flow-container {
  width: 100%;
  will-change: auto;
}

.horizontal-flow-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 20px 10px;
  min-height: 200px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* When content overflows, align to flex-start to show beginning */
.horizontal-flow-steps.has-overflow {
  justify-content: flex-start;
}

.horizontal-step-wrapper {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  will-change: transform;
}

/* Step Group Container for Parallel Execution */
.step-group-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
}

.step-group-container.parallel-steps {
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
}

.step-item {
  display: flex;
  align-items: center;
}

.step-item.parallel-item {
  position: relative;
}

.step-item.parallel-item::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  width: 12px;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6 0%, transparent 100%);
  transform: translateY(-50%);
  z-index: 1;
}

/* Vertical line connecting parallel items - adjusted to not overflow */
.step-group-container.parallel-steps {
  position: relative;
  padding-left: 0;
}

.step-group-container.parallel-steps .step-item.parallel-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  width: 2px;
  background: #3b82f6;
  height: calc(100% + 12px);
  z-index: 0;
}

.step-group-container.parallel-steps .step-item.parallel-item:last-child::after {
  content: '';
  position: absolute;
  left: -20px;
  top: 0;
  width: 2px;
  background: #3b82f6;
  height: 50%;
  z-index: 0;
}

/* Checkpoint Node Styles */
.checkpoint-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  padding: 8px;
  min-width: 80px;
  max-width: 120px;
  border: 4px solid transparent !important;
  border-radius: 12px;
}

.checkpoint-node:hover {
  transform: translateY(-3px);
}

.checkpoint-node.active {
  transform: translateY(-3px) scale(1.05);
  border: 4px solid #10b981 !important;
  border-radius: 12px;
  box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.25), 0 0 20px rgba(16, 185, 129, 0.4);
  background: rgba(16, 185, 129, 0.08);
  animation: border-pulse 2s ease-in-out infinite;
}

@keyframes border-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.25), 0 0 15px rgba(16, 185, 129, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 10px rgba(16, 185, 129, 0.6);
  }
}

.checkpoint-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
}

.checkpoint-icon::before {
  content: '';
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  top: -4px;
  left: -4px;
  animation: checkpoint-pulse 2s infinite;
}

@keyframes checkpoint-pulse {
  0% {
    transform: scale(0.9);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }
  100% {
    transform: scale(0.9);
    opacity: 1;
  }
}

.checkpoint-label {
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 4px;
  line-height: 1.2;
}

.checkpoint-time-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
}

.checkpoint-time {
  font-size: 9px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
  font-weight: 400;
}

.checkpoint-duration {
  font-size: 9px;
  color: white;
  text-align: center;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Checkpoint Colors by Node Type */
.checkpoint-node[data-node-type='messageInput'] .checkpoint-icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.checkpoint-node[data-node-type='response'] .checkpoint-icon {
  background: linear-gradient(135deg, #f97316, #ea580c);
}

/* Selection Indicators - Hidden, use border instead */
.selection-indicator {
  display: none;
}

.card-selection-indicator {
  display: none;
}

.node-selection-indicator {
  display: none;
}

@keyframes pulse-select {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 4px 16px rgba(59, 130, 246, 0.6);
  }
}

/* Flow Node Styles - Minimal Style */
.flow-node {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  max-width: 180px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  cursor: pointer;
  border: 2px solid #e5e7eb;
  overflow: hidden;
}

.flow-node:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 0, 0, 0.12);
}

.flow-node.active {
  transform: translateY(-3px) scale(1.02);
  border: 4px solid #8b5cf6 !important;
  box-shadow: 0 0 0 6px rgba(139, 92, 246, 0.3), 0 0 20px rgba(139, 92, 246, 0.5);
  animation: border-pulse-purple 2s ease-in-out infinite;
}

@keyframes border-pulse-purple {
  0%,
  100% {
    box-shadow: 0 0 0 6px rgba(139, 92, 246, 0.3), 0 0 20px rgba(139, 92, 246, 0.5);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.4), 0 0 30px rgba(139, 92, 246, 0.7);
  }
}

/* Node type-based colors using FlowNode.vue themes */

/* Message Input Node - Using message-node theme (green) */
.flow-node[data-node-type='messageInput'] {
  border: 5px solid #53ca7e !important;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%) !important;
  color: #166534 !important;
  box-shadow: 2px 6px 6px rgba(83, 202, 126, 0.699) !important;
}

/* Intent Node - Using intent-modern-node theme (purple) */
.flow-node[data-node-type='intent'] {
  border: 5px solid #c0a4ff !important;
  background: white !important;
  color: #1e293b !important;
  box-shadow: 2px 6px 6px rgba(145, 27, 255, 0.699) !important;
}

/* AI Model Node - Using ai-agent-node theme (blue) */
.flow-node[data-node-type='aiModel'] {
  border: 5px solid #3b82f6 !important;
  background: linear-gradient(135deg, #ffffff 0%, #eef5ff 100%) !important;
  color: #1e40af !important;
  box-shadow: 2px 6px 6px rgba(59, 130, 246, 0.699) !important;
}

/* Message Output Node - Using response-node theme (orange) */
.flow-node[data-node-type='messageOutput'] {
  border: 5px solid #f97316 !important;
  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%) !important;
  color: #c2410c !important;
  box-shadow: 2px 6px 6px rgba(249, 115, 22, 0.699) !important;
}

/* Agent AI Model Node - Using agent theme (teal) */
.flow-node[data-node-type='agent-aimodel'] {
  border: 5px solid #5eead4 !important;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%) !important;
  color: #0f766e !important;
  box-shadow: 2px 6px 6px rgba(20, 184, 166, 0.699) !important;
}

/* API Knowledge Node - Orange theme */
.flow-card-node[data-node-type='apiknowledge'] {
  border: 5px solid #ffca98;
  box-shadow: 2px 6px 6px rgba(255, 108, 55, 0.6);
}

.flow-card-node[data-node-type='apiknowledge']:hover {
  border-color: #ffb367;
}

.flow-card-node[data-node-type='apiknowledge'].active {
  border: 5px solid #ff6c37 !important;
  box-shadow: 0 0 0 8px rgba(255, 108, 55, 0.35), 0 0 25px rgba(255, 108, 55, 0.6);
  animation: border-pulse-apiknowledge 2s ease-in-out infinite;
}

@keyframes border-pulse-apiknowledge {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(255, 108, 55, 0.35), 0 0 15px rgba(255, 108, 55, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(255, 108, 55, 0.45), 0 0 10px rgba(255, 108, 55, 0.8);
  }
}

/* Database Integration Node - Green theme */
.flow-card-node[data-node-type='databaseIntegration'] {
  border: 5px solid #67d89a;
  box-shadow: 2px 6px 6px rgba(22, 163, 74, 0.6);
}

.flow-card-node[data-node-type='databaseIntegration']:hover {
  border-color: #4ade80;
}

.flow-card-node[data-node-type='databaseIntegration'].active {
  border: 5px solid #16a34a !important;
  box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.35), 0 0 25px rgba(22, 163, 74, 0.6);
  animation: border-pulse-dbintegration 2s ease-in-out infinite;
}

@keyframes border-pulse-dbintegration {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.35), 0 0 15px rgba(22, 163, 74, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(22, 163, 74, 0.45), 0 0 10px rgba(22, 163, 74, 0.8);
  }
}

/* Tax Planning Node - Green theme (matches Tax Planning node in FlowNode.vue: border #67d89a) */
.flow-card-node[data-node-type='taxPlanning'] {
  border: 5px solid #67d89a;
  box-shadow: 2px 6px 6px rgba(22, 163, 74, 0.6);
}

.flow-card-node[data-node-type='taxPlanning']:hover {
  border-color: #4ade80;
}

.flow-card-node[data-node-type='taxPlanning'].active {
  border: 5px solid #16a34a !important;
  box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.35), 0 0 25px rgba(22, 163, 74, 0.6);
  animation: border-pulse-taxplanning 2s ease-in-out infinite;
}

@keyframes border-pulse-taxplanning {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(22, 163, 74, 0.35), 0 0 15px rgba(22, 163, 74, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(22, 163, 74, 0.45), 0 0 10px rgba(22, 163, 74, 0.8);
  }
}

/* Tax Planning V2 Node - Teal theme (matches taxPlanningV2 color in flowUtils.js; distinct from taxPlanning's green) */
.flow-card-node[data-node-type='taxPlanningV2'] {
  border: 5px solid #5eead4;
  box-shadow: 2px 6px 6px rgba(13, 148, 136, 0.6);
}

.flow-card-node[data-node-type='taxPlanningV2']:hover {
  border-color: #2dd4bf;
}

.flow-card-node[data-node-type='taxPlanningV2'].active {
  border: 5px solid #0d9488 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-taxplanningv2 2s ease-in-out infinite;
}

@keyframes border-pulse-taxplanningv2 {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* Tax Planning Agent - Indigo theme (matches its Flow editor identity) */
.flow-card-node[data-node-type='taxPlanningAgent'] {
  border: 5px solid #a5b4fc;
  box-shadow: 2px 6px 6px rgba(79, 70, 229, 0.6);
}

.flow-card-node[data-node-type='taxPlanningAgent']:hover {
  border-color: #818cf8;
}

.flow-card-node[data-node-type='taxPlanningAgent'].active {
  border: 5px solid #4f46e5 !important;
  box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.35), 0 0 25px rgba(99, 102, 241, 0.6);
  animation: border-pulse-taxplanningagent 2s ease-in-out infinite;
}

@keyframes border-pulse-taxplanningagent {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.35), 0 0 15px rgba(99, 102, 241, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(99, 102, 241, 0.45), 0 0 10px rgba(99, 102, 241, 0.8);
  }
}

@media (prefers-reduced-motion: reduce) {
  .flow-card-node[data-node-type='taxPlanningAgent'] {
    transition: none;
  }

  .flow-card-node[data-node-type='taxPlanningAgent'].active {
    animation: none;
  }
}

/* Tax State Read Node - Teal theme (mobile/playground state read) */
.flow-card-node[data-node-type='taxStateRead'] {
  border: 5px solid #5eead4;
  box-shadow: 2px 6px 6px rgba(13, 148, 136, 0.6);
}

.flow-card-node[data-node-type='taxStateRead']:hover {
  border-color: #2dd4bf;
}

.flow-card-node[data-node-type='taxStateRead'].active {
  border: 5px solid #0d9488 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-taxstateread 2s ease-in-out infinite;
}

@keyframes border-pulse-taxstateread {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* API Trigger Node - Sky Blue theme */
.flow-card-node[data-node-type='apiTrigger'] {
  border: 5px solid #75d3ff;
  box-shadow: 2px 6px 6px rgba(14, 165, 233, 0.6);
}

.flow-card-node[data-node-type='apiTrigger']:hover {
  border-color: #38bdf8;
}

.flow-card-node[data-node-type='apiTrigger'].active {
  border: 5px solid #0ea5e9 !important;
  box-shadow: 0 0 0 8px rgba(14, 165, 233, 0.35), 0 0 25px rgba(14, 165, 233, 0.6);
  animation: border-pulse-apitrigger 2s ease-in-out infinite;
}

@keyframes border-pulse-apitrigger {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(14, 165, 233, 0.35), 0 0 15px rgba(14, 165, 233, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(14, 165, 233, 0.45), 0 0 10px rgba(14, 165, 233, 0.8);
  }
}

/* API Request Node - Indigo theme (matches Flow page) */
.flow-card-node[data-node-type='apiRequest'] {
  border: 5px solid #6366f1;
  box-shadow: 2px 6px 6px rgba(79, 70, 229, 0.6);
}

.flow-card-node[data-node-type='apiRequest']:hover {
  border-color: #4f46e5;
}

.flow-card-node[data-node-type='apiRequest'].active {
  border: 5px solid #4f46e5 !important;
  box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 25px rgba(79, 70, 229, 0.6);
  animation: border-pulse-apirequest 2s ease-in-out infinite;
}

@keyframes border-pulse-apirequest {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 15px rgba(79, 70, 229, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(79, 70, 229, 0.45), 0 0 10px rgba(79, 70, 229, 0.8);
  }
}

/* Favorite Matcher Node - Teal theme (matches Flow page) */
.flow-card-node[data-node-type='favoriteMatcher'] {
  border: 5px solid #0d9488;
  box-shadow: 2px 6px 6px rgba(13, 148, 136, 0.6);
}

.flow-card-node[data-node-type='favoriteMatcher']:hover {
  border-color: #14b8a6;
}

.flow-card-node[data-node-type='favoriteMatcher'].active {
  border: 5px solid #14b8a6 !important;
  box-shadow: 0 0 0 8px rgba(13, 148, 136, 0.35), 0 0 25px rgba(13, 148, 136, 0.6);
  animation: border-pulse-favoritematcher 2s ease-in-out infinite;
}

@keyframes border-pulse-favoritematcher {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(13, 148, 136, 0.35), 0 0 15px rgba(13, 148, 136, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(13, 148, 136, 0.45), 0 0 10px rgba(13, 148, 136, 0.8);
  }
}

/* LLM Enrich Node - Teal theme (matches Flow page) */
.flow-card-node[data-node-type='llmEnrich'] {
  border: 5px solid #14b8a6;
  box-shadow: 2px 6px 6px rgba(20, 184, 166, 0.6);
}

.flow-card-node[data-node-type='llmEnrich']:hover {
  border-color: #5eead4;
}

.flow-card-node[data-node-type='llmEnrich'].active {
  border: 5px solid #0d9488 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-llmenrich 2s ease-in-out infinite;
}

@keyframes border-pulse-llmenrich {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* Button Style Node - Fuchsia theme (matches .buttonstyle-node on the Flow page) */
.flow-card-node[data-node-type='buttonStyle'] {
  border: 5px solid #d946ef;
  box-shadow: 2px 6px 6px rgba(217, 70, 239, 0.6);
}

.flow-card-node[data-node-type='buttonStyle']:hover {
  border-color: #f0abfc;
}

.flow-card-node[data-node-type='buttonStyle'].active {
  border: 5px solid #c026d3 !important;
  box-shadow: 0 0 0 8px rgba(217, 70, 239, 0.35), 0 0 25px rgba(217, 70, 239, 0.6);
  animation: border-pulse-buttonstyle 2s ease-in-out infinite;
}

@keyframes border-pulse-buttonstyle {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(217, 70, 239, 0.35), 0 0 15px rgba(217, 70, 239, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(217, 70, 239, 0.45), 0 0 10px rgba(217, 70, 239, 0.8);
  }
}

/* Mutual Fund Node - Violet theme (matches .mutual-fund-node on the Flow page) */
.flow-card-node[data-node-type='mutualFund'] {
  border: 5px solid #8b5cf6;
  box-shadow: 2px 6px 6px rgba(139, 92, 246, 0.6);
}

.flow-card-node[data-node-type='mutualFund']:hover {
  border-color: #c4b5fd;
}

.flow-card-node[data-node-type='mutualFund'].active {
  border: 5px solid #7c3aed !important;
  box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 25px rgba(139, 92, 246, 0.6);
  animation: border-pulse-mutualfund 2s ease-in-out infinite;
}

@keyframes border-pulse-mutualfund {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 15px rgba(139, 92, 246, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(139, 92, 246, 0.45), 0 0 10px rgba(139, 92, 246, 0.8);
  }
}

/* Service Matcher Node - Cyan theme (matches Flow page) */
.flow-card-node[data-node-type='serviceMatcher'] {
  border: 5px solid #0891b2;
  box-shadow: 2px 6px 6px rgba(8, 145, 178, 0.6);
}

.flow-card-node[data-node-type='serviceMatcher']:hover {
  border-color: #22d3ee;
}

.flow-card-node[data-node-type='serviceMatcher'].active {
  border: 5px solid #22d3ee !important;
  box-shadow: 0 0 0 8px rgba(8, 145, 178, 0.35), 0 0 25px rgba(8, 145, 178, 0.6);
  animation: border-pulse-servicematcher 2s ease-in-out infinite;
}

@keyframes border-pulse-servicematcher {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(8, 145, 178, 0.35), 0 0 15px rgba(8, 145, 178, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(8, 145, 178, 0.45), 0 0 10px rgba(8, 145, 178, 0.8);
  }
}

/* Service Matcher (API sub-step) Node - Indigo theme (matches apiRequest) */
.flow-card-node[data-node-type='serviceMatcher-api'] {
  border: 5px solid #6366f1;
  box-shadow: 2px 6px 6px rgba(79, 70, 229, 0.6);
}

.flow-card-node[data-node-type='serviceMatcher-api']:hover {
  border-color: #4f46e5;
}

.flow-card-node[data-node-type='serviceMatcher-api'].active {
  border: 5px solid #4f46e5 !important;
  box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 25px rgba(79, 70, 229, 0.6);
  animation: border-pulse-servicematcher-api 2s ease-in-out infinite;
}

@keyframes border-pulse-servicematcher-api {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 15px rgba(79, 70, 229, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(79, 70, 229, 0.45), 0 0 10px rgba(79, 70, 229, 0.8);
  }
}

/* Service Matcher (Favorite sub-step) Node - Teal theme (matches favoriteMatcher) */
.flow-card-node[data-node-type='serviceMatcher-favorite'] {
  border: 5px solid #0d9488;
  box-shadow: 2px 6px 6px rgba(13, 148, 136, 0.6);
}

.flow-card-node[data-node-type='serviceMatcher-favorite']:hover {
  border-color: #14b8a6;
}

.flow-card-node[data-node-type='serviceMatcher-favorite'].active {
  border: 5px solid #14b8a6 !important;
  box-shadow: 0 0 0 8px rgba(13, 148, 136, 0.35), 0 0 25px rgba(13, 148, 136, 0.6);
  animation: border-pulse-servicematcher-favorite 2s ease-in-out infinite;
}

@keyframes border-pulse-servicematcher-favorite {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(13, 148, 136, 0.35), 0 0 15px rgba(13, 148, 136, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(13, 148, 136, 0.45), 0 0 10px rgba(13, 148, 136, 0.8);
  }
}

/* Contact Agent Node (and Contact Agent V2) - Red theme */
.flow-card-node[data-node-type='contactAgent'],
.flow-card-node[data-node-type='contactAgentV2'] {
  border: 5px solid #ff8282;
  box-shadow: 2px 6px 6px rgba(220, 38, 38, 0.6);
}

.flow-card-node[data-node-type='contactAgent']:hover,
.flow-card-node[data-node-type='contactAgentV2']:hover {
  border-color: #f87171;
}

.flow-card-node[data-node-type='contactAgent'].active,
.flow-card-node[data-node-type='contactAgentV2'].active {
  border: 5px solid #dc2626 !important;
  box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.35), 0 0 25px rgba(220, 38, 38, 0.6);
  animation: border-pulse-contactagent 2s ease-in-out infinite;
}

@keyframes border-pulse-contactagent {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(220, 38, 38, 0.35), 0 0 15px rgba(220, 38, 38, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(220, 38, 38, 0.45), 0 0 10px rgba(220, 38, 38, 0.8);
  }
}

/* Loan Interest Node - Emerald theme */
.flow-card-node[data-node-type='loanInterest'] {
  border: 5px solid #34d399;
  box-shadow: 2px 6px 6px rgba(16, 185, 129, 0.6);
}

.flow-card-node[data-node-type='loanInterest']:hover {
  border-color: #10b981;
}

.flow-card-node[data-node-type='loanInterest'].active {
  border: 5px solid #10b981 !important;
  box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 25px rgba(16, 185, 129, 0.6);
  animation: border-pulse-loaninterest 2s ease-in-out infinite;
}

@keyframes border-pulse-loaninterest {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 15px rgba(16, 185, 129, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(16, 185, 129, 0.45), 0 0 10px rgba(16, 185, 129, 0.8);
  }
}

/* Loan Interest V2 Node - Emerald theme (same as V1) */
.flow-card-node[data-node-type='loanInterestV2'] {
  border: 5px solid #34d399;
  box-shadow: 2px 6px 6px rgba(16, 185, 129, 0.6);
}

.flow-card-node[data-node-type='loanInterestV2']:hover {
  border-color: #10b981;
}

.flow-card-node[data-node-type='loanInterestV2'].active {
  border: 5px solid #10b981 !important;
  box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 25px rgba(16, 185, 129, 0.6);
  animation: border-pulse-loaninterestv2 2s ease-in-out infinite;
}

@keyframes border-pulse-loaninterestv2 {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0.35), 0 0 15px rgba(16, 185, 129, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(16, 185, 129, 0.45), 0 0 10px rgba(16, 185, 129, 0.8);
  }
}

/* Documents Node - Blue theme */
.flow-card-node[data-node-type='documents'] {
  border: 5px solid #76b2ff;
  box-shadow: 2px 6px 6px rgba(3, 105, 161, 0.6);
}

.flow-card-node[data-node-type='documents']:hover {
  border-color: #60a5fa;
}

.flow-card-node[data-node-type='documents'].active {
  border: 5px solid #0369a1 !important;
  box-shadow: 0 0 0 8px rgba(3, 105, 161, 0.35), 0 0 25px rgba(3, 105, 161, 0.6);
  animation: border-pulse-documents 2s ease-in-out infinite;
}

@keyframes border-pulse-documents {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(3, 105, 161, 0.35), 0 0 15px rgba(3, 105, 161, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(3, 105, 161, 0.45), 0 0 10px rgba(3, 105, 161, 0.8);
  }
}

/* Summary Documents Memory Node - Blue theme (matches Documents) */
.flow-card-node[data-node-type='summaryMemory'] {
  border: 5px solid #76b2ff;
  box-shadow: 2px 6px 6px rgba(3, 105, 161, 0.6);
}

.flow-card-node[data-node-type='summaryMemory']:hover {
  border-color: #60a5fa;
}

.flow-card-node[data-node-type='summaryMemory'].active {
  border: 5px solid #0369a1 !important;
  box-shadow: 0 0 0 8px rgba(3, 105, 161, 0.35), 0 0 25px rgba(3, 105, 161, 0.6);
  animation: border-pulse-documents 2s ease-in-out infinite;
}

/* Embedding Node - Teal/Cyan theme */
.flow-card-node[data-node-type='embedding'] {
  border: 5px solid #5eead4;
  box-shadow: 2px 6px 6px rgba(20, 184, 166, 0.6);
}

.flow-card-node[data-node-type='embedding']:hover {
  border-color: #2dd4bf;
}

.flow-card-node[data-node-type='embedding'].active {
  border: 5px solid #14b8a6 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-embedding 2s ease-in-out infinite;
}

@keyframes border-pulse-embedding {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* Community Graph Node - Purple theme */
.flow-card-node[data-node-type='community'] {
  border: 5px solid #a78bfa;
  box-shadow: 2px 6px 6px rgba(124, 58, 237, 0.6);
}

.flow-card-node[data-node-type='community']:hover {
  border-color: #8b5cf6;
}

.flow-card-node[data-node-type='community'].active {
  border: 5px solid #7c3aed !important;
  box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 25px rgba(124, 58, 237, 0.6);
  animation: border-pulse-community 2s ease-in-out infinite;
}

@keyframes border-pulse-community {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 15px rgba(124, 58, 237, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(124, 58, 237, 0.45), 0 0 10px rgba(124, 58, 237, 0.8);
  }
}

/* Community + Documents Node - Indigo theme */
.flow-card-node[data-node-type='community+documents'] {
  border: 5px solid #818cf8;
  box-shadow: 2px 6px 6px rgba(99, 102, 241, 0.6);
}

.flow-card-node[data-node-type='community+documents']:hover {
  border-color: #6366f1;
}

.flow-card-node[data-node-type='community+documents'].active {
  border: 5px solid #6366f1 !important;
  box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.35), 0 0 25px rgba(99, 102, 241, 0.6);
  animation: border-pulse-community-docs 2s ease-in-out infinite;
}

@keyframes border-pulse-community-docs {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.35), 0 0 15px rgba(99, 102, 241, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(99, 102, 241, 0.45), 0 0 10px rgba(99, 102, 241, 0.8);
  }
}

/* Cache Node - Teal/Cyan theme */
.flow-card-node[data-node-type='cache'] {
  border: 5px solid #5eead4;
  box-shadow: 2px 6px 6px rgba(20, 184, 166, 0.6);
}

.flow-card-node[data-node-type='cache']:hover {
  border-color: #2dd4bf;
}

.flow-card-node[data-node-type='cache'].active {
  border: 5px solid #14b8a6 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-cache 2s ease-in-out infinite;
}

@keyframes border-pulse-cache {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* Smart Intent Node - Indigo theme (matches FlowNode) */
.flow-card-node[data-node-type='smartIntent'] {
  border: 5px solid #6366f1;
  box-shadow: 2px 6px 6px rgba(79, 70, 229, 0.6);
}

.flow-card-node[data-node-type='smartIntent']:hover {
  border-color: #4f46e5;
}

.flow-card-node[data-node-type='smartIntent'].active {
  border: 5px solid #4f46e5 !important;
  box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 25px rgba(79, 70, 229, 0.6);
  animation: border-pulse-smartIntent 2s ease-in-out infinite;
}

@keyframes border-pulse-smartIntent {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(79, 70, 229, 0.35), 0 0 15px rgba(79, 70, 229, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(79, 70, 229, 0.45), 0 0 10px rgba(79, 70, 229, 0.8);
  }
}

/* Router Node - Green theme (same as Flow.vue) */
.flow-card-node[data-node-type='router'] {
  border: 5px solid #86efac;
  box-shadow: 2px 6px 6px rgba(34, 197, 94, 0.6);
}

.flow-card-node[data-node-type='router']:hover {
  border-color: #4ade80;
}

.flow-card-node[data-node-type='router'].active {
  border: 5px solid #22c55e !important;
  box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.35), 0 0 25px rgba(34, 197, 94, 0.6);
  animation: border-pulse-router 2s ease-in-out infinite;
}

@keyframes border-pulse-router {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0.35), 0 0 15px rgba(34, 197, 94, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(34, 197, 94, 0.45), 0 0 10px rgba(34, 197, 94, 0.8);
  }
}

/* Advanced Router Node - Purple theme (same as Flow.vue) */
.flow-card-node[data-node-type='advancedRouter'] {
  border: 5px solid #c4b5fd;
  box-shadow: 2px 6px 6px rgba(139, 92, 246, 0.6);
}

.flow-card-node[data-node-type='advancedRouter']:hover {
  border-color: #a78bfa;
}

.flow-card-node[data-node-type='advancedRouter'].active {
  border: 5px solid #8b5cf6 !important;
  box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 25px rgba(139, 92, 246, 0.6);
  animation: border-pulse-advancedRouter 2s ease-in-out infinite;
}

@keyframes border-pulse-advancedRouter {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 15px rgba(139, 92, 246, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(139, 92, 246, 0.45), 0 0 10px rgba(139, 92, 246, 0.8);
  }
}

/* Dynamic Router Node - Teal theme (same as FlowNode.vue) */
.flow-card-node[data-node-type='dynamicRouter'] {
  border: 5px solid #5eead4;
  box-shadow: 2px 6px 6px rgba(13, 148, 136, 0.6);
}

.flow-card-node[data-node-type='dynamicRouter']:hover {
  border-color: #2dd4bf;
}

.flow-card-node[data-node-type='dynamicRouter'].active {
  border: 5px solid #0d9488 !important;
  box-shadow: 0 0 0 8px rgba(13, 148, 136, 0.35), 0 0 25px rgba(13, 148, 136, 0.6);
  animation: border-pulse-dynamicRouter 2s ease-in-out infinite;
}

@keyframes border-pulse-dynamicRouter {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(13, 148, 136, 0.35), 0 0 15px rgba(13, 148, 136, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(13, 148, 136, 0.45), 0 0 10px rgba(13, 148, 136, 0.8);
  }
}

/* Orchestrator Node - Pink theme (same as FlowNode.vue) */
.flow-card-node[data-node-type='orchestrator'] {
  border: 5px solid #f9a8d4;
  box-shadow: 2px 6px 6px rgba(236, 72, 153, 0.6);
}

.flow-card-node[data-node-type='orchestrator']:hover {
  border-color: #ec4899;
}

.flow-card-node[data-node-type='orchestrator'].active {
  border: 5px solid #ec4899 !important;
  box-shadow: 0 0 0 8px rgba(236, 72, 153, 0.35), 0 0 25px rgba(236, 72, 153, 0.6);
  animation: border-pulse-orchestrator 2s ease-in-out infinite;
}

@keyframes border-pulse-orchestrator {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(236, 72, 153, 0.35), 0 0 15px rgba(236, 72, 153, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(236, 72, 153, 0.45), 0 0 10px rgba(236, 72, 153, 0.8);
  }
}

/* Guardrail Node - Rose theme */
.flow-card-node[data-node-type='guardrail'] {
  border: 5px solid #fda4af;
  box-shadow: 2px 6px 6px rgba(190, 24, 93, 0.6);
}

.flow-card-node[data-node-type='guardrail']:hover {
  border-color: #be185d;
}

.flow-card-node[data-node-type='guardrail'].active {
  border: 5px solid #be185d !important;
  box-shadow: 0 0 0 8px rgba(190, 24, 93, 0.35), 0 0 25px rgba(190, 24, 93, 0.6);
  animation: border-pulse-guardrail 2s ease-in-out infinite;
}

@keyframes border-pulse-guardrail {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(190, 24, 93, 0.35), 0 0 15px rgba(190, 24, 93, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(190, 24, 93, 0.45), 0 0 10px rgba(190, 24, 93, 0.8);
  }
}

/* Agent Tool - Yellow theme */
.flow-card-node[data-node-type='agent-tool'] {
  border: 5px solid #fde047;
  box-shadow: 2px 6px 6px rgba(245, 158, 11, 0.6);
}

.flow-card-node[data-node-type='agent-tool']:hover {
  border-color: #facc15;
}

.flow-card-node[data-node-type='agent-tool'].active {
  border: 5px solid #f59e0b !important;
  box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 25px rgba(245, 158, 11, 0.6);
  animation: border-pulse-agent-tool 2s ease-in-out infinite;
}

@keyframes border-pulse-agent-tool {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 15px rgba(245, 158, 11, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(245, 158, 11, 0.45), 0 0 10px rgba(245, 158, 11, 0.8);
  }
}

/* Agent Node - Teal theme (same as FlowNode.vue) */
.flow-card-node[data-node-type='agent'] {
  border: 5px solid #5eead4;
  box-shadow: 2px 6px 6px rgba(20, 184, 166, 0.6);
}

.flow-card-node[data-node-type='agent']:hover {
  border-color: #14b8a6;
}

.flow-card-node[data-node-type='agent'].active {
  border: 5px solid #14b8a6 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-agent 2s ease-in-out infinite;
}

@keyframes border-pulse-agent {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* Agent AI Model Node - Teal theme (same as agent node) */
.flow-card-node[data-node-type='agent-aimodel'] {
  border: 5px solid #5eead4;
  box-shadow: 2px 6px 6px rgba(20, 184, 166, 0.6);
}

.flow-card-node[data-node-type='agent-aimodel']:hover {
  border-color: #14b8a6;
}

.flow-card-node[data-node-type='agent-aimodel'].active {
  border: 5px solid #14b8a6 !important;
  box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 25px rgba(20, 184, 166, 0.6);
  animation: border-pulse-agent-aimodel 2s ease-in-out infinite;
}

@keyframes border-pulse-agent-aimodel {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(20, 184, 166, 0.35), 0 0 15px rgba(20, 184, 166, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(20, 184, 166, 0.45), 0 0 10px rgba(20, 184, 166, 0.8);
  }
}

/* Service Fallback Node - Warm Orange theme (fallback/recovery) */
.flow-card-node[data-node-type='serviceFallback'] {
  border: 5px solid #fb923c;
  box-shadow: 2px 6px 6px rgba(249, 115, 22, 0.6);
}

.flow-card-node[data-node-type='serviceFallback']:hover {
  border-color: #f97316;
}

.flow-card-node[data-node-type='serviceFallback'].active {
  border: 5px solid #f97316 !important;
  box-shadow: 0 0 0 8px rgba(249, 115, 22, 0.35), 0 0 25px rgba(249, 115, 22, 0.6);
  animation: border-pulse-serviceFallback 2s ease-in-out infinite;
}

@keyframes border-pulse-serviceFallback {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(249, 115, 22, 0.35), 0 0 15px rgba(249, 115, 22, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(249, 115, 22, 0.45), 0 0 10px rgba(249, 115, 22, 0.8);
  }
}

/* JSON Condition Node - Cyan theme (logic/condition) */
.flow-card-node[data-node-type='jsonCondition'] {
  border: 5px solid #22d3ee;
  box-shadow: 2px 6px 6px rgba(6, 182, 212, 0.6);
}

.flow-card-node[data-node-type='jsonCondition']:hover {
  border-color: #06b6d4;
}

.flow-card-node[data-node-type='jsonCondition'].active {
  border: 5px solid #06b6d4 !important;
  box-shadow: 0 0 0 8px rgba(6, 182, 212, 0.35), 0 0 25px rgba(6, 182, 212, 0.6);
  animation: border-pulse-jsonCondition 2s ease-in-out infinite;
}

@keyframes border-pulse-jsonCondition {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(6, 182, 212, 0.35), 0 0 15px rgba(6, 182, 212, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(6, 182, 212, 0.45), 0 0 10px rgba(6, 182, 212, 0.8);
  }
}

/* Node Header */
.node-header {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  background: transparent;
  border-bottom: none;
}

.node-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  flex-shrink: 0;
  background: #f3f4f6;
  color: #6b7280;
}

/* Node type-based icon colors */
.flow-node[data-node-type='messageInput'] .node-icon {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
}

.flow-node[data-node-type='intent'] .node-icon {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.25);
}

.flow-node[data-node-type='aiModel'] .node-icon {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
}

.flow-node[data-node-type='queryRewriter'] .node-icon {
  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(124, 58, 237, 0.3);
}

.flow-node[data-node-type='orchestrator'] .node-icon {
  background: linear-gradient(135deg, #ec4899 0%, #db2777 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(236, 72, 153, 0.3);
}

.flow-node[data-node-type='guardrail'] .node-icon {
  background: linear-gradient(135deg, #be185d 0%, #9d174d 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(190, 24, 93, 0.3);
}

.flow-node[data-node-type='agent-tool'] .node-icon {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.3);
}

.flow-node[data-node-type='agent'] .node-icon {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(20, 184, 166, 0.3);
}

.flow-node[data-node-type='agent-aimodel'] .node-icon {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  color: white;
  box-shadow: 0 2px 4px rgba(20, 184, 166, 0.3);
}

.flow-node[data-node-type='messageOutput'] .node-icon {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  color: white;
}

.node-info {
  flex: 1;
  min-width: 0;
}

.node-title {
  font-weight: 600;
  font-size: 11px;
  color: #51565f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  margin-bottom: 2px;
}

.node-subtitle {
  font-size: 9px;
  color: #6b7280;
  margin-top: 0;
  font-weight: 400;
}

.status-indicator {
  display: flex;
  align-items: center;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.8);
}

/* Node Time Info */
.node-time-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: rgba(0, 0, 0, 0.02);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  gap: 8px;
}

.node-time {
  display: flex;
  align-items: center;
  font-size: 9px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
}

.node-duration {
  display: flex;
  align-items: center;
  font-size: 9px;
  color: white;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.click-indicator {
  position: absolute;
  bottom: 4px;
  right: 4px;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.flow-node:hover .click-indicator {
  opacity: 1;
}

/* Connection Arrow */
.horizontal-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px 0px 20px;
  position: relative;
  flex-shrink: 0;
}

.arrow-with-time {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.gap-time-text {
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

/* Gap Time Breakdown Tooltip Styles */
.gap-breakdown {
  font-size: 11px;
  line-height: 1.6;
}

.gap-breakdown .gap-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 0;
}

.gap-breakdown .gap-value {
  font-weight: 600;
  color: #fcd34d;
}

/* Timing Breakdown Tooltip Styles */
.timing-breakdown {
  font-size: 11px;
  line-height: 1.6;
  min-width: 220px;
}

.timing-breakdown .breakdown-title {
  font-weight: 700;
  margin-bottom: 6px;
  color: #2196F3;
  font-size: 12px;
}

.timing-breakdown .breakdown-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.timing-breakdown .breakdown-item:last-child {
  border-bottom: none;
}

.timing-breakdown .breakdown-label {
  color: rgba(255, 255, 255, 0.9);
}

.timing-breakdown .breakdown-value {
  font-weight: 600;
  color: #64b5f6;
}


.arrow-icon {
  transition: all 0.3s ease;
  opacity: 0.7;
}

.arrow-icon:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* =============================================================================
   CARD STYLE NODES (Intent, Model, InterestOptimizer)
   Based on FlowNode.vue styling
   ============================================================================= */
.flow-card-node {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  height: 120px;
  min-height: 120px;
  max-height: 120px;
  min-width: 210px;
  max-width: 350px;
  width: fit-content;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.flow-card-node:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18);
}

.flow-card-node.active {
  transform: translateY(-4px) scale(1.02);
}

/* Action Type Badge for Cards */
.action-type-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.action-type-badge.main-action {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.action-type-badge.parallel-action {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

/* Sync Process Badge for Cards */
.sync-process-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  z-index: 2;
  background: linear-gradient(135deg, #2196F3, #1976D2);
  color: white;
  box-shadow: 0 1px 3px rgba(33, 150, 243, 0.4);
}

/* Action Type Badge for Regular Nodes */
.action-type-badge-node {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 5px;
  border-radius: 6px;
  font-size: 7px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  z-index: 2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.action-type-badge-node.main-action {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.action-type-badge-node.parallel-action {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  color: white;
}

/* Sync Process Badge for Regular Nodes */
.sync-process-badge-node {
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 2px 5px;
  border-radius: 6px;
  font-size: 7px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  z-index: 2;
  background: linear-gradient(135deg, #2196F3, #1976D2);
  color: white;
  box-shadow: 0 1px 2px rgba(33, 150, 243, 0.4);
}

/* Intent Card - Purple Theme */
.flow-card-node[data-node-type='intent'] {
  border: 5px solid #c0a4ff;
  box-shadow: 2px 6px 6px rgba(145, 27, 255, 0.699);
}

.flow-card-node[data-node-type='intent']:hover {
  border-color: #a984ff;
}

.flow-card-node[data-node-type='intent'].active {
  border: 5px solid #8b5cf6 !important;
  box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 25px rgba(139, 92, 246, 0.6);
  animation: border-pulse-intent 2s ease-in-out infinite;
}

@keyframes border-pulse-intent {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(139, 92, 246, 0.35), 0 0 15px rgba(139, 92, 246, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(139, 92, 246, 0.45), 0 0 10px rgba(139, 92, 246, 0.8);
  }
}

/* Intent Card - Purple Theme */
.flow-card-node[data-node-type='queryRewriter'] {
  border: 5px solid #a78bfa;
  box-shadow: 2px 6px 6px rgba(124, 58, 237, 0.699);
}

.flow-card-node[data-node-type='queryRewriter']:hover {
  border-color: #8b5cf6;
}

.flow-card-node[data-node-type='queryRewriter'].active {
  border: 5px solid #7c3aed !important;
  box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 25px rgba(124, 58, 237, 0.6);
  animation: border-pulse-queryRewriter 2s ease-in-out infinite;
}

@keyframes border-pulse-queryRewriter {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 15px rgba(124, 58, 237, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(124, 58, 237, 0.45), 0 0 10px rgba(124, 58, 237, 0.8);
  }
}

@keyframes border-pulse-queryrewriter {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(124, 58, 237, 0.35), 0 0 15px rgba(124, 58, 237, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(124, 58, 237, 0.45), 0 0 10px rgba(124, 58, 237, 0.8);
  }
}

/* Model Card - Blue Theme */
.flow-card-node[data-node-type='model'] {
  border: 5px solid #8bb8ff;
  box-shadow: 3px 5px 5px rgba(11, 68, 255, 0.7);
  background: rgba(255, 255, 255, 0.95);
}

.flow-card-node[data-node-type='model'].active {
  border: 5px solid #3b82f6 !important;
  box-shadow: 0 0 0 8px rgba(59, 130, 246, 0.35), 0 0 25px rgba(59, 130, 246, 0.6);
  animation: border-pulse-model 2s ease-in-out infinite;
}

@keyframes border-pulse-model {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(59, 130, 246, 0.35), 0 0 15px rgba(59, 130, 246, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0.45), 0 0 10px rgba(59, 130, 246, 0.8);
  }
}
.flow-card-node[data-node-type='model']:hover {
  border-color: #5f92ff;
}

/* Interest Optimizer Card - Amber Theme */
.flow-card-node[data-node-type='interestOptimizer'] {
  border: 5px solid #fbbf24;
  box-shadow: 2px 6px 6px rgba(245, 158, 11, 0.699);
}

.flow-card-node[data-node-type='interestOptimizer']:hover {
  border-color: #f59e0b;
}

.flow-card-node[data-node-type='interestOptimizer'].active {
  border: 5px solid #f59e0b !important;
  box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 25px rgba(245, 158, 11, 0.6);
  animation: border-pulse-optimizer 2s ease-in-out infinite;
}

@keyframes border-pulse-optimizer {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 15px rgba(245, 158, 11, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(245, 158, 11, 0.45), 0 0 10px rgba(245, 158, 11, 0.8);
  }
}

/* Interest Optimizer V2 Card - Amber Theme (same as V1) */
.flow-card-node[data-node-type='interestOptimizerV2'] {
  border: 5px solid #fbbf24;
  box-shadow: 2px 6px 6px rgba(245, 158, 11, 0.699);
}

.flow-card-node[data-node-type='interestOptimizerV2']:hover {
  border-color: #f59e0b;
}

.flow-card-node[data-node-type='interestOptimizerV2'].active {
  border: 5px solid #f59e0b !important;
  box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 25px rgba(245, 158, 11, 0.6);
  animation: border-pulse-optimizerv2 2s ease-in-out infinite;
}

@keyframes border-pulse-optimizerv2 {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(245, 158, 11, 0.35), 0 0 15px rgba(245, 158, 11, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(245, 158, 11, 0.45), 0 0 10px rgba(245, 158, 11, 0.8);
  }
}

/* ReformatForTTS Card - Pink/TTS Theme */
.flow-card-node[data-node-type='reformatForTTS'] {
  border: 5px solid #f9a8d4;
  box-shadow: 2px 6px 6px rgba(236, 72, 153, 0.699);
}

.flow-card-node[data-node-type='reformatForTTS']:hover {
  border-color: #f472b6;
}

.flow-card-node[data-node-type='reformatForTTS'].active {
  border: 5px solid #ec4899 !important;
  box-shadow: 0 0 0 8px rgba(236, 72, 153, 0.35), 0 0 25px rgba(236, 72, 153, 0.6);
  animation: border-pulse-reformatTTS 2s ease-in-out infinite;
}

@keyframes border-pulse-reformatTTS {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(236, 72, 153, 0.35), 0 0 15px rgba(236, 72, 153, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(236, 72, 153, 0.45), 0 0 10px rgba(236, 72, 153, 0.8);
  }
}

/* FormatForTTSEngine Card - Dark Pink/TTS Theme */
.flow-card-node[data-node-type='formatForTTSEngine'] {
  border: 5px solid #f472b6;
  box-shadow: 2px 6px 6px rgba(219, 39, 119, 0.699);
}

.flow-card-node[data-node-type='formatForTTSEngine']:hover {
  border-color: #ec4899;
}

.flow-card-node[data-node-type='formatForTTSEngine'].active {
  border: 5px solid #db2777 !important;
  box-shadow: 0 0 0 8px rgba(219, 39, 119, 0.35), 0 0 25px rgba(219, 39, 119, 0.6);
  animation: border-pulse-formatTTS 2s ease-in-out infinite;
}

@keyframes border-pulse-formatTTS {
  0%,
  100% {
    box-shadow: 0 0 0 8px rgba(219, 39, 119, 0.35), 0 0 15px rgba(219, 39, 119, 0.6);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(219, 39, 119, 0.45), 0 0 10px rgba(219, 39, 119, 0.8);
  }
}

/* Card Header Section */
.card-header-section {
  padding: 10px 12px 8px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  background: transparent;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: transparent;
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.card-info {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
  margin-bottom: 2px;
  word-break: break-word;
  overflow: visible;
}

.card-subtitle {
  font-size: 10px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Card Time Info */
.card-time-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.02);
  gap: 8px;
  flex-wrap: wrap;
  min-height: 40px;
}

.card-time {
  display: flex;
  align-items: center;
  font-size: 9px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 400;
}

.card-duration {
  display: flex;
  align-items: center;
  font-size: 9px;
  color: white;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-duration-flex {
  white-space: nowrap;
  overflow: visible;
  max-width: fit-content;
  flex-shrink: 0;
}

/* =============================================================================
   END CARD STYLE NODES
   ============================================================================= */

/* Step Details Panel */
.step-details-panel {
  margin-top: 20px;
  padding-top: 20px;
  width: 100%;
  overflow: visible;
  flex-shrink: 0;
}

/* Instruction Panel */
.instruction-panel {
  margin-top: 20px;
  padding-top: 20px;
  overflow: visible;
  flex-shrink: 0;
}

.instruction-card {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.02), rgba(25, 118, 210, 0.05)) !important;
  border: 2px dashed rgba(25, 118, 210, 0.3) !important;
  animation: fadeInUp 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: top center;
}

.instruction-icon-wrapper {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.instruction-icon {
  opacity: 0.8;
}

.instruction-title {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 600;
  font-size: 1.5rem;
}

.instruction-subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1rem;
  line-height: 1.5;
}

.instruction-hints {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}

.details-card {
  animation: fadeInUp 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: top center;
  max-height: none;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Smooth transition for details panel */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-fade-leave-active {
  transition: none; /* Instant fade out */
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-15px) scale(0.98);
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-15px) scale(0.98);
}

.details-json {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
  font-size: 11px;
  line-height: 1.4;
  max-height: 300px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Courier New', monospace;
}

/* trace ของ agent ยาวกว่า details-json ปกติ (มีรายการ query + sources) — ให้พื้นที่มากขึ้นแต่ยัง scroll ในกล่องตัวเอง */
.agent-process-trace {
  max-height: 420px;
  user-select: text;
}

.agent-trace-link {
  color: #0d9488;
  text-decoration: underline;
  word-break: break-all;
}

.agent-trace-link:hover {
  color: #0f766e;
}

.timing-details {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.timing-compact {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 6px;
}

.timing-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.timing-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.timing-value {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.87);
}

.duration-badge-compact {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: white;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.duration-label-compact {
  font-size: 9px;
  opacity: 0.9;
}

.duration-badge-inline {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  color: white;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.timing-details > div {
  margin-bottom: 4px;
  font-size: 12px;
}

/* Log References Section */
.log-refs-table-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.log-refs-table {
  font-size: 12px;
}

.log-refs-table thead tr th {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.08), rgba(25, 118, 210, 0.12)) !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  padding: 8px 12px !important;
  border-bottom: 2px solid rgba(25, 118, 210, 0.3) !important;
}

.log-refs-table tbody tr.log-ref-row {
  transition: background-color 0.2s ease;
}

.log-refs-table tbody tr.log-ref-row:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
}

.log-refs-table tbody tr td {
  padding: 10px 12px !important;
  font-size: 11px !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

.token-info {
  display: flex;
  justify-content: center;
}

.ref-detail-grid {
  display: grid;
  gap: 12px;
  padding: 8px;
}

.detail-section {
  padding: 8px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 6px;
  font-size: 11px;
}

.detail-section strong {
  display: block;
  margin-bottom: 6px;
  color: rgba(0, 0, 0, 0.7);
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-code {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px;
  font-size: 10px;
  line-height: 1.4;
  max-height: 150px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Courier New', monospace;
  margin-top: 4px;
}

.log-refs-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 8px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.log-refs-ids {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

.error-message {
  background: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 8px;
  color: #d32f2f;
  font-size: 13px;
  display: flex;
  align-items: center;
}

/* Scrollbar for horizontal flow */
.horizontal-flow-steps::-webkit-scrollbar {
  height: 6px;
}

.horizontal-flow-steps::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.horizontal-flow-steps::-webkit-scrollbar-thumb {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.horizontal-flow-steps::-webkit-scrollbar-thumb:hover {
  background: rgba(25, 118, 210, 0.5);
}

/* Responsive Design */
@media (max-width: 768px) {
  .horizontal-flow-steps {
    padding: 16px 0;
    gap: 12px;
  }

  /* Checkpoint Responsive */
  .checkpoint-node {
    min-width: 70px;
    max-width: 100px;
    padding: 6px;
  }

  .checkpoint-icon {
    width: 32px;
    height: 32px;
    margin-bottom: 6px;
  }

  .checkpoint-icon::before {
    width: 40px;
    height: 40px;
    top: -4px;
    left: -4px;
  }

  .checkpoint-label {
    font-size: 10px;
    margin-bottom: 3px;
  }

  .checkpoint-time {
    font-size: 8px;
  }

  /* Flow Node Responsive */
  .flow-node {
    min-width: 140px;
    max-width: 160px;
  }

  .node-header {
    padding: 8px 10px 6px 10px;
  }

  .node-content {
    padding: 0 10px 8px 10px;
  }

  .node-icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }

  .node-title {
    font-size: 11px;
  }

  .node-subtitle {
    font-size: 9px;
  }

  .time-label {
    font-size: 9px;
  }

  .duration-badge {
    font-size: 8px;
    padding: 1px 4px;
  }

  .log-count {
    font-size: 8px;
    padding: 1px 4px;
  }
}

/* Enhanced Dialog Styling */
.flow-dialog-card {
  border-radius: 22px !important;
  overflow: hidden;
  will-change: transform, opacity;
}

/* Optimize dialog transitions */
.v-dialog {
  will-change: transform, opacity;
}

.v-dialog--active {
  animation: dialogFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.flow-dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

.flow-dialog-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.7;
  }
}

.flow-header-content {
  position: relative;
  z-index: 1;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.flow-icon-wrapper {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  margin-right: 20px;
}

.flow-icon-wrapper:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.flow-icon-wrapper i {
  font-size: 28px;
  color: white;
}

.flow-header-text {
  flex: 1;
}

.flow-title {
  font-size: 24px;
  font-weight: 600;
  color: white;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.flow-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin: 4px 0 0 0;
  font-weight: 400;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
}

.close-btn i {
  color: white !important;
}

.flow-dialog-content {
  background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
  height: 70vh;
  min-height: 70vh;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  will-change: scroll-position;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.horizontal-flow-container {
  padding: 32px 24px;
  background: transparent;
  contain: layout style paint;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

/* Scrollbar Styling */
.flow-dialog-content::-webkit-scrollbar {
  width: 8px;
}

.flow-dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.flow-dialog-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

.flow-dialog-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
}

/* =============================================================================
   MONITOR DIALOG STYLES
   ============================================================================= */
.monitor-content {
  padding: 8px 0;
}

.monitor-section {
  margin-bottom: 20px;
}

.monitor-section:last-child {
  margin-bottom: 0;
}

.monitor-textarea {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
}

.monitor-textarea :deep(.v-field__input) {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.5;
  color: #333;
}

.monitor-textarea :deep(textarea) {
  font-family: 'Courier New', monospace !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
}

.monitor-json {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
  font-size: 11px;
  line-height: 1.5;
  max-height: 400px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Courier New', monospace;
  color: #333;
}

.monitor-json::-webkit-scrollbar {
  width: 6px;
}

.monitor-json::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.monitor-json::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.monitor-json::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Log Textarea Styles - Similar to Stream.vue */
.Log_text_textarea :deep(.v-field__input) {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  color: #2c3e50;
  padding: 8px;
}

.Log_text_textarea :deep(textarea) {
  font-family: 'Courier New', monospace !important;
  font-size: 12px !important;
  line-height: 1.6 !important;
  color: #2c3e50 !important;
}

.Log_text_textarea :deep(.v-field) {
  background-color: #f8f9fa;
  border-radius: 6px;
}

.Log_text_textarea :deep(.v-field--focused) {
  background-color: #ffffff;
}

.Log_text_textarea :deep(.v-field__input) {
  -webkit-mask-image: none !important;
  mask-image: none !important;
}

/* Monitor Dialog Styles */
.monitor-panels {
  margin-top: 16px;
}

.monitor-panels :deep(.v-expansion-panel) {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
}

.monitor-panels :deep(.v-expansion-panel-title) {
  font-weight: 600;
  font-size: 14px;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-label {
  font-size: 11px;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 8px;
}

.info-card {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
}

.param-label {
  font-size: 11px;
  color: #666;
  margin-bottom: 2px;
}

.param-value {
  font-size: 12px;
  font-weight: 500;
  color: #2c3e50;
}

/* =============================================================================
   PROFESSIONAL TOAST NOTIFICATION
   ============================================================================= */
:deep(.professional-toast) {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05) !important;
  backdrop-filter: blur(10px);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  padding: 8px 12px !important;
  min-height: auto !important;
}

:deep(.professional-toast .swal2-title) {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  margin-bottom: 2px !important;
  line-height: 1.2 !important;
}

:deep(.professional-toast .swal2-html-container) {
  font-size: 11px !important;
  color: #64748b !important;
  margin: 0 !important;
  font-weight: 400 !important;
  line-height: 1.3 !important;
}

:deep(.professional-toast .swal2-icon) {
  width: 24px !important;
  height: 24px !important;
  margin: 0 10px 0 0 !important;
  border-width: 2px !important;
}

:deep(.professional-toast .swal2-icon.swal2-success) {
  border-color: #10b981 !important;
}

:deep(.professional-toast .swal2-success-ring) {
  border: 2px solid rgba(16, 185, 129, 0.3) !important;
}

:deep(.professional-toast .swal2-success-line-tip),
:deep(.professional-toast .swal2-success-line-long) {
  background-color: #10b981 !important;
}

/* Remove default animation */
:deep(.swal2-noanimation) {
  animation: slideInRight 0.2s ease-out !important;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.tool-type-header {
  display: flex;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.tool-type-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.tool-details-wrapper {
  margin-top: 12px;
}

.tool-section {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 8px;
}

.tool-section-header {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tool-section-header.api-header {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: white;
}

.tool-section-header.master-header {
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
}

.tool-section-header.master-header-light {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #374151;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.tool-section-content {
  padding: 14px;
}

.tool-info-item {
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.tool-info-label {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tool-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  word-break: break-word;
}

.tool-description {
  font-size: 13px;
  color: #475569;
  line-height: 1.6;
  background: #f8fafc;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.endpoint-code {
  font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
  font-size: 12px;
  color: #0f172a;
  background: #f1f5f9;
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  word-break: break-all;
  flex: 1;
}

.tool-json-display {
  background: transparent;
  color: #1e293b;
  font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
  font-size: 11px;
  line-height: 1.5;
  padding: 14px;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  border-radius: 0 0 10px 10px;
}

.tool-json-display::-webkit-scrollbar {
  width: 6px;
}

.tool-json-display::-webkit-scrollbar-track {
  background: #334155;
  border-radius: 3px;
}

.tool-json-display::-webkit-scrollbar-thumb {
  background: #64748b;
  border-radius: 3px;
}
.tool-section-header.text-info-header {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.text-info-display {
  background: #f8fafc;
  color: #1e293b;
  font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  padding: 16px;
  margin: 0;
  max-height: 300px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  border: 1px solid #e2e8f0;
  border-top: none;
  border-radius: 0 0 10px 10px;
}

.text-info-display::-webkit-scrollbar {
  width: 6px;
}

.text-info-display::-webkit-scrollbar-track {
  background: #e2e8f0;
  border-radius: 3px;
}

.text-info-display::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 3px;
}

.headers-list {
  background: #ffffff;
  border-radius: 0 0 10px 10px;
  overflow: hidden;
}

.header-item {
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  min-height: 48px;
}

.header-item:last-child {
  border-bottom: none;
}

.header-item:hover {
  background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, rgba(14, 165, 233, 0.04) 100%);
}

.header-key {
  display: flex;
  align-items: center;
  min-width: 160px;
  max-width: 200px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  border-right: 2px solid #e2e8f0;
  font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
  letter-spacing: 0.3px;
}

.header-key .v-icon {
  opacity: 0.7;
}

.header-value {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 12px;
  color: #1e293b;
  word-break: break-all;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'JetBrains Mono', 'Fira Code', 'Courier New', monospace;
  background: #ffffff;
  position: relative;
}

.header-value:hover {
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.06) 0%, rgba(59, 130, 246, 0.02) 100%);
}

.header-value::after {
  content: 'Click to copy';
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 9px;
  color: #94a3b8;
  opacity: 0;
  transition: opacity 0.2s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.header-value:hover::after {
  opacity: 1;
}

.header-value .copy-icon-inline {
  opacity: 0;
  transition: all 0.2s ease;
  color: #3b82f6;
  flex-shrink: 0;
}

.header-value:hover .copy-icon-inline {
  opacity: 1;
  transform: scale(1.1);
}

/* Responsive headers */
@media (max-width: 600px) {
  .header-item {
    flex-direction: column;
    min-height: auto;
  }
  
  .header-key {
    min-width: 100%;
    max-width: 100%;
    border-right: none;
    border-bottom: 1px dashed #e2e8f0;
    padding: 10px 14px;
    font-size: 11px;
  }
  
  .header-value {
    padding: 10px 14px;
    font-size: 11px;
  }
  
  .header-value::after {
    display: none;
  }
}

/* =============================================================================
   TAX PLANNING · PROCESS STEPS (inline summary + timeline dialog)
   ============================================================================= */
/* Dialog shell — matches the app's .flow-dialog-card convention (22px + clipped
   corners so the gradient header follows the radius) */
.process-dialog-card {
  border-radius: 22px !important;
  overflow: hidden;
}

.process-dialog-header {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  color: #fff;
}

.process-summary {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #f6fbf8;
  border: 1px solid #e3f3ea;
  border-radius: 12px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.process-summary:hover {
  border-color: #bbf7d0;
  box-shadow: 0 2px 10px rgba(34, 197, 94, 0.12);
}

.process-summary-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  box-shadow: 0 2px 6px rgba(21, 128, 61, 0.3);
  flex-shrink: 0;
}

.process-summary-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.process-summary-label {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.3;
}

.process-summary-caption {
  font-size: 12px;
  color: #475569;
}

.process-timeline {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.process-step {
  display: flex;
  gap: 12px;
}

.process-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.process-dot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #64748b;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.process-step:hover .process-dot {
  transform: scale(1.08);
}

.process-step:not(:last-child) .process-rail::after {
  content: '';
  flex: 1 0 auto;
  width: 2px;
  min-height: 14px;
  margin: 2px 0;
  background: #e2e8f0;
  transition: background 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.process-body {
  flex: 1;
  min-width: 0;
  padding-bottom: 14px;
}

.process-step-index {
  font-size: 11px;
  color: #64748b;
}

.process-title {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  line-height: 1.4;
  word-break: break-word;
}

.process-note {
  font-size: 13px;
  color: #475569;
  margin-top: 2px;
  padding-left: 10px;
  border-left: 2px solid #cbd5e1;
  word-break: break-word;
}

.process-step[data-kind='answer'] .process-dot,
.process-step[data-kind='done'] .process-dot,
.process-step[data-kind='start'] .process-dot {
  background: linear-gradient(135deg, #22c55e, #16a34a);
}

.process-step[data-kind='question'] .process-dot {
  background: #3b82f6;
}

.process-step[data-kind='llm'] .process-dot {
  background: #8b5cf6;
}

.process-step[data-kind='skip'] .process-dot {
  background: #9ca3af;
}

.process-step[data-kind='error'] .process-dot {
  background: #ef4444;
}

.process-step[data-kind='info'] .process-dot,
.process-step[data-kind='plain'] .process-dot {
  background: #64748b;
}

/* Step head row: kind chip + step index + optional timestamp */
.process-step-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 3px;
}

/* Kind chip — self-labels each step so the colour code needs no separate legend */
.process-chip {
  display: inline-flex;
  align-items: center;
  height: 19px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
  white-space: nowrap;
  background: #f1f5f9;
  color: #475569;
}

.process-chip[data-kind='answer'],
.process-chip[data-kind='done'],
.process-chip[data-kind='start'] {
  background: #dcfce7;
  color: #15803d;
}

.process-chip[data-kind='question'] {
  background: #dbeafe;
  color: #1d4ed8;
}

.process-chip[data-kind='llm'] {
  background: #ede9fe;
  color: #6d28d9;
}

.process-chip[data-kind='error'] {
  background: #fee2e2;
  color: #b91c1c;
}

/* Optional per-step timestamp — rendered only when the trace supplies one */
.process-step-time {
  padding: 0 6px;
  border-radius: 5px;
  background: #f1f5f9;
  color: #475569;
  font-size: 10.5px;
  font-variant-numeric: tabular-nums;
}

/* Empty state that explains why there are no steps */
.process-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  text-align: center;
}

.process-empty-title {
  font-size: 15px;
  font-weight: 600;
  color: #475569;
}

.process-empty-hint {
  font-size: 13px;
  color: #64748b;
  max-width: 340px;
}

/* =============================================================================
   OUTCOME BANNER — status + progress, answered in one glance
   ============================================================================= */
.process-outcome {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  margin-bottom: 18px;
  border-radius: 14px;
  border: 1px solid transparent;
}

.process-outcome-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  flex-shrink: 0;
}

.process-outcome-main {
  min-width: 0;
  flex: 1 1 auto;
}

.process-outcome-label {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
}

.process-outcome-meta {
  font-size: 12.5px;
  color: #475569;
  margin-top: 1px;
}

.process-outcome-progress {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 1 190px;
  min-width: 130px;
}

.process-outcome-bar {
  flex: 1 1 auto;
}

.process-outcome-percent {
  min-width: 34px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* Status variants — full borders + tinted surfaces, never a side stripe */
.process-outcome[data-status='completed'] {
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.process-outcome[data-status='completed'] .process-outcome-icon {
  background: #dcfce7;
  color: #15803d;
}
.process-outcome[data-status='completed'] .process-outcome-label {
  color: #15803d;
}

.process-outcome[data-status='error'] {
  background: #fef2f2;
  border-color: #fecaca;
}
.process-outcome[data-status='error'] .process-outcome-icon {
  background: #fee2e2;
  color: #b91c1c;
}
.process-outcome[data-status='error'] .process-outcome-label {
  color: #b91c1c;
}

.process-outcome[data-status='incomplete'] {
  background: #eff6ff;
  border-color: #bfdbfe;
}
.process-outcome[data-status='incomplete'] .process-outcome-icon {
  background: #dbeafe;
  color: #1d4ed8;
}
.process-outcome[data-status='incomplete'] .process-outcome-label {
  color: #1d4ed8;
}

@media (max-width: 520px) {
  .process-outcome {
    flex-wrap: wrap;
  }
  .process-outcome-progress {
    flex-basis: 100%;
  }
}

/* Emphasised terminal step — the conclusion of the trace */
.process-step.is-outcome .process-body {
  padding: 8px 12px 10px;
  margin-bottom: 4px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.process-step.is-outcome[data-kind='error'] .process-body {
  background: #fef2f2;
  border-color: #fecaca;
}
.process-step.is-outcome .process-title {
  font-weight: 600;
}

/* Motion — steps reveal in sequence; conveys "this ran step by step" */
.process-step {
  animation: processStepReveal 0.34s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(var(--reveal-i, 0) * 45ms);
}

@keyframes processStepReveal {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .process-step {
    animation: none;
  }
}
</style>
